// the Studio's texts (descriptions, bios, credentials, quotes) in the page's
// language, before anything draws them (snippets/ayasa-i18n.liquid)
if (typeof window.AYASA_translateData === "function") {
  window.AYASA_translateData({
    MODELS: typeof MODELS !== "undefined" ? MODELS : null,
    ARTISTS: typeof ARTISTS !== "undefined" ? ARTISTS : null,
    PLAYERS: typeof PLAYERS !== "undefined" ? PLAYERS : null
  });
}

// Elements are off the site until the line launches (Roy, 08-10). The switch is
// the Studio's page editor, homepage, "Show the Elements line"
// (AYASA_CFG.homeBands.elements); its preview may try the other setting before it
// is saved (AYASA_PREVIEW_ELEMENTS). Off, they are taken out of MODELS here, first
// thing, so no page draws them: the homepage's Instruments section, the shop page,
// the rails; and <html> carries .no-elements for the shop's product-line filter.
// MODELS is Studio's (ayasa-data.js, which loads before this file) and stays
// untouched there. Where the line is talked about (the handpans guide, the FAQ
// page, the homepage's Buying and FAQ) its name is followed by "(coming soon)": in a heading
// or question at every mention, in running text once per answer or part. The
// texts themselves stay clean, so switching the line on takes it all away.
(() => {
  const cfg = typeof AYASA_CFG !== "undefined" && AYASA_CFG && AYASA_CFG.homeBands;
  const on = typeof window.AYASA_PREVIEW_ELEMENTS === "boolean" ? window.AYASA_PREVIEW_ELEMENTS : !!(cfg && cfg.elements === true);
  if (on) return;
  document.documentElement.classList.add("no-elements");
  if (typeof MODELS !== "undefined" && Array.isArray(MODELS)) {
    for (let i = MODELS.length - 1; i >= 0; i--) if (MODELS[i] && MODELS[i].range === "elements") MODELS.splice(i, 1);
  }
  const NAME = /\b(?:Ayasa )?Elements\b/g;
  const soon = () => Object.assign(document.createElement("span"), { className: "soon", textContent: " " + AYASA_t("js.core.coming_soon_note") });
  // "(coming soon)" after the first `limit` mentions in this heading or text
  const mark = (unit, limit) => {
    const walker = document.createTreeWalker(unit, NodeFilter.SHOW_TEXT);
    const texts = [];
    for (let t; (t = walker.nextNode()); ) if (!t.parentElement.closest(".soon, script, style")) texts.push(t);
    let left = limit;
    for (const t of texts) {
      if (left <= 0) break;
      NAME.lastIndex = 0;
      let node = t, m;
      while (left > 0 && (m = NAME.exec(node.data))) {
        const rest = node.splitText(m.index + m[0].length);
        // a linked name keeps its link whole: the words follow the link
        const link = node.parentElement.closest("a");
        if (link && unit.contains(link)) link.after(soon()); else node.after(soon());
        left--; node = rest; NAME.lastIndex = 0;
      }
    }
  };
  const run = () => {
    for (const scope of document.querySelectorAll(".guide-page, .faq-page, #faq, #buying")) {
      scope.querySelectorAll("h1, h2, h3, summary").forEach(h => mark(h, Infinity));
      scope.querySelectorAll(".guide-text, .faq-answer, .faqp-answer, .fact").forEach(t => mark(t, 1));
    }
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run); else run();
})();

function initPlayerPurchaseOptions(root, error) {
  const byId = id => root.querySelector("#" + id);
  const caseSelect = byId("caseSelect");
  // visual case picker drives the hidden select; a select-style trigger drops it down
  const picker = byId("casePicker");
  const caseTrigger = byId("caseTrigger");
  const pickerWrap = byId("casePickerWrap");
  // desktop: once an options panel has finished expanding, park Add to cart at
  // the bottom edge so the new choices fill the space above it. Waiting for the
  // expansion matters — the button's final position isn't known at click time.
  function frameBuyRow(wrap) {
    if (root !== document) return;
    let done = false;
    const go = () => {
      if (done) return;
      done = true;
      const row = document.querySelector(".buy-row");
      if (!row) return;
      // computed, not scrollIntoView: that refuses to move when the element is
      // already on screen, so on a tall display nothing would happen
      const target = row.getBoundingClientRect().bottom + scrollY - innerHeight + 12;
      scrollTo({ top: Math.max(0, target), behavior: "smooth" });
    };
    wrap?.addEventListener("transitionend", go, { once: true });
    setTimeout(go, 340);
  }

  const openPicker = open => {
    if (!pickerWrap) return;
    pickerWrap.classList.toggle("open", open);
    caseTrigger.setAttribute("aria-expanded", open);
    if (!open) return; // closing never scrolls
    // phone: lift the "Handpan case" label to just under the fixed header so
    // all nine cases open into view. The label's position doesn't depend on the
    // picker's height, so this can run alongside the expansion.
    if (matchMedia("(max-width: 900px)").matches) {
      caseTrigger.closest(".product-option")
        ?.scrollIntoView({ block: "start", behavior: "smooth" });
    } else {
      frameBuyRow(pickerWrap);
    }
  };
  if (picker && caseSelect) {
    const family = byId("evatekFamily");
    const colors = byId("evatekColors");
    const showColors = open => {
      if (!family || !colors) return;
      family.setAttribute("aria-expanded", String(open));
      colors.hidden = !open;
    };
    const syncPicker = () => {
      let chosen = null;
      picker.querySelectorAll(".case-card[data-variant]").forEach(b => {
        const on = b.dataset.variant === caseSelect.value;
        b.classList.toggle("on", on);
        b.setAttribute("aria-pressed", String(on));
        if (on) chosen = b;
      });
      const isEvatek = !!chosen && !!colors?.contains(chosen);
      family?.classList.toggle("on", isEvatek);
      if (!isEvatek) showColors(false);
      const label = caseTrigger.querySelector(".case-trigger-label");
      label.replaceChildren();
      if (chosen) {
        const img = chosen.querySelector("img");
        if (img) {
          const thumb = document.createElement("img");
          thumb.src = img.currentSrc || img.src;
          thumb.alt = "";
          label.append(thumb);
        }
        const text = document.createElement("span");
        text.textContent = `${isEvatek ? "HCT Evatek · " : ""}${chosen.querySelector(".case-name").textContent} — ${chosen.querySelector(".case-price").textContent}`;
        label.append(text);
      } else {
        label.textContent = AYASA_t("js.core.choose_case_placeholder");
      }
    };
    caseTrigger.addEventListener("click", () => openPicker(!pickerWrap.classList.contains("open")));
    picker.addEventListener("click", e => {
      const card = e.target.closest(".case-card");
      if (!card || !picker.contains(card) || card.disabled) return;
      if (card === family) {
        showColors(colors.hidden);
        return;
      }
      const option = Array.from(caseSelect.options).find(o => o.value === card.dataset.variant);
      if (!option || option.disabled) return;
      caseSelect.value = card.dataset.variant;
      caseSelect.dispatchEvent(new Event("change", { bubbles: true }));
      if (error) error.hidden = true;
      openPicker(false);
      if (matchMedia("(max-width: 900px)").matches) {
        root.dispatchEvent(new CustomEvent("ayasa:open-shirt"));
      }
    });
    picker.addEventListener("keydown", e => {
      if (e.key === "Escape" && colors && !colors.hidden) {
        showColors(false);
        family.focus();
        e.stopPropagation();
      }
    });
    caseSelect.addEventListener("change", syncPicker);
    syncPicker();
  }


  // Free t-shirt: colour tiles, then size chips. Both drive the hidden selects
  // that the cart (and the lightbox buy bar) already read, so nothing
  // downstream changes. Sizes appear only once a colour is chosen, and the
  // "no t-shirt" tile skips them entirely.
  const shirtPicker = byId("shirtPicker");
  const shirtSizes = byId("shirtSizes");
  const sizeChips = byId("sizeChips");
  const shirtSize = byId("shirtSize");
  const shirtColor = byId("shirtColor");
  const shirtTrigger = byId("shirtTrigger");
  const shirtWrap = byId("shirtPickerWrap");
  if (shirtPicker && sizeChips && shirtSize && shirtColor) {
    // chips from the select's own options — one source of truth for the strings
    const SHORT = { "Extra Small": "XS", Small: "S", Medium: "M", Large: "L" };
    const abbr = s => SHORT[s] || s; // XL / XXL / XXXL already read fine
    sizeChips.innerHTML = [...shirtSize.options]
      .filter(o => o.value && o.value !== "No free t-shirt")
      .map(o => {
        const [eu, us] = o.value.split(" / ");
        return `<button type="button" class="size-chip" data-value="${o.value}" aria-pressed="false">
            <strong>${abbr(eu.replace(/^EU /, ""))}</strong>
            <span>${us ? "US " + abbr(us.replace(/^US /, "")) : ""}</span>
          </button>`;
      }).join("");

    // phone: once the t-shirt is answered, park Add to cart at the bottom edge
    // — the size chips sit right above it, so the next step frames itself
    const parkBuyRow = () => {
      if (root !== document) return;
      if (!matchMedia("(max-width: 900px)").matches) return;
      const row = document.querySelector(".buy-row");
      if (!row) return;
      const target = row.getBoundingClientRect().bottom + scrollY - innerHeight + 12;
      scrollTo({ top: Math.max(0, target), behavior: "smooth" });
    };
    const openShirt = (open, scroll = true) => {
      if (!shirtWrap || !shirtTrigger) return;
      shirtWrap.classList.toggle("open", open);
      shirtTrigger.setAttribute("aria-expanded", open);
      if (!open || !scroll) return; // closing, or the case step's silent handover
      if (matchMedia("(max-width: 900px)").matches) {
        byId("shirtOption")
          ?.scrollIntoView({ block: "start", behavior: "smooth" });
      } else {
        frameBuyRow(shirtWrap); // desktop: Add to cart to the bottom edge
      }
    };
    // the case step hands over: open without scrolling, it does its own
    root.addEventListener("ayasa:open-shirt", () => openShirt(true, false));
    const syncShirt = () => {
      const color = shirtColor.dataset.chosen || "";
      const none = shirtSize.value === "No free t-shirt";
      let chosen = null;
      shirtPicker.querySelectorAll(".shirt-card").forEach(b => {
        // !!color guards the none tile, whose data-color is also empty
        const on = none ? b.classList.contains("shirt-none") : !!color && b.dataset.color === color;
        b.classList.toggle("on", on);
        b.setAttribute("aria-pressed", on);
        if (on) chosen = b;
      });
      sizeChips.querySelectorAll(".size-chip").forEach(c => {
        const on = c.dataset.value === shirtSize.value;
        c.classList.toggle("on", on);
        c.setAttribute("aria-pressed", on);
      });
      // the trigger carries the answer once there is one, like the case picker
      const label = byId("shirtTriggerLabel");
      if (label) {
        if (none) label.textContent = AYASA_t("js.core.no_tshirt_thanks");
        else if (chosen) {
          const img = chosen.querySelector("img");
          // the tile's own name is in the page's language; the colour value stays English for Flow
          const name = chosen.querySelector(".shirt-name")?.textContent || color;
          label.innerHTML = img ? `<img src="${img.currentSrc || img.src}" alt="">` : "";
          label.append(Object.assign(document.createElement("span"), { textContent: name }));
        } else label.textContent = AYASA_t("js.core.choose_tshirt_placeholder");
      }
      // sizes are visible from the start so the whole t-shirt decision sits on
      // one screen; only declining removes them
      shirtSizes.hidden = none;
    };

    shirtPicker.addEventListener("click", e => {
      const card = e.target.closest(".shirt-card");
      if (!card) return;
      if (card.classList.contains("shirt-none")) {
        shirtColor.dataset.chosen = "";
        shirtSize.value = "No free t-shirt";
        syncShirt();
      } else {
        shirtColor.value = card.dataset.color;
        shirtColor.dataset.chosen = card.dataset.color;
        if (shirtSize.value === "No free t-shirt") shirtSize.value = "";
        syncShirt();
      }
      // fold the tiles away once chosen, on every screen (Roy, 29-09: phones
      // too; they used to stay open there) — the trigger carries the answer,
      // and the size chips below stay put
      openShirt(false);
      // phone: then park Add to cart at the bottom edge. The fold (0.3s, and
      // the "no t-shirt" tile also drops the sizes) moves where the button
      // ends up, so measure once it has settled
      setTimeout(parkBuyRow, 340);
      if (error) error.hidden = true;
    });
    shirtTrigger?.addEventListener("click", () => openShirt(!shirtWrap.classList.contains("open")));
    sizeChips.addEventListener("click", e => {
      const chip = e.target.closest(".size-chip");
      if (!chip) return;
      shirtSize.value = chip.dataset.value;
      syncShirt();
      if (error) error.hidden = true;
      // no scroll here: the button was parked when the colour was chosen
    });
    syncShirt();
  }

  return { openPicker, caseTrigger };
}

// ============================================================
// AYASA — rendering & interactions
// ============================================================

// ---------- note-map SVG (ding centre, topside notes in a circle) ----------
function noteMapSVG(model) {
  const size = 120, c = size / 2, ringR = 44, noteR = 11, dingR = 17;
  const notes = model.top || [];
  let circles = "";
  notes.forEach((n, i) => {
    const a = -Math.PI / 2 + (i * 2 * Math.PI) / notes.length;
    const x = c + ringR * Math.cos(a), y = c + ringR * Math.sin(a);
    circles += `
      <circle cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" r="${noteR}" fill="#1b1e25" stroke="rgba(236,233,226,0.22)"/>
      <text x="${x.toFixed(1)}" y="${(y + 2.6).toFixed(1)}" text-anchor="middle" font-size="6.6" fill="#ece9e2" font-family="Inter, sans-serif">${n}</text>`;
  });
  return `
  <svg viewBox="0 0 ${size} ${size}" width="118" height="118" role="img" aria-label="${AYASA_t("js.core.note_layout_label", { name: model.name, ding: model.ding, notes: notes.join(", ") })}">
    <circle cx="${c}" cy="${c}" r="${c - 2}" fill="none" stroke="rgba(236,233,226,0.08)"/>
    <circle cx="${c}" cy="${c}" r="${dingR}" fill="#1b1e25" stroke="#657599" stroke-width="1.2"/>
    <text x="${c}" y="${c + 3}" text-anchor="middle" font-size="8.6" fill="#8b98b8" font-family="Inter, sans-serif" font-weight="600">${model.ding}</text>
    ${circles}
  </svg>`;
}

// ---------- model cards ----------
function modelCard(m) {
  const badgeClass = m.inStock ? "badge-stock" : "badge-order";
  const bottom = m.bottom && m.bottom.length
    ? `<b>${AYASA_t("js.core.bottom_count", { n: m.bottom.length })}</b> ${m.bottom.join(" ")}`
    : AYASA_t("js.core.topside_only");
  // cards with a shop destination are fully clickable (stretched link);
  // RRP-only (UK dealer) and parked (no product yet) cards get neither
  const linked = !m.rrp && m.productHandle;
  const priceOrLink = m.rrp
    ? `<span class="model-price">${AYASA_t("js.core.rrp", { price: m.rrp })}</span>`
    : m.productHandle
      ? `<a class="model-link" href="/products/${m.productHandle}" aria-label="${AYASA_t("js.core.view_name_in_shop", { name: m.name })}">${AYASA_t("js.core.view_in_shop")} <span class="arrow">→</span></a>`
      : `<span class="model-price">${AYASA_t("js.core.coming_soon")}</span>`;
  const idx = MODELS.indexOf(m);
  const hearIt = m.videos && m.videos.length
    ? `<button class="hear-btn" data-model="${idx}" aria-haspopup="dialog">
         <span class="hear-play" aria-hidden="true">▶</span>
         ${AYASA_t("js.core.watch")}
       </button>`
    : "";
  const explore3d = m.detailPage
    ? `<a class="hear-btn explore-btn" href="${m.detailPage}">
         <span class="hear-play" aria-hidden="true">◈</span>
         ${AYASA_t("js.core.explore_3d")}
       </a>`
    : "";
  // Phase 0 shortlist — every purchasable scale gets a heart (top-right)
  const heart = m.productHandle
    ? `<button type="button" class="shortlist-heart" data-handle="${m.productHandle}" data-name="${m.name}" aria-label="${AYASA_t("js.core.add_name_to_wishlist", { name: m.name })}" aria-pressed="false">${HEART_SVG}</button>`
    : "";
  return `
  <article class="model-card reveal${linked ? " model-card-linked" : ""}${m.cardPhoto ? " model-card-photo" : ""}">
    ${m.cardPhoto ? `<div class="model-card-bg" style="background-image: url('${m.cardPhoto}')" aria-hidden="true"></div>` : ""}
    ${heart}
    <div class="model-head">
      <h3>${m.name}</h3>
    </div>
    <p class="model-scale">${m.scale}</p>
    <div class="notemap">
      ${noteMapSVG(m)}
      <p class="notemap-bottom">${bottom}</p>
    </div>
    <p class="model-desc">${m.desc}</p>
    <div class="model-actions">${hearIt}${explore3d}</div>
    <div class="model-foot">
      <span class="badge ${badgeClass}"${m.productHandle ? ` data-handle="${m.productHandle}"` : ""}>${m.availability}</span>
      ${priceOrLink}
    </div>
  </article>`;
}

// ---------- player carousel ----------
// The social links moved to the artist pages: every click on a card should go
// deeper into the site, not out of it. With no interactive children left, the
// whole card can simply be an anchor — no stretched-link overlay, no z-index.
function playerCard(p) {
  const quote = p.quote ? `<p class="player-quote">“${p.quote}”</p>` : "";
  const inner = `
    <img src="${p.img}" alt="${p.name}" loading="lazy">
    <div class="player-info">
      <h3>${p.name}</h3>
      <p class="player-cred">${p.credential}</p>
      ${quote}
    </div>`;
  return p.handle
    ? `<a class="player-card player-card-linked" href="/pages/${p.handle}">${inner}</a>`
    : `<article class="player-card">${inner}</article>`;
}

// Two callers: the homepage grid shows the first few and a card pointing at the
// full list; the artists page carries data-show="all" and shows everyone. The
// homepage's few are the artists page's first ones, in its order (Ralf, 09-10),
// so the order set in the Studio is the order on both; "featured" no longer picks.
const HOME_PLAYERS = 6;
function renderPlayers() {
  if (typeof PLAYERS === "undefined") return;
  document.querySelectorAll(".player-grid").forEach(track => {
    const showAll = track.dataset.show === "all";
    // Malte owns the section header (photo + quote), so his card would show him
    // twice on the homepage; the artists page still lists him with everyone.
    const shown = showAll ? PLAYERS : PLAYERS.filter(p => p.name !== "Malte Marten").slice(0, HOME_PLAYERS);
    const rest = PLAYERS.length - shown.length;
    const more = rest > 0 ? `
  <article class="player-card player-card-more">
    <div class="player-more-inner">
      <span>+${rest}</span>
      <p>${AYASA_t("js.core.more_artists")}</p>
      <a href="/pages/artists">${AYASA_t("js.core.meet_them_all")}</a>
    </div>
  </article>` : "";
    track.innerHTML = shown.map(playerCard).join("") + more;
  });
}

function renderRange() {
  const premium = document.getElementById("premiumGrid");
  const elements = document.getElementById("elementsGrid");
  if (!premium || !elements || typeof MODELS === "undefined") return;
  premium.innerHTML = MODELS.filter(m => m.range === "premium").map(modelCard).join("");
  elements.innerHTML = MODELS.filter(m => m.range === "elements").map(modelCard).join("");
  loadCardAvailability(premium);
  loadCardAvailability(elements);
}

// ---------- homepage range filters ----------
// Premium and Elements already have their own grids and headings on this page, so
// range pills would say nothing here — tonality is what is worth filtering. The
// chips are the shop's and product page's, minus the two that are structural.
const FAMILY_LABEL = {
  "d-minor": AYASA_t("js.core.family_d_minor"), "f#-minor": AYASA_t("js.core.family_fs_minor"), "e-minor": AYASA_t("js.core.family_e_minor"),
  "c-major": AYASA_t("js.core.family_c_major"), "b-minor": AYASA_t("js.core.family_b_minor"), other: AYASA_t("js.core.other")
};
// the product page's order, with "Other" kept last wherever it appears
const FAMILY_ORDER = ["d-minor", "f#-minor", "e-minor", "c-major", "b-minor", "other"];
function initRangeFilters() {
  const row = document.getElementById("rangeFilters");
  const premium = document.getElementById("premiumGrid");
  const elements = document.getElementById("elementsGrid");
  if (!row || !premium || !elements || typeof MODELS === "undefined") return;
  // the grids were filled from these same filtered lists, so index maps to model
  const groups = [
    { grid: premium, models: MODELS.filter(m => m.range === "premium"), head: null },
    { grid: elements, models: MODELS.filter(m => m.range === "elements"),
      head: document.querySelector("#range .elements-head") }
  ];
  const cards = [];
  groups.forEach(g => [...g.grid.querySelectorAll(".model-card")].forEach((el, i) => {
    if (!g.models[i]) return;
    el.dataset.family = g.models[i].family || "other";
    cards.push({ el, group: g });
  }));
  const present = new Set(cards.map(c => c.el.dataset.family));
  const keys = FAMILY_ORDER.filter(k => present.has(k));
  // one tonality is a label, not a filter — draw no row rather than a dead pill
  if (keys.length < 2) return;
  row.innerHTML = [{ key: "all", label: AYASA_t("js.core.all") }, ...keys.map(k => ({ key: k, label: FAMILY_LABEL[k] || k }))]
    .map(c => `<button type="button" class="filter-chip${c.key === "all" ? " on" : ""}" data-filter="${c.key}" aria-pressed="${c.key === "all"}">${c.label}</button>`)
    .join("");
  const apply = key => {
    row.querySelectorAll(".filter-chip").forEach(c => {
      const on = c.dataset.filter === key;
      c.classList.toggle("on", on);
      c.setAttribute("aria-pressed", on);
    });
    cards.forEach(c => { c.el.hidden = !(key === "all" || c.el.dataset.family === key); });
    // a heading over an empty grid reads as a bug, so the Elements block leaves
    // with its cards. Premium keeps its heading either way — that one is the
    // section's own title, not a label for the grid beneath it.
    groups.forEach(g => {
      if (!g.head) return;
      const empty = ![...g.grid.querySelectorAll(".model-card")].some(el => !el.hidden);
      g.head.hidden = empty;
      g.grid.hidden = empty;
    });
  };
  row.addEventListener("click", e => {
    const chip = e.target.closest(".filter-chip");
    if (!chip) return;
    // the rail is looked up per click, not once: initStickyRails wraps this row
    // after initRangeFilters has already run
    const rail = row.closest(".pill-rail");
    // sampled before the filter runs — see alignToFilteredTop for why afterwards is
    // too late
    const pinned = !!rail && rail.classList.contains("stuck");
    // un-pinned, the anti-jump applies: collapsing the grid yanks everything below
    // it up the screen, so hold the row still and let only the cards move. Pinned,
    // the row cannot move anyway and we align to the cards instead.
    const anchor = row.getBoundingClientRect().top;
    apply(chip.classList.contains("on") ? "all" : chip.dataset.filter);
    if (pinned) {
      alignToFilteredTop(rail, ".range-grid", ".model-card", true);
    } else {
      scrollBy({ top: row.getBoundingClientRect().top - anchor, behavior: "instant" });
    }
  });
}

// ---------- video card extras: hover previews + watched markers ----------
// Desktop-only: hovering a video card starts a muted inline preview after a
// beat. Works on every .demo-card (artist grids and product-page strips).
function initHoverPreviews() {
  if (!matchMedia("(hover: hover) and (pointer: fine)").matches) return;
  let hoverCard = null;
  let timer = 0;
  const previews = new Map();
  const visibility = new IntersectionObserver(entries => entries.forEach(e => {
    if (!e.isIntersecting) {
      if (hoverCard === e.target) hoverCard = null;
      discard(e.target);
    }
  }));
  const allowed = card => card === hoverCard && card.isConnected && !backgroundMediaBlocked();
  const discard = card => {
    const v = previews.get(card);
    if (!v) return;
    clearTimeout(v.__evictT);
    v.pause(); v.removeAttribute("src"); v.load(); v.remove();
    visibility.unobserve(card);
    previews.delete(card);
  };
  const stop = () => {
    clearTimeout(timer); hoverCard = null;
    for (const card of previews.keys()) discard(card);
  };
  document.addEventListener("ayasa:player-visibility", stop);
  document.addEventListener("visibilitychange", () => { if (document.hidden) stop(); });
  window.addEventListener("pagehide", stop);
  document.addEventListener("mouseover", e => {
    const card = e.target.closest(".demo-card");
    if (!card || card === hoverCard) return;
    hoverCard = card;
    clearTimeout(timer);
    timer = setTimeout(() => {
      if (!allowed(card)) return;
      let v = card.querySelector(".demo-preview");
      if (v) { // warm from an earlier hover — already buffered, resume instantly
        clearTimeout(v.__evictT);
        previews.delete(card); previews.set(card, v);
        v.classList.add("on");
        v.play().catch(() => {});
        return;
      }
      const img = card.querySelector("img");
      if (!img) return;
      v = document.createElement("video");
      v.className = "demo-preview";
      v.muted = true;
      v.loop = true;
      v.playsInline = true;
      v.preload = "auto";
      v.src = img.dataset.videoFile || img.src.replace(/\.jpg(\?.*)?$/, ".mp4$1");
      previews.set(card, v);
      visibility.observe(card);
      while (previews.size > 2) discard(previews.keys().next().value);
      card.appendChild(v);
      // Start when playback is possible; never restart a card the pointer left.
      const start = () => {
        if (!allowed(card) || previews.get(card) !== v) return;
        v.play().then(() => {
          if (allowed(card)) v.classList.add("on"); else v.pause();
        }).catch(() => { if (previews.get(card) === v) discard(card); });
      };
      if (v.readyState >= 3) start();
      else v.addEventListener("canplay", start, { once: true });
    }, 120);
  });
  document.addEventListener("mouseout", e => {
    const card = e.target.closest(".demo-card");
    if (!card || card.contains(e.relatedTarget)) return;
    clearTimeout(timer);
    hoverCard = null;
    const v = card.querySelector(".demo-preview");
    if (v) { // keep at most two briefly warm, then release their buffers
      v.classList.remove("on");
      v.pause();
      clearTimeout(v.__evictT);
      v.__evictT = setTimeout(() => discard(card), 10000);
    }
  });
}

// A subtle dot on cards whose video was already opened this session.
const WATCHED_KEY = "ayasaWatched";
function getWatched() {
  try { return new Set(JSON.parse(sessionStorage.getItem(WATCHED_KEY)) || []); }
  catch (e) { return new Set(); }
}
function videoKey(url) {
  return url.split("/").pop().split("?")[0].replace(/\.jpg$/, ".mp4");
}
// A clip's poster sits beside it under the same name. Clip urls now carry a ?v=
// stamp of the file's contents — so that replacing a video actually reaches the
// caches — and the swap has to happen BEFORE that stamp, not at the end of the
// string, or the poster silently becomes a request for an .mp4?v=… as an image.
const posterOf = url => url.replace(/\.mp4(\?|$)/, ".jpg$1");
// Only Shopify theme-asset URLs support these size suffixes. Keep local and
// external posters intact, and retain the original video identity separately.
const posterAttrs = (file, sizes = "(max-width: 640px) 160px, 300px") => {
  const url = posterOf(file);
  const escape = s => String(s).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;");
  const resize = /\/cdn\/shop\/t\/\d+\/assets\//.test(url) || /\/s\/files\/.*\/t\/\d+\/assets\//.test(url);
  const srcset = resize ? [240, 480, 720, 1080].map(w => escape(url.replace(/\.jpg(?=\?|$)/, `_${w}x.jpg`)) + ` ${w}w`).join(", ") : "";
  return `src="${escape(url)}" data-video-file="${escape(file)}" decoding="async"` +
    (srcset ? ` srcset="${srcset}" sizes="auto, ${sizes}"` : "");
};
const backgroundMediaBlocked = () => document.hidden || !!document.querySelector(".demo-lightbox:not(.minimized)");
const notifyPlayerVisibility = () => document.dispatchEvent(new Event("ayasa:player-visibility"));
function refreshWatchedDots() {
  const seen = getWatched();
  document.querySelectorAll(".demo-card img").forEach(img => {
    img.closest(".demo-card").classList.toggle("watched", seen.has(videoKey(img.dataset.videoFile || img.src)));
  });
}
function markWatched(file) {
  const seen = getWatched();
  seen.add(videoKey(file));
  sessionStorage.setItem(WATCHED_KEY, JSON.stringify([...seen]));
  refreshWatchedDots();
}

// ---------- how far people actually watch ----------
// Shopify cannot tell us this and no analytics product will: the player is ours,
// so it reports. Anonymous by design — a clip id, a percentage, a duration.
// No cookie, no visitor id, nothing that could identify anybody.
//
// A play only counts after PLAY_AFTER seconds of real playback; without that,
// crawlers and accidental taps register as viewers and every completion rate
// sags for reasons that have nothing to do with the footage.
const BEACON = "https://beacon.ayasa-studio.com/api/beacon";
const PLAY_AFTER = 3;
const videoId = file => videoKey(file).replace(/\.mp4$/, "");

function report(payload) {
  try {
    const body = JSON.stringify(payload);
    // sendBeacon survives the page being closed, which is exactly when the last
    // and most interesting event fires
    if (navigator.sendBeacon) {
      navigator.sendBeacon(BEACON, new Blob([body], { type: "application/json" }));
    } else {
      fetch(BEACON, { method: "POST", body, keepalive: true,
        headers: { "Content-Type": "application/json" } }).catch(() => {});
    }
  } catch (e) { /* measurement must never break playback */ }
}

// One clip at a time: start() when it appears, flush() when it is replaced,
// closed, or the tab goes away.
const watchTracker = {
  id: null, counted: false, maxPct: 0, secs: 0, lastT: 0,
  start(id) {
    this.flush();
    this.id = id; this.counted = false; this.maxPct = 0; this.secs = 0; this.lastT = 0;
  },
  tick(el) {
    if (!this.id || !el.duration || !isFinite(el.duration)) return;
    // sum of forward movement, so scrubbing back and forth cannot inflate it
    const t = el.currentTime;
    if (t > this.lastT) this.secs += Math.min(t - this.lastT, 1.5);
    this.lastT = t;
    this.maxPct = Math.max(this.maxPct, Math.round(t / el.duration * 100));
    if (!this.counted && this.secs >= PLAY_AFTER) {
      this.counted = true;
      report({ v: this.id, e: "play" });
    }
  },
  finished() { this.maxPct = 100; },
  flush() {
    if (this.id && this.counted) {
      report({ v: this.id, e: "done", p: this.maxPct, s: Math.round(this.secs) });
    }
    this.id = null; this.counted = false;
  },
  shopClick() { if (this.id) report({ v: this.id, e: "shop" }); }
};
// a closed tab is the commonest way a watch ends
addEventListener("pagehide", () => watchTracker.flush());

// ---------- demo video lightbox ----------
function artistInfoHTML(label) {
  const base = label.split(" · ")[0];
  const a = (typeof ARTISTS !== "undefined" && ARTISTS[base]) || {};
  const avatar = a.img
    ? `<img class="demo-artist-avatar" src="${a.img}" alt="${base}">`
    : `<span class="demo-artist-avatar demo-artist-initial" aria-hidden="true">${base[0]}</span>`;
  return `
    ${avatar}
    <div class="demo-artist-text">
      <strong>${a.page ? `<a href="${a.page}" title="${AYASA_t("js.core.meet_artist", { name: base })}">${base} →</a>` : base}</strong>
      ${a.credential ? `<span class="demo-artist-cred">${a.credential}</span>` : ""}
      ${a.bio ? `<p class="demo-artist-bio">${a.bio}</p>` : ""}
    </div>`;
}

// small centered popup for missed required choices (case / t-shirt)
function showChoicePopup(msg) {
  document.querySelector(".choice-popup")?.remove();
  const p = document.createElement("div");
  p.className = "choice-popup";
  p.setAttribute("role", "alert");
  p.textContent = msg;
  document.body.appendChild(p);
  setTimeout(() => {
    p.classList.add("out");
    setTimeout(() => p.remove(), 400);
  }, 2600);
}
function choiceMessage(needCase, needShirt) {
  if (needCase && needShirt) return AYASA_t("js.core.choose_case_and_tshirt");
  if (needCase) return AYASA_t("js.core.choose_case");
  return AYASA_t("js.core.choose_tshirt_or_none");
}

// lightbox top-bar icons: stroke inherits the button's color, so one set
// serves the frosted mobile buttons and the outlined desktop ones alike
const DEMO_ICON_MIN = `<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 9l7 7 7-7"/></svg>`;
const DEMO_ICON_EXPAND = `<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 15l-7-7-7 7"/></svg>`;
const DEMO_ICON_RIGHT = `<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M12 5l7 7-7 7"/></svg>`;
const DEMO_ICON_LEFT = `<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 12H5M12 5l-7 7 7 7"/></svg>`;
const DEMO_ICON_DOWN = `<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 5v14M5 12l7 7 7-7"/></svg>`;
const DEMO_ICON_UP = `<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7"/></svg>`;
const DEMO_ICON_CLOSE = `<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>`;

const DEMO_ICON_GRID = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><rect x="4" y="4" width="6" height="6" rx="1"/><rect x="14" y="4" width="6" height="6" rx="1"/><rect x="4" y="14" width="6" height="6" rx="1"/><rect x="14" y="14" width="6" height="6" rx="1"/></svg>';
const DEMO_ICON_CAROUSEL = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><rect x="8" y="3" width="8" height="18" rx="2"/><path d="M5 6H2v12h3M19 6h3v12h-3"/></svg>';

// The setting limits the visible grid, never the available performances.
// Keep names readable on small windows and let additional rows scroll.
function fitDemoGrid(width, height, count, visible = 12) {
  const gap = 14, ratio = 9 / 16, minHeight = 160;
  if (width <= 0 || height <= 0 || count < 1) return null;
  const limit = [6, 9, 12, 18, 24, 36, 48].includes(Number(visible)) ? Number(visible) : 12;
  const target = Math.min(count, limit);
  // Medium clip lists read as three rows rather than a long two-row strip:
  // nine is 3/3/3; ten is 4/4/2. Wide frames contain the portrait posters.
  if (target >= 9 && target <= 12) {
    const columns = Math.ceil(target / 3);
    const tileWidth = (width - (columns - 1) * gap) / columns;
    if (tileWidth >= minHeight * ratio) {
      const tileHeight = Math.min(tileWidth / ratio, height,
        Math.max(minHeight, (height - 2 * gap) / 3));
      const visibleRows = Math.max(1, Math.min(3,
        Math.floor((height + gap) / (tileHeight + gap))));
      return { columns, tileWidth, tileHeight, visibleRows,
        rows: Math.ceil(count / columns), gap, gapX: gap,
        viewportHeight: visibleRows * tileHeight + (visibleRows - 1) * gap };
    }
  }
  let best;
  for (let columns = 1; columns <= Math.min(8, target); columns++) {
    const tileWidth = (width - (columns - 1) * gap) / columns;
    const portraitHeight = tileWidth / ratio;
    if (tileWidth <= 0 || (columns > 1 && portraitHeight < minHeight)) continue;
    // Sparse grids may have wider frames; contain the poster rather than crop it.
    const tileHeight = Math.min(portraitHeight, height);
    const visibleRows = Math.max(1, Math.min(Math.ceil(count / columns),
      Math.floor(limit / columns), Math.floor((height + gap) / (tileHeight + gap))));
    const shown = Math.min(count, visibleRows * columns);
    // Show as much of the requested amount as comfortably fits, then prefer
    // larger cards. Every candidate spans the entire width with the same gaps.
    if (!best || shown > best.shown || (shown === best.shown && tileWidth > best.tileWidth)) {
      best = { columns, visibleRows, tileWidth, tileHeight, shown };
    }
  }
  return { ...best, rows: Math.ceil(count / best.columns), gap, gapX: gap,
    viewportHeight: best.visibleRows * best.tileHeight + (best.visibleRows - 1) * gap };
}

// Player settings travel from the studio in AYASA_CFG.player (Settings → video
// player). Every default here reproduces the player EXACTLY as it was before the
// setting existed, so a shop with no saved settings — or an older ayasa-data.js —
// renders the classic player and nothing shifts under anyone.
const PLAYER_DEFAULTS = {
  design: "classic",   // classic | carousel
  cards: 5,            // carousel cards across
  gridVisible: 12,     // maximum grid clips at once; extra clips scroll
  scale: 82,           // each step back is this % of the one in front
  lift: 26,            // px each step back rises, so the deck recedes upward
  dim: 55,             // % — how much dimmer each card is than the one in front
  barDim: 55,          // % — and the same again, docked: the bar and the micro
                       //     player share it, the big screen keeps dim             // % opacity of the first card back, compounding outward
  gap: 18,             // px between neighbouring card edges
  radius: 14,          // px corner on the video card
  pills: true,         // the artist pill strip
  pillOpacity: 100,
  panelBg: true,       // the card background and border behind everything
  backdrop: 88,        // % dim of the page behind
  blur: 6,             // px blur of the page behind
  endWrap: true,       // last clip runs back to the first
  barHeight: 200,      // px tall the clip is in the minimized bar
  cardName: 14,        // px — the artist's name on the cards behind
  nowName: 16,         // px — and on the one playing; 0 hides it
  boost: 100,          // % — the playing card against the ones behind it
  barSide: 300,        // px — the artist and instrument columns in the bar
  expSide: 300,        // px — and the same two beside the maximized clip
  barLayout: "centre", // centre | left — where the playing clip sits in the bar
  barOffset: 260,      // px from the browser's left edge, in the left layout
  microHeight: 120,    // px of clip in the micro player, one step below the bar
  nameDrop: 0,         // px the whole bottom row is lifted off the screen edge
  mobileIntro: false,  // show the scrollable artist intro in mobile players
  mobileSwap: false,   // swap artist and model positions in mobile players
  artistX: 0           // px the artist column starts right of the screen's middle
};
const playerCfg = () => ({ ...PLAYER_DEFAULTS,
  ...(typeof AYASA_CFG !== "undefined" && AYASA_CFG.player) || {} });

// Artist pages may contain takes that are not featured in the model grid.
// Build a session-only playlist; never substitute another clip or mutate data.
function playerSelectionForClip(model, clip) {
  const index = model.videos.findIndex(v => videoKey(v.file) === videoKey(clip.file));
  if (index >= 0) return { model, index };
  return { model: { ...model, videos: [...model.videos, { ...clip }] }, index: model.videos.length };
}

function openDemoLightbox(model, startIndex, buyCtx) {
  // one player at a time — a lingering (possibly minimized) lightbox closes first.
  // A minimized one means the user is browsing: the new player opens minimized too.
  // The shape the player was left in is the shape the next clip arrives in.
  // Docked was already carried; small and mirrored were not, so choosing a
  // second clip threw the player back up to the bar and back to the left —
  // undoing, every time, the very thing that had made room to browse.
  const prev = document.querySelector(".demo-lightbox.minimized");
  const wasMin = !!prev;
  const wasCompact = wasMin && prev.classList.contains("bar-compact");
  const wasMirror = wasMin && prev.classList.contains("bar-mirror");
  document.querySelectorAll(".demo-lightbox").forEach(el => el.__close && el.__close());
  // A restored or range player may already be on its matching product page.
  // Close the previous player first so its borrowed options are back home.
  if (!buyCtx) {
    const target = model.videoShop?.url || (model.productHandle ? `/products/${model.productHandle}` : "");
    try {
      const url = new URL(target, location.href);
      const handle = decodeURIComponent(url.pathname.match(/\/products\/([^/]+)\/?$/)?.[1] || "");
      const page = document.querySelector(".product-section[data-handle]");
      if (url.origin === location.origin && handle && page?.dataset.handle === handle)
        buyCtx = page.__playerBuyContext?.();
    } catch (_) { /* remote loader reports an invalid destination */ }
  }
  const start = startIndex || 0;
  const cfg = playerCfg();
  const canDockGrid = true;
  // Keep the deck structure available across breakpoint changes. The expanded
  // deck is desktop-only; mobile uses its original sheet and the docked strip.
  const deckMode = true; // Grid is the only player layout, including single-clip instruments.
  const lb = document.createElement("div");
  // .opening scopes the sheet's slide-up entrance to this moment alone
  lb.className = "demo-lightbox opening" + (deckMode && !matchMedia("(max-width: 640px)").matches ? " deck" : "") +
    (cfg.pills ? "" : " no-pills") + (cfg.panelBg ? "" : " no-panel") +
    (deckMode && cfg.barLayout === "left" ? " bar-left" : "");
  lb.setAttribute("role", "dialog");
  lb.setAttribute("aria-label", AYASA_t("js.core.demo_videos_for", { name: model.name }));
  const tabs = model.videos.map((v, i) =>
    `<button class="demo-tab${i === start ? " active" : ""}" data-i="${i}">${v.artist}</button>`).join("");
  // cta bar: fades in once the viewer is watching.
  // product pages (buyCtx) get add-to-cart; elsewhere a "View in shop" link,
  // derived from the model's product handle unless videoShop overrides it.
  const shop = !buyCtx && (model.videoShop ||
    (model.productHandle ? { name: `${model.name} — Ember Steel®`, url: `/products/${model.productHandle}` } : null));
  // the mobile footer's identity anchor — always the playing model's page
  const shopUrl = (model.videoShop && model.videoShop.url) ||
    (model.productHandle ? `/products/${model.productHandle}` : "/collections/handpans");
  // the model name leads to its product page, in the same "name →" language the
  // artist link beside it already speaks, including on the product page itself:
  // the link docks the overlay so the instrument can be explored again.
  const shopHref = (model.videoShop && model.videoShop.url) ||
    (model.productHandle ? `/products/${model.productHandle}` : null);
  const nameLink = label => shopHref
    ? `<a class="demo-shop-link" href="${shopHref}">${label} →</a>`
    : label;
  // The shortlist is document-delegated, so the right classes and data are all a
  // heart needs: the toggle, the toast, the analytics event and the pressed state
  // come free, and refreshShortlistUI() keeps it in step with the same model's
  // heart on its card. It keys on the product handle, so no handle, no heart.
  const heartFor = where => model.productHandle
    ? `<button type="button" class="shortlist-heart ${where}" data-handle="${model.productHandle}"
        data-name="${model.name}" aria-label="${AYASA_t("js.core.add_name_to_wishlist", { name: model.name })}" aria-pressed="false">${HEART_SVG}</button>`
    : "";
  const purchaseHTML = () => `
      <div class="demo-cta">
        <div class="demo-cta-inner">
          <div class="demo-cta-row">
            <p class="demo-cta-price">
              ${buyCtx.compareAt ? `<s>${buyCtx.compareAt}</s>` : ""}<strong>${buyCtx.price}</strong>
            </p>
            <div class="demo-cta-actions">
              <button type="button" class="btn btn-primary demo-cta-btn">${AYASA_t("js.core.order_now")}</button>
              ${heartFor("demo-cta-heart")}
            </div>
          </div>
          ${buyCtx.caseSelect ? `
          <!-- the page's real options block is MOVED in here on the first tap:
               same case picker, colour tiles, size chips and validation,
               rather than a clone that can drift out of step -->
          <div class="demo-cta-casewrap" hidden></div>
          <button type="button" class="btn btn-primary demo-cta-add" hidden>${AYASA_t("js.core.add_to_cart")}</button>` : ""}
          <p class="demo-cta-error" hidden></p>
        </div>
      </div>`;
  const ctaHTML = buyCtx && buyCtx.available ? purchaseHTML() : shop ? `
      <div class="demo-cta demo-cta-remote visible">
        <div class="demo-cta-inner">
          <div class="demo-cta-row">
            <p class="demo-cta-price" aria-live="polite"><strong class="demo-remote-price">${AYASA_t("js.core.loading_price")}</strong></p>
            <div class="demo-cta-actions">
              <a class="btn btn-primary demo-cta-btn demo-remote-order" href="${shop.url}">${AYASA_t("js.core.order_now")}</a>
              ${heartFor("demo-cta-heart")}
            </div>
          </div>
        </div>
      </div>` : "";
  lb.innerHTML = `
    <div class="demo-backdrop"></div>
    <div class="demo-panel">
      <!-- mobile shows [chevron · title ······ close] over the scrim; desktop
           reorders the same three children to [title ······ chevron close] -->
      <div class="demo-top">
        <button class="demo-min" aria-label="${AYASA_t("js.core.minimize")}">${DEMO_ICON_MIN}</button>
        <div class="demo-top-id">
          <p class="demo-title">${nameLink(model.name)}</p>
          <p class="demo-sub">${model.scale}</p>
        </div>
        <button class="demo-close" aria-label="${AYASA_t("js.core.close")}">${DEMO_ICON_CLOSE}</button>
      </div>
      ${model.videos.length > 1 ? `
      <div class="demo-dots" aria-hidden="true">${model.videos.map((_, i) =>
        `<span${i === start ? ' class="on"' : ""}></span>`).join("")}</div>` : ""}
      ${deckMode ? `
      <!-- The bar's own column, beside the clip. The pair at the bottom right
           stays where it is; this is the fuller set, and the only place the
           mirror and the small player can be reached from. -->
      <div class="demo-side">
        <button type="button" class="demo-side-btn demo-side-close" aria-label="${AYASA_t("js.core.close")}">${DEMO_ICON_CLOSE}</button>
        <button type="button" class="demo-side-btn demo-side-max" aria-label="${AYASA_t("js.core.expand")}">${DEMO_ICON_EXPAND}</button>
        <button type="button" class="demo-side-btn demo-side-mirror" aria-label="${AYASA_t("js.core.mirror_bar")}">${DEMO_ICON_RIGHT}</button>
        <button type="button" class="demo-side-btn demo-side-small" aria-label="${AYASA_t("js.core.micro_player")}">${DEMO_ICON_DOWN}</button>
        <button type="button" class="demo-side-btn demo-side-back" aria-label="${AYASA_t("js.core.back_to_bar")}">${DEMO_ICON_UP}</button>
      </div>` : ""}
      ${deckMode ? `<div class="demo-stage">` : ""}
      ${deckMode ? `
      <!-- One card per clip, posters only: five live <video> elements would
           cripple a phone and the browser has these posters already. The real
           <video> below sits exactly on top of the centre card, so a clip change
           is the deck sliding while the video fades across its own poster. -->
      <p class="demo-grid-heading">${AYASA_t("js.core.performances")} <span>${AYASA_t(model.videos.length === 1 ? "js.core.clips_one" : "js.core.clips_other", { n: model.videos.length })}</span></p>
      <div class="demo-deck" role="group" aria-label="${AYASA_t("js.core.choose_performance")}">${model.videos.map((v, i) => `
        <button type="button" class="demo-slide" data-i="${i}" tabindex="-1">
          <img ${posterAttrs(v.file, "(max-width: 640px) 120px, 300px")} alt="" loading="lazy">
          <span class="demo-slide-state" aria-hidden="true">${AYASA_t("js.core.playing")}</span>
          <span class="demo-slide-name">${v.artist}</span>
        </button>`).join("")}</div>` : ""}
      ${deckMode && cfg.nowName ? `<p class="demo-now"></p>` : ""}
      <video controls playsinline preload="metadata" controlslist="nodownload nofullscreen noremoteplayback noplaybackrate" disablepictureinpicture
             poster="${posterOf(model.videos[start].file)}"
             src="${model.videos[start].file}"></video>
      ${deckMode ? `</div>` : ""}
      ${ctaHTML}
      <div class="demo-mini-info">
        <p class="demo-mini-name">${nameLink(model.name)}</p>
        <p class="demo-mini-scale">${model.scale}</p>
        <div class="demo-mini-actions">
          <a class="btn btn-primary demo-mini-shop" href="${shopUrl}">${AYASA_t("js.core.view_in_shop_arrow")}</a>
          ${heartFor("demo-mini-heart")}
        </div>
      </div>
      <div class="demo-scroll">
        <!-- two rows that pack independently (see splitTabRows); role=presentation
             keeps the tablist→tab relationship intact through the extra level -->
        <div class="demo-tabs" role="tablist" aria-label="${AYASA_t("js.core.choose_artist")}">
          <div class="demo-tab-row" role="presentation">${tabs}</div>
          <div class="demo-tab-row" role="presentation"></div>
        </div>
        <div class="demo-artist">${artistInfoHTML(model.videos[start].artist)}</div>
      </div>
    </div>`;
  lb.style.setProperty("--dock-opacity", Math.min(1, Math.max(0.05, cfg.barDim / 100)));
  lb.style.setProperty("--dock-name-size", (cfg.cardName === 0 ? 0 : Math.max(9, Math.min(11, cfg.cardName))) + "px");
  lb.style.setProperty("--deck-scale", cfg.scale / 100);
  lb.style.setProperty("--deck-lift", cfg.lift + "px");
  lb.style.setProperty("--deck-dim", cfg.dim / 100);
  lb.style.setProperty("--deck-gap", cfg.gap + "px");
  lb.style.setProperty("--deck-radius", cfg.radius + "px");
  lb.style.setProperty("--bar-video", cfg.barHeight + "px");
  lb.style.setProperty("--card-name", cfg.cardName + "px");
  lb.style.setProperty("--now-name", cfg.nowName + "px");
  lb.style.setProperty("--deck-boost", cfg.boost / 100);
  lb.style.setProperty("--bar-side", cfg.barSide + "px");
  lb.style.setProperty("--exp-side", cfg.expSide + "px");
  lb.style.setProperty("--bar-offset", cfg.barOffset + "px");
  lb.style.setProperty("--micro-video", cfg.microHeight + "px");
  lb.style.setProperty("--name-drop", cfg.nameDrop + "px");
  lb.style.setProperty("--artist-x", cfg.artistX + "px");
  lb.style.setProperty("--pill-opacity", cfg.pillOpacity / 100);
  lb.style.setProperty("--demo-backdrop", cfg.backdrop / 100);
  lb.style.setProperty("--demo-blur", cfg.blur + "px");
  if (canDockGrid) {
    const rail = document.createElement("div");
    rail.className = "demo-dock-grid";
    rail.hidden = true;
    rail.innerHTML = '<button type="button" class="demo-dock-prev" aria-label="' + AYASA_t("js.core.earlier_clips") + '">' + DEMO_ICON_LEFT + '</button>' +
      '<div class="demo-dock-window" role="group" aria-label="' + AYASA_t("js.core.browse_performances") + '">' +
      model.videos.map((v, i) => '<button type="button" class="demo-dock-clip" data-i="' + i + '" aria-label="' +
        AYASA_t("js.core.clip_label", { artist: String(v.artist).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/"/g, "&quot;"), i: i + 1, n: model.videos.length }) + '"><img alt="" loading="lazy" ' +
        posterAttrs(v.file, "120px") + '><span>' + String(v.artist).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/"/g, "&quot;") + '</span></button>').join('') +
      '</div><button type="button" class="demo-dock-next" aria-label="' + AYASA_t("js.core.later_clips") + '">' + DEMO_ICON_RIGHT + '</button>';
    lb.appendChild(rail);
  }
  document.body.appendChild(lb);
  document.body.style.overflow = "hidden";
  notifyPlayerVisibility();
  refreshShortlistUI();   // the new heart adopts this model's saved state
  // the entrance is over once it has played (or immediately never played, under
  // reduced motion or when opening straight into the footer) — a timer rather
  // than animationend, which never fires in those two cases
  setTimeout(() => lb.classList.remove("opening"), 450);

  const video = lb.querySelector("video");
  const artistBox = lb.querySelector(".demo-artist");
  // mobile sheet: fade the scroll area's bottom edge while more content is below
  const scroller = lb.querySelector(".demo-scroll");
  // and the pill strip's right edge while more artists sit off to the side
  const tabsWrap = lb.querySelector(".demo-tabs");
  const updateFade = () => {
    scroller.classList.toggle("scroll-fade",
      scroller.scrollHeight - scroller.scrollTop - scroller.clientHeight > 8);
    tabsWrap.classList.toggle("more",
      tabsWrap.scrollWidth - tabsWrap.scrollLeft - tabsWrap.clientWidth > 4);
  };
  scroller.addEventListener("scroll", updateFade, { passive: true });
  tabsWrap.addEventListener("scroll", updateFade, { passive: true });
  updateFade();
  const close = () => {
    video.pause();
    watchTracker.flush();
    document.body.style.overflow = "";
    // hand the borrowed options block back to the page before this element
    // disappears, or the product page loses its case and t-shirt pickers
    const borrowed = lb.querySelector("#buyOptions");
    if (borrowed && lb.__optsHome) {
      lb.__optsHome.insertBefore(borrowed, lb.__optsNext || null);
      document.dispatchEvent(new CustomEvent("ayasa:options-returned"));
    }
    lb.remove();
    lb.__offResize && lb.__offResize();
    clearWarmNeighbors();
    video.removeAttribute("src"); video.load();
    notifyPlayerVisibility();
    document.removeEventListener("keydown", onKey);
  };
  lb.__close = close;
  // state snapshot for cross-page resurrection of the minimized player
  lb.__state = () => ({ name: model.name, index: current(), clip: model.videos[current()], time: video.currentTime,
    compact: lb.classList.contains("bar-compact"),
    mirror: lb.classList.contains("bar-mirror") });

  // minimize: desktop docks to a corner mini-player, mobile to a footer bar —
  // either way the page stays browsable while the music keeps playing
  const mq = matchMedia("(max-width: 640px)");
  const panel = lb.querySelector(".demo-panel");
  const btnMin = lb.querySelector(".demo-min");

  const inGrid = () => !!deckMode && !mq.matches && !lb.classList.contains("minimized");
  btnMin.addEventListener("click", e => {
    // the panel's tap-to-maximize listener must never see this: swapping the
    // icon below detaches the tapped <svg>, and a detached target's .closest()
    // finds no button, so its guard would leak and toggle straight back
    e?.stopPropagation();
    const min = lb.classList.toggle("minimized");
    document.body.style.overflow = min ? "" : "hidden";
    notifyPlayerVisibility();
    btnMin.innerHTML = min ? DEMO_ICON_EXPAND : DEMO_ICON_MIN;
    btnMin.setAttribute("aria-label", min ? AYASA_t("js.core.expand") : AYASA_t("js.core.minimize"));
    // any minimize ends the coaching — the gesture (or button) is now known
    lb.querySelector(".demo-hint")?.remove();
    panel.classList.remove("peek");
    // and ends the opening moment, so coming back up never replays the entrance
    // even if that happens within the timer's window
    lb.classList.remove("opening");
    // the footer video is a thumbnail, not a player surface — taps maximize instead
    if (mq.matches) {
      video.controls = !min;
      // a 112px thumbnail is no place to start casting, and the browser draws that
      // button right where our own expand and close buttons sit
      video.disableRemotePlayback = min;

    }
    // the sheet and the footer give the strip a different width AND a different
    // pill size, so both the split and the centred position are different numbers
    // in each — recompute rather than inherit. Split first: it moves the geometry
    // that centring then measures.
    splitTabRows();
    scroller.style.height = "";
    lb.querySelector(".demo-top").style.top = "";
    layoutDeck();
    layoutBar();
    revealGridSelection();
    centreActivePill(tabEls[current()], "auto");
    requestAnimationFrame(updateFade); // scroll geometry changes with the size
  });
  // footer: tapping the bar brings the player back — except on anything
  // interactive (pills, artist link, shop button, the corner buttons)
  panel.addEventListener("click", e => {
    if (!mq.matches || !lb.classList.contains("minimized")) return;
    if (e.target.closest("button, a, .demo-scroll, .demo-dock-grid, .demo-mobile-product")) return;
    btnMin.click();
  });

  // first-open coaching, once ever: after the sheet settles, it dips and
  // springs back while a pill names the swipe. Restored/minimized opens skip
  // it, and the timeout re-checks — restoreMiniPlayer docks right after open.
  if (mq.matches && !wasMin) {
    let seen = null;
    try { seen = localStorage.getItem("ayasa:mini-hint"); } catch (e) { /* private mode */ }
    if (!seen) {
      setTimeout(() => {
        if (!document.contains(lb) || lb.classList.contains("minimized")) return;
        try { localStorage.setItem("ayasa:mini-hint", "1"); } catch (e) { /* session-only then */ }
        const hint = document.createElement("div");
        hint.className = "demo-hint";
        hint.innerHTML = `<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 4v14M6 13l6 6 6-6"/></svg>${AYASA_t("js.core.swipe_down_hint")}`;
        panel.appendChild(hint);
        panel.classList.add("peek");
        setTimeout(() => panel.classList.remove("peek"), 1400);
        setTimeout(() => hint.classList.add("out"), 3600);
        setTimeout(() => hint.remove(), 4200);
      }, 700);
    }
  }
  const tabEls = [...lb.querySelectorAll(".demo-tab")];
  const dotEls = [...lb.querySelectorAll(".demo-dots span")];
  // warm the neighbouring clips (metadata + poster) so a swipe starts fast
  const warmed = new Map();
  const releaseWarm = k => {
    const w = warmed.get(k);
    w?.pause(); w?.removeAttribute("src"); w?.load(); warmed.delete(k);
  };
  const clearWarmNeighbors = () => { for (const k of warmed.keys()) releaseWarm(k); };
  const warmNeighbors = n => {
    const connection = navigator.connection;
    if (document.hidden || connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || "")) {
      clearWarmNeighbors(); return;
    }
    const wanted = new Set([n - 1, n + 1].map(i => (i + model.videos.length) % model.videos.length));
    wanted.delete(n);
    for (const k of warmed.keys()) if (!wanted.has(k)) releaseWarm(k);
    wanted.forEach(k => {
    if (warmed.has(k)) return;
    const w = document.createElement("video");
    w.preload = "metadata";
    w.src = model.videos[k].file;
    warmed.set(k, w);
    });
  };
  // Two rows that lean into each other. A grid would align every bottom pill to
  // the column above it, so a short name left dead air beside it and pushed the
  // next pill out; independent flex rows in the one scroller pack tightly instead.
  // The split is SEQUENTIAL — never re-ordered — because select() and the dots
  // index pills by position, so a shuffled DOM would light up the wrong artist.
  // The cut lands where the running width passes half the total, which keeps both
  // rows about the same length rather than merely the same count.
  const tabRows = [...lb.querySelectorAll(".demo-tab-row")];
  const splitTabRows = () => {
    tabRows[0].append(...[...tabRows[1].children]);   // back to one row: idempotent
    if (!mq.matches) return;                          // desktop wraps freely
    const pills = [...tabRows[0].children];
    if (pills.length < 2) return;
    const gap = parseFloat(getComputedStyle(tabRows[0]).columnGap) || 0;
    const widths = pills.map(p => p.getBoundingClientRect().width + gap);
    const total = widths.reduce((a, b) => a + b, 0) - gap;
    if (total <= tabsWrap.clientWidth + 2) return;    // a single row already fits
    let run = 0, cut = pills.length;
    for (let i = 0; i < pills.length; i++) {
      run += widths[i];
      if (run >= total / 2) {
        // the pill that straddles the halfway mark can go either way: keep
        // whichever choice makes the LONGER row shorter, because the strip
        // scrolls as far as its longest row and no further
        const takingIt = Math.max(run - gap, total - run);
        const leavingIt = Math.max(run - widths[i] - gap, total - run + widths[i]);
        cut = leavingIt < takingIt ? i : i + 1;
        break;
      }
    }
    if (cut < 1) cut = 1;                             // never strand the top row empty
    if (cut < pills.length) tabRows[1].append(...pills.slice(cut));
  };

  // The deck lays itself out from the VIDEO's measured box rather than from CSS
  // guesses: the video is sized by its own aspect ratio, so only it knows how wide
  // a card is. Each step back is placed edge-to-edge with the one in front —
  // half of that card, the gap, then half of this smaller one — which keeps the
  // spacing honest at any scale instead of hard-coding offsets per position.
  const deck = lb.querySelector(".demo-deck");
  const nowName = lb.querySelector(".demo-now");
  // the deck measures itself into the stage, which is the column it may not leave
  const stage = lb.querySelector(".demo-stage");
  const boost = Math.max(1, cfg.boost / 100);
  const slides = deck ? [...deck.querySelectorAll(".demo-slide")] : [];
  let gridColumns = 1;
  const revealGridSelection = () => {
    if (!inGrid() || !slides[current()]) return;
    const item = slides[current()].getBoundingClientRect(), box = deck.getBoundingClientRect();
    if (item.top < box.top) deck.scrollTop += item.top - box.top;
    else if (item.bottom > box.bottom) deck.scrollTop += item.bottom - box.bottom;
  };
  const markGridSelection = () => slides.forEach((slide, i) => {
    const selected = i === current();
    slide.classList.toggle("current", selected);
    slide.setAttribute("aria-current", String(selected));
    slide.setAttribute("aria-label", AYASA_t("js.core.clip_label", { artist: model.videos[i].artist, i: i + 1, n: slides.length }));
    slide.querySelector(".demo-slide-state").textContent = video.paused || video.ended ? AYASA_t("js.core.selected") : AYASA_t("js.core.playing");
  });
  const layoutGrid = () => {
    const sr = stage.getBoundingClientRect();
    if (!sr.width || !sr.height) return;
    const gap = parseFloat(getComputedStyle(panel).columnGap) || 24;
    const ratio = video.videoWidth && video.videoHeight ? video.videoWidth / video.videoHeight : 9 / 16;
    const width = Math.min(sr.height * ratio, sr.width * 0.44);
    panel.style.setProperty("--grid-video-width", width + "px");
    panel.style.setProperty("--grid-video-height", width / ratio + "px");
    panel.style.setProperty("--grid-info-width", Math.max(0, Math.min(cfg.expSide, (sr.width - width - gap * 2) / 2)) + "px");
    if (lb.classList.contains("buying")) { scroller.style.height = ""; return; }
    // Both bottom columns start on the model-name line. Include the real buy
    // row when present; a short artist bio must not pull its name downwards.
    const infoRect = lb.querySelector(".demo-mini-info").getBoundingClientRect();
    const buyRow = lb.querySelector(".demo-cta");
    const buyBottom = buyRow?.offsetHeight ? buyRow.getBoundingClientRect().bottom : infoRect.bottom;
    scroller.style.height = Math.max(0, Math.max(infoRect.bottom, buyBottom) - infoRect.top) + "px";
    // Leave a header above the posters for the view/minimize/close controls.
    const top = lb.querySelector(".demo-top").getBoundingClientRect().height + 16;
    const textTop = Math.min(...[".demo-scroll", ".demo-mini-info", ".demo-cta"]
      .map(s => lb.querySelector(s)).filter(el => el && el.offsetHeight)
      .map(el => el.getBoundingClientRect().top - sr.top));
    deck.style.left = width + gap + "px";
    deck.style.top = top + "px";
    deck.style.width = Math.max(1, sr.width - width - gap) + "px";
    deck.style.height = Math.max(60, Math.min(sr.height, textTop - 18) - top) + "px";
    const fit = fitDemoGrid(deck.clientWidth, deck.clientHeight, slides.length, cfg.gridVisible);
    if (!fit) return;
    gridColumns = fit.columns;
    deck.style.height = fit.viewportHeight + "px";
    deck.style.setProperty("--grid-card-name", Math.max(12, Math.min(cfg.cardName, fit.tileWidth / 8.5)) + "px");
    // A real layout box keeps the scroll range stable while cards animate.
    deck.style.setProperty("--grid-content-height", (fit.rows * fit.tileHeight + (fit.rows - 1) * fit.gap) + "px");
    slides.forEach((el, i) => {
      el.style.width = fit.tileWidth + "px";
      el.style.height = fit.tileHeight + "px";
      el.style.transform = `translate(${i % fit.columns * (fit.tileWidth + fit.gapX)}px, ${Math.floor(i / fit.columns) * (fit.tileHeight + fit.gap)}px)`;
      el.style.opacity = "";
      el.style.pointerEvents = "auto";
      el.style.zIndex = "1";
      el.tabIndex = 0;
      el.removeAttribute("aria-hidden");
    });
    markGridSelection();
  };
  const mobileMeta = document.createElement("div");
  mobileMeta.className = "demo-mobile-meta";
  const mobileProduct = document.createElement("div");
  mobileProduct.className = "demo-mobile-product";
  mobileMeta.appendChild(mobileProduct);
  panel.appendChild(mobileMeta);
  const mobileHomes = [scroller, lb.querySelector(".demo-mini-info"), lb.querySelector(".demo-cta"), lb.querySelector(".demo-dock-grid")]
    .filter(Boolean).map(el => {
      const slot = document.createComment("player layout home"); el.before(slot);
      return { el, slot };
    });
  const fittedLabels = new WeakMap();
  let fontRevision = 0;
  const fitMobileModel = () => {
    const compact = mq.matches && lb.classList.contains("minimized");
    const singleLine = mq.matches && !lb.classList.contains("minimized") && !lb.classList.contains("buying") && mobileProduct.classList.contains("has-buy");
    for (const [selector, lines, floor] of [[".demo-mini-name", 1, 11], [".demo-mini-scale", 2, 7]]) {
      const el = mobileProduct.querySelector(selector);
      if (!el) continue;
      const key = [el.clientWidth, innerWidth, compact, singleLine, el.textContent, fontRevision].join("|");
      if (fittedLabels.get(el) === key) continue;
      fittedLabels.set(el, key);
      el.style.removeProperty("--mini-fit-size");
      if ((!compact && !singleLine) || !el.clientWidth) continue;
      const max = parseFloat(getComputedStyle(el).fontSize);
      if (singleLine) {
        let size = max;
        // Measure each label separately; never enlarge past its CSS size.
        for (let pass = 0; pass < 3 && el.scrollWidth > el.clientWidth; pass++) {
          size *= Math.max(1, el.clientWidth - 2) / el.scrollWidth;
          el.style.setProperty("--mini-fit-size", size + "px");
        }
        continue;
      }
      const fits = size => {
        el.style.setProperty("--mini-fit-size", size + "px");
        const lineHeight = parseFloat(getComputedStyle(el).lineHeight);
        return el.scrollWidth <= el.clientWidth + 1 && el.getBoundingClientRect().height <= lineHeight * lines + 1;
      };
      if (fits(max)) continue;
      let low = Math.min(floor, max), high = max;
      while (high - low > 0.25) {
        const mid = (low + high) / 2;
        if (fits(mid)) low = mid; else high = mid;
      }
      el.style.setProperty("--mini-fit-size", low + "px");
    }
  };
  const layoutMobile = () => {
    const mobile = mq.matches, wasMobile = lb.classList.contains("mobile-player");
    lb.classList.toggle("mobile-player", mobile);
    lb.classList.toggle("mobile-intro", cfg.mobileIntro === true);
    lb.classList.toggle("mobile-swap", cfg.mobileSwap === true);
    if (mobile) {
      if (artistBox.parentElement !== scroller) scroller.append(tabsWrap, artistBox);
      if (scroller.parentElement !== mobileMeta) {
        mobileMeta.prepend(scroller);
        mobileHomes.filter(x => x.el.matches(".demo-mini-info,.demo-cta")).forEach(x => mobileProduct.append(x.el));
        panel.append(lb.querySelector(".demo-dock-grid"));
      }
      video.controls = !lb.classList.contains("minimized");
      video.disableRemotePlayback = lb.classList.contains("minimized");
      mobileProduct.classList.toggle("has-buy", (!!buyCtx || !!shop) && !!lb.querySelector(".demo-cta"));
    } else if (wasMobile) {
      mobileHomes.forEach(({el,slot}) => slot.after(el));
      scroller.append(tabsWrap, artistBox);
      video.controls = true; video.disableRemotePlayback = false;
    }
    // Keep the favourite beside the title while ordering on desktop.
    const purchaseHeart = lb.querySelector(".demo-cta-heart");
    if (purchaseHeart) {
      if (!purchaseHeart.__home) {
        purchaseHeart.__home = document.createComment("purchase heart home");
        purchaseHeart.before(purchaseHeart.__home);
      }
      if (!mobile && lb.classList.contains("buying") && !lb.classList.contains("minimized")) {
        const home = lb.querySelector(".demo-mini-info");
        if (purchaseHeart.parentElement !== home) home.append(purchaseHeart);
      } else if (purchaseHeart.__home.isConnected && purchaseHeart.__home.nextSibling !== purchaseHeart) purchaseHeart.__home.after(purchaseHeart);
    }
    fitMobileModel();
    if (mobile && lb.classList.contains("minimized")) {
      const subtitle = mobileProduct.querySelector(".demo-mini-scale");
      if (subtitle) panel.style.setProperty("--mini-controls-top", (subtitle.getBoundingClientRect().bottom - panel.getBoundingClientRect().top - 28) + "px");
    } else panel.style.removeProperty("--mini-controls-top");
    updateFade();
  };
  const layoutDeck = () => {
    if (!deck || !lb.isConnected) return;
    layoutMobile();
    lb.classList.toggle("deck", !mq.matches);
    if (mq.matches) { lb.classList.remove("grid-active"); return; }
    // Keep the real controls and artist information in the right host when
    // resizing across the mobile breakpoint; never replace the playing video.
    if (lb.classList.contains("minimized")) {
      const info = lb.querySelector(".demo-mini-info");
      if (mq.matches && artistBox.parentElement !== info) info.querySelector(".demo-mini-actions").before(tabsWrap, artistBox);
      if (!mq.matches && artistBox.parentElement !== scroller) scroller.append(tabsWrap, artistBox);
      video.controls = !mq.matches;
      video.disableRemotePlayback = mq.matches;
    }
    const grid = inGrid();
    lb.classList.toggle("grid-active", grid);

    if (grid) return layoutGrid();
    deck.scrollTop = 0;
    slides.forEach(el => { el.style.width = ""; el.style.height = ""; });
    const vr = video.getBoundingClientRect();
    const pr = (stage || panel).getBoundingClientRect();
    if (!vr.width) return;                       // not laid out yet
    // The video IS the playing card, already grown by the boost. A card behind is
    // the base size the boost was applied to — deriving it back means growing the
    // playing clip leaves the others exactly where they were, rather than dragging
    // the whole deck up with it.
    const bst = boost;   // both sizes of the carousel grow the playing card alone
    const baseW = vr.width / bst, baseH = vr.height / bst;
    deck.style.width = baseW + "px";
    deck.style.height = baseH + "px";
    deck.style.left = Math.round(vr.left - pr.left + (vr.width - baseW) / 2) + "px";
    // In the bar the cards stand on the clip's bottom edge, which is what makes
    // the strip read as one row. Maximized, the clip now runs nearly the whole
    // height, so sharing its baseline left the smaller cards hanging at the
    // floor — there they centre on the clip instead, which puts them back in
    // the middle of the screen and stays right at any height.
    deck.style.top = Math.round(lb.classList.contains("minimized")
      ? vr.bottom - pr.top - baseH
      : vr.top - pr.top + (vr.height - baseH) / 2) + "px";
    if (nowName) {   // rides the playing clip's own lower edge
      nowName.style.left = Math.round(vr.left - pr.left) + "px";
      nowName.style.top = Math.round(vr.bottom - pr.top) + "px";
      nowName.style.width = vr.width + "px";
      nowName.textContent = model.videos[current()].artist;
    }
    const cur = current();
    // 200px of bar and 900px of screen are not the same picture: dimming that
    // reads as depth on the big one can leave the small one's cards as smudges,
    // so docked has its own number. The bar and the micro player share it.
    const dim = lb.classList.contains("minimized") ? cfg.barDim : cfg.dim;
    const each = Math.floor((Math.max(3, cfg.cards) - 1) / 2);
    const step = cfg.scale / 100, gap = cfg.gap;
    slides.forEach((el, i) => {
      const o = i - cur, a = Math.abs(o);
      // A card past the last visible step is parked one step further out rather
      // than at the centre, so it slides in from off the deck instead of growing
      // out of the middle of the pile.
      const steps = Math.min(a, each + 1);
      // laid edge to edge outward from the playing card, each one smaller than the
      // last, so the gap between any two neighbours is the gap and nothing else
      let edge = vr.width / 2, x = 0, sc = bst;
      for (let k = 1; k <= steps; k++) {
        sc = Math.pow(step, k);
        const w = baseW * sc;
        x = edge + gap + w / 2;
        edge += gap + w;
      }
      el.style.transform = `translateX(${(o < 0 ? -x : x).toFixed(1)}px) ` +
        `translateY(${(-cfg.lift * steps).toFixed(1)}px) scale(${sc.toFixed(3)})`;
      el.style.opacity = a > each ? "0" : a === 0 ? "1" : Math.pow(dim / 100, a).toFixed(3);
      // the centre belongs to the video on top of it; the far ones are not there
      el.style.pointerEvents = (a === 0 || a > each) ? "none" : "auto";
      el.style.zIndex = String(20 - a);
      el.tabIndex = a > 0 && a <= each ? 0 : -1;
      el.setAttribute("aria-hidden", String(a === 0 || a > each));
    });
    if (!lb.classList.contains("minimized")) fitExpandedFade();
  };

  // The ramp is hung above whichever block reaches highest — measured, because
  // only the laid-out text knows where it falls, and the buy block's height is
  // the shop's, not ours. Capped, so a tall one can never black out the deck.
  const fitExpandedFade = () => {
    const pr = panel.getBoundingClientRect();
    const tops = [".demo-scroll", ".demo-mini-info"]
      .map(s => lb.querySelector(s))
      .filter(el => el && el.offsetParent)
      .map(el => el.getBoundingClientRect().top);
    if (!tops.length || !pr.height) return;
    const ramp = 64;
    const h = pr.bottom - (Math.min(...tops) - 10 - ramp);
    panel.style.setProperty("--fade-len", ramp + "px");
    panel.style.setProperty("--exp-fade",
      Math.round(Math.min(Math.max(h, 0), pr.height * 0.45)) + "px");
  };

  const dockRail = lb.querySelector(".demo-dock-grid");
  const dockWindow = lb.querySelector(".demo-dock-window");
  const dockClips = [...lb.querySelectorAll(".demo-dock-clip")];

  const inDockGrid = () => canDockGrid && (mq.matches || lb.classList.contains("minimized"));
  let dockRows = 1, dockSelection = -1, dockSize = "", dockFadeDepth = null;
  const dockMotion = () => matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth";
  const dockEdges = () => {
    if (!dockWindow) return;
    const max = Math.max(0, dockWindow.scrollWidth - dockWindow.clientWidth);
    dockRail.querySelector(".demo-dock-prev").disabled = dockWindow.scrollLeft <= 1;
    dockRail.querySelector(".demo-dock-next").disabled = dockWindow.scrollLeft >= max - 1;
  };
  const centreDockClip = (i, behavior = dockMotion()) => {
    const item = dockClips[i];
    if (!item || !inDockGrid()) return;
    const ir = item.getBoundingClientRect(), wr = dockWindow.getBoundingClientRect();
    const left = Math.max(0, Math.min(dockWindow.scrollWidth - dockWindow.clientWidth,
      dockWindow.scrollLeft + ir.left + ir.width / 2 - wr.left - wr.width / 2));
    dockWindow.scrollTo({ left, behavior });
    dockEdges();
  };
  const layoutDock = () => {
    if (!dockRail || !lb.isConnected) return;
    const on = inDockGrid();
    const was = lb.classList.contains("dock-grid");
    if (on && !was && !mq.matches) {
      const fade = parseFloat(panel.style.getPropertyValue("--fade-top"));
      dockFadeDepth = Number.isFinite(fade) ? innerHeight - panel.getBoundingClientRect().top - fade : null;
    }
    lb.classList.toggle("dock-grid", on && lb.classList.contains("minimized"));
    dockRail.hidden = !on;
    if (!on) { dockSelection = -1; dockFadeDepth = null; return; }
    if (mq.matches) {
      layoutMobile(); dockRows = 1;
      dockRail.style.cssText = "";
      dockRail.classList.remove("all-fit");
      const cur = current(), size = dockWindow.clientWidth + ":" + lb.classList.contains("minimized");
      dockClips.forEach((el,i) => { el.classList.toggle("active",i===cur);el.setAttribute("aria-current",String(i===cur)); });
      if (cur !== dockSelection || size !== dockSize) centreDockClip(cur, size === dockSize ? dockMotion() : "auto");
      dockSelection = cur; dockSize = size; dockEdges(); updateFade(); return;
    }
    const vr = video.getBoundingClientRect(), pr = panel.getBoundingClientRect();
    const info = lb.querySelector(".demo-mini-info"), scroll = lb.querySelector(".demo-scroll");
    let left = 12, right = innerWidth - 12, ceiling;
    if (!mq.matches) {
      const mirrored = lb.classList.contains("bar-mirror");
      const sideRight = !mirrored;
      left = sideRight ? Math.max(16, vr.right + 24) : 16;
      right = sideRight ? innerWidth - 16 : Math.min(innerWidth - 16, vr.left - 24);
      // Keep the two identity blocks together on the free side of the video.
      // Transforms preserve the original grid's video position and bar height.
      const room = Math.max(120, right - left - 82), gap = 18;
      const modelWidth = Math.min(cfg.barSide || 300, Math.max(100, room * 0.52));
      const artistWidth = Math.min(cfg.barSide || 300, Math.max(70, room - modelWidth - gap));
      const groupWidth = artistWidth + gap + modelWidth;
      const tile = Math.max(66, Math.min(112, Math.max(80, vr.height)) * 9 / 16);
      const desiredStrip = dockClips.length * (tile + 8) - 8 + 20;
      const centre = innerWidth / 2;
      const groupStart = sideRight
        ? Math.min(right - 82 - groupWidth, Math.max(centre, left + desiredStrip))
        : Math.max(left + 82, Math.min(centre - groupWidth, right - desiredStrip - groupWidth));
      const modelX = sideRight ? groupStart + artistWidth + gap : groupStart;
      const artistX = sideRight ? groupStart : groupStart + modelWidth + gap;
      const priorModel = parseFloat(lb.style.getPropertyValue("--dock-model-x")) || 0;
      const priorArtist = parseFloat(lb.style.getPropertyValue("--dock-artist-x")) || 0;
      const modelOrigin = info.getBoundingClientRect().left - priorModel;
      const artistOrigin = scroll.getBoundingClientRect().left - priorArtist;
      lb.style.setProperty("--dock-model-width", modelWidth + "px");
      lb.style.setProperty("--dock-artist-width", artistWidth + "px");
      lb.style.setProperty("--dock-model-x", (modelX - modelOrigin) + "px");
      lb.style.setProperty("--dock-artist-x", (artistX - artistOrigin) + "px");
      // The rail lives horizontally between the video and the identity group.
      const groupEnd = groupStart + artistWidth + gap + modelWidth;
      const stripLeft = sideRight ? left : groupEnd + 20;
      const stripRight = sideRight ? groupStart - 20 : right;
      ceiling = vr.bottom;
      if (stripRight - stripLeft >= 140) {
        left = stripLeft; right = stripRight;
      } else {
        // Narrow layouts keep a usable row above the text instead of overlap.
        ceiling = Math.min(info.getBoundingClientRect().top, scroll.getBoundingClientRect().top) - 14;
      }
      if (dockFadeDepth !== null) {
        const line = parseFloat(panel.style.getPropertyValue("--fade-top")) || 0;
        panel.style.setProperty("--fade-top", Math.max(line, innerHeight - dockFadeDepth - pr.top) + "px");
      }
    } else ceiling = pr.top - 10;
    if (right - left < 160) { left = 12; right = innerWidth - 12; ceiling = Math.min(ceiling, vr.top - 12); }
    dockRows = 1;
    const h = Math.min(112, Math.max(80, vr.height));
    const railHeight = dockRows * h + (dockRows - 1) * 8;
    const tileWidth = Math.max(66, h * 9 / 16);
    const available = Math.max(120, right - left);
    const railWidth = available;
    const allFit = dockClips.length * (tileWidth + 8) - 8 <= available;
    dockRail.classList.toggle("all-fit", allFit);
    dockRail.style.left = left + "px";
    dockRail.style.width = railWidth + "px";
    dockRail.style.top = Math.max(8, ceiling - railHeight) + "px";
    dockRail.style.height = railHeight + "px";
    dockRail.style.setProperty("--dock-rows", dockRows);
    dockRail.style.setProperty("--dock-tile-height", h + "px");
    dockRail.style.setProperty("--dock-tile-width", Math.max(66, h * 9 / 16) + "px");
    const size = [left, right, h, dockRows, railWidth].join(":");
    const cur = current();
    dockClips.forEach((el, i) => { el.classList.toggle("active", i === cur); el.setAttribute("aria-current", String(i === cur)); });
    if (cur !== dockSelection || size !== dockSize || !was) centreDockClip(cur, was && size === dockSize ? dockMotion() : "auto");
    dockSelection = cur; dockSize = size; dockEdges();
  };
  if (dockRail) {

    dockClips.forEach((el, i) => el.addEventListener("click", e => {
      e.stopPropagation();
      if (i === current()) { centreDockClip(i); video.play().catch(() => {}); }
      else select(i);
    }));
    dockWindow.addEventListener("scroll", dockEdges, { passive: true });
    dockRail.addEventListener("keydown", e => {
      const tile = e.target.closest(".demo-dock-clip");
      if (!tile) return;
      if (e.key === "Escape") return;
      e.stopPropagation();
      const delta = { ArrowLeft: -dockRows, ArrowRight: dockRows, ArrowUp: -1, ArrowDown: 1 }[e.key];
      let i = +tile.dataset.i;
      if (delta !== undefined) i = Math.max(0, Math.min(dockClips.length - 1, i + delta));
      else if (e.key === "Home") i = 0;
      else if (e.key === "End") i = dockClips.length - 1;
      else return;
      e.preventDefault(); dockClips[i].focus({ preventScroll: true }); centreDockClip(i);
    });
    for (const [selector, dir] of [[".demo-dock-prev", -1], [".demo-dock-next", 1]]) {
      dockRail.querySelector(selector).addEventListener("click", e => {
        e.stopPropagation(); dockWindow.scrollBy({ left: dir * dockWindow.clientWidth * 0.75, behavior: dockMotion() });
      });
    }
    let drag = null, dragged = false;
    dockWindow.addEventListener("pointerdown", e => {
      if (e.pointerType !== "mouse" || e.button !== 0) return;
      drag = { x: e.clientX, scroll: dockWindow.scrollLeft, id: e.pointerId }; dragged = false;
    });
    dockWindow.addEventListener("pointermove", e => {
      if (!drag) return;
      if (Math.abs(e.clientX - drag.x) > 6) { dragged = true; dockWindow.setPointerCapture(e.pointerId); }
      if (dragged) { e.preventDefault(); dockWindow.scrollLeft = drag.scroll + drag.x - e.clientX; }
    });
    const endDrag = () => { drag = null; };
    dockWindow.addEventListener("pointerup", endDrag); dockWindow.addEventListener("pointercancel", endDrag);
    dockWindow.addEventListener("pointerleave", e => { if (!dockWindow.hasPointerCapture(e.pointerId)) endDrag(); });
    dockWindow.addEventListener("click", e => { if (dragged) { e.preventDefault(); e.stopPropagation(); dragged = false; } }, true);
    dockWindow.addEventListener("dragstart", e => e.preventDefault());
    dockWindow.addEventListener("wheel", e => {
      if (e.ctrlKey || Math.abs(e.deltaX) >= Math.abs(e.deltaY)) return;
      const before = dockWindow.scrollLeft;
      dockWindow.scrollLeft += e.deltaY;
      if (dockWindow.scrollLeft !== before) e.preventDefault();
    }, { passive: false });
  }

  const layoutBar = () => {
    const info = lb.querySelector(".demo-mini-info");
    const scroll = lb.querySelector(".demo-scroll");
    const topBar = lb.querySelector(".demo-top");
    if (!deck || !info || !scroll) { layoutDock(); return; }
    const inBar = lb.classList.contains("minimized") && !mq.matches;
    if (!inBar) {                        // the sheet and the phone keep their own layout
      if (!inGrid()) scroll.style.height = "";
      if (topBar) topBar.style.top = "";
      layoutDock();
      return;
    }
    const cta = lb.querySelector(".demo-cta");
    const ir = info.getBoundingClientRect();
    if (!ir.height) return;
    const cr = cta && cta.getBoundingClientRect();
    const bottom = cr && cr.height ? cr.bottom : ir.bottom;
    scroll.style.height = Math.round(bottom - ir.top) + "px";
    const pr = panel.getBoundingClientRect();
    const line = Math.round(ir.top - pr.top);
    if (topBar) {
      // back at the bar's right end, on the line the names start — CSS holds the
      // right edge, only the height has to be measured
      topBar.style.left = "";
      topBar.style.top = Math.max(0, info.querySelector(".demo-mini-name").getBoundingClientRect().top - pr.top) + "px";
    }
    // Mirrored, the artist's OUTER edge has to land on the middle the same way its
    // inner edge does unmirrored. CSS cannot quite do it: the stage column is
    // measured from the window (50vw) while the panel's right edge stops short of
    // it by the scrollbar, so the mirror came out a scrollbar's width shallow.
    // Measured here instead, from the panel's own right edge.
    if (lb.classList.contains("bar-mirror") && lb.classList.contains("bar-left")) {
      const gap = parseFloat(getComputedStyle(panel).columnGap) || 0;
      const artistRight = innerWidth / 2 - cfg.artistX;   // x walks it left, mirrored
      panel.style.setProperty("--mirror-stage",
        Math.max(0, Math.round(pr.right - artistRight - gap)) + "px");
    } else {
      panel.style.removeProperty("--mirror-stage");
    }
    // the column stands beside the clip's top-left corner, or on the other side of
    // it once the bar is mirrored — always on the outside, never over the deck
    const side = lb.querySelector(".demo-side");
    if (side) {
      const vr = video.getBoundingClientRect();
      const sw = side.getBoundingClientRect().width || 34;
      const mirrored = lb.classList.contains("bar-mirror");
      const outside = mirrored
        ? Math.round(vr.right - pr.left + 10)
        : Math.round(vr.left - pr.left - sw - 10);
      const room = mirrored ? outside + sw <= pr.width - 8 : outside >= 8;
      side.classList.toggle("on-clip", !room);
      side.style.top = Math.round(vr.top - pr.top + (room ? 0 : 6)) + "px";
      side.style.left = (room ? outside
        : Math.round(mirrored ? vr.right - pr.left - sw - 6 : vr.left - pr.left + 6)) + "px";
    }
    // the scrim starts on that same line, so the fade ends exactly where the
    // reading starts and the clip above it is not sitting on a dark band
    panel.style.setProperty("--fade-top", line + "px");
    layoutDock();
  };

  // put the playing artist's pill in the MIDDLE of the strip, rather than merely
  // inside its edge, where it read as half-hidden. The browser clamps at both
  // ends, so the first and last pills come as close to centre as the scroll
  // range allows. Strip only, never the page — which is why this measures and
  // scrolls by hand instead of calling scrollIntoView.
  const centreActivePill = (pill, behavior) => {
    const wrap = pill.closest(".demo-tabs");   // the scroller, not the pill's row
    const pr = pill.getBoundingClientRect(), wr = wrap.getBoundingClientRect();
    if (wrap.scrollWidth > wrap.clientWidth + 2) {
      const dx = (pr.left + pr.right) / 2 - (wr.left + wr.right) / 2;
      if (Math.abs(dx) > 1) wrap.scrollBy({ left: dx, behavior });
    }
    // the desktop corner's strip can still be the vertical kind
    if (wrap.scrollHeight > wrap.clientHeight + 2) {
      const dy = (pr.top + pr.bottom) / 2 - (wr.top + wr.bottom) / 2;
      if (Math.abs(dy) > 1) wrap.scrollBy({ top: dy, behavior });
    }
  };
  const select = i => {
    const n = (i + model.videos.length) % model.videos.length;
    tabEls.forEach(t => t.classList.remove("active"));
    tabEls[n].classList.add("active");
    if (deck && !inGrid() && !inDockGrid()) {
      // fade to the poster underneath, swap, come back when there are pixels
      video.style.opacity = "0";
      video.addEventListener("loadeddata", () => { video.style.opacity = ""; }, { once: true });
      layoutDeck();
    } else { video.style.opacity = ""; }
    // end-of-clip autoplay moves the selection with nobody's finger on the strip
    centreActivePill(tabEls[n], "smooth");
    dotEls.forEach((d, di) => d.classList.toggle("on", di === n));
    const v = model.videos[n];
    video.poster = posterOf(v.file);
    video.src = v.file;
    // autoplay refused (un-gestured after src swap, e.g. iOS): rest on the poster, one tap resumes
    video.play().catch(() => {});
    markWatched(v.file);
    watchTracker.start(videoId(v.file));   // closes the books on the previous clip
    artistBox.innerHTML = artistInfoHTML(v.artist);
    scroller.scrollTop = 0;
    layoutDeck();
    revealGridSelection();
    layoutBar();   // a different bio is a different height for the two to share
    updateFade();
    warmNeighbors(n);
  };
  const current = () => tabEls.findIndex(t => t.classList.contains("active"));
  // slide the next clip in — shared by swipe commits and end-of-clip autoplay
  const slideTo = dir => {
    if ((deck && !mq.matches) || inDockGrid()) { video.style.transform = ""; return select(current() + dir); }   // the deck carries the motion
    const w = video.getBoundingClientRect().width * 0.6;
    video.style.transition = "transform 0.22s ease, opacity 0.22s ease";
    video.style.transform = `translateX(${-dir * w}px)`;
    video.style.opacity = "0.2";
    setTimeout(() => {
      video.style.transition = "none";
      video.style.transform = `translateX(${dir * w}px)`;
      select(current() + dir);
      requestAnimationFrame(() => requestAnimationFrame(() => {
        video.style.transition = "transform 0.22s ease, opacity 0.22s ease";
        video.style.transform = "translateX(0)";
        video.style.opacity = "1";
      }));
    }, 220);
  };
  // every clip flows into the next; the last wraps back to the first
  if (model.videos.length > 1) video.addEventListener("ended", () => {
    // the deck has hard ends, so "next" from the last is a decision rather than
    // arithmetic: wrap back to the first, or rest on the last frame
    if (!cfg.endWrap && current() === model.videos.length - 1) return;
    slideTo(1);
  });
  const onKey = e => {
    if (e.key === "Escape") return close();
    if (e.target.closest?.(".demo-dock-grid")) return;
    if (inGrid() && e.target.closest?.(".demo-slide")) {
      const step = { ArrowRight: 1, ArrowLeft: -1, ArrowDown: gridColumns, ArrowUp: -gridColumns }[e.key];
      if (!step) return;
      e.preventDefault();
      const i = +e.target.closest(".demo-slide").dataset.i;
      slides[Math.max(0, Math.min(slides.length - 1, i + step))].focus({ preventScroll: true });
      const item = document.activeElement.getBoundingClientRect(), box = deck.getBoundingClientRect();
      if (item.top < box.top) deck.scrollTop += item.top - box.top;
      else if (item.bottom > box.bottom) deck.scrollTop += item.bottom - box.bottom;
      return;
    }
    if (e.target.closest?.("input, select, textarea, video, [contenteditable=true]")) return;
    if (e.key === "ArrowRight") { e.preventDefault(); select(current() + 1); }
    else if (e.key === "ArrowLeft") { e.preventDefault(); select(current() - 1); }
  };
  document.addEventListener("keydown", onKey);
  lb.querySelector(".demo-backdrop").addEventListener("click", close);
  lb.querySelector(".demo-close").addEventListener("click", close);
  tabEls.forEach(tab => tab.addEventListener("click", () => select(+tab.dataset.i)));
  slides.forEach(sl => sl.addEventListener("click", () => {
    if (inGrid() && +sl.dataset.i === current()) return video.play().catch(() => {});
    select(+sl.dataset.i);
  }));
  ["play", "pause", "ended"].forEach(event => video.addEventListener(event, markGridSelection));

  // the bar's column: two of these repeat the pair at the other end on purpose —
  // whichever corner the eye is in, the way out is in it
  {
    const on = (sel, fn) => lb.querySelector(sel)?.addEventListener("click", e => {
      e.stopPropagation();
      fn();
    });
    const settle = () => { layoutDeck(); layoutBar(); };
    on(".demo-side-close", close);
    on(".demo-side-max", () => btnMin.click());
    // mirror: the clip changes ends and everything beside it follows, so the page
    // can be read on whichever side the player is not
    on(".demo-side-mirror", () => {
      const mirrored = lb.classList.toggle("bar-mirror");
      // the arrow points where the clip is going, so it turns around with it
      const b = lb.querySelector(".demo-side-mirror");
      b.innerHTML = mirrored ? DEMO_ICON_LEFT : DEMO_ICON_RIGHT;
      b.setAttribute("aria-label", mirrored ? AYASA_t("js.core.back_to_left") : AYASA_t("js.core.mirror_bar"));
      settle();
    });
    // and the small player: 120px of clip and one way back, for when the bar is
    // in the way of the very page it is selling
    on(".demo-side-small", () => { lb.classList.add("bar-compact"); settle(); });
    // one rung, not all the way out: micro came from the bar, so it goes back to it
    on(".demo-side-back", () => { lb.classList.remove("bar-compact"); settle(); });
  }
  // Resize/observer bursts share one layout pass; direct interaction layouts
  // stay synchronous so selection, swipe and purchase geometry remain correct.
  let layoutFrame = 0;
  const schedulePlayerLayout = () => {
    if (layoutFrame || !lb.isConnected) return;
    layoutFrame = requestAnimationFrame(() => {
      layoutFrame = 0;
      if (lb.isConnected) { layoutDeck(); layoutBar(); updateFade(); }
    });
  };
  const onMediaVisibility = () => { if (document.hidden) clearWarmNeighbors(); };
  document.addEventListener("visibilitychange", onMediaVisibility);
  lb.__offResize = () => {
    cancelAnimationFrame(layoutFrame);
    document.removeEventListener("visibilitychange", onMediaVisibility);
  };
  // the cards are measured from the video, so anything that resizes it moves them
  if (deck) {
    const onResize = schedulePlayerLayout;
    addEventListener("resize", onResize, { passive: true });
    const cleanup = lb.__offResize;
    lb.__offResize = () => { cleanup(); removeEventListener("resize", onResize); };
    // a clip of any shape fills its card: with a definite height and the real
    // aspect ratio, width follows and the black bars have nowhere to appear
    const fitCard = () => {
      if (!video.videoWidth) return;
      video.style.aspectRatio = video.videoWidth + " / " + video.videoHeight;
      schedulePlayerLayout();
    };
    video.addEventListener("loadedmetadata", fitCard);
    fitCard();
    // The buy block's height is the shop's business and it arrives late — the
    // price, the case options, a sold-out line. Both the bar's name line and the
    // fade above the words are measured from it, so they are re-measured when it
    // actually settles rather than at a moment we guessed. Neither layout resizes
    // these two, so there is no loop to fall into.
    if (typeof ResizeObserver === "function") {
      const ro = new ResizeObserver(schedulePlayerLayout);
      [".demo-mini-info", ".demo-cta"].forEach(s => {
        const el = lb.querySelector(s);
        if (el) ro.observe(el);
      });
      const off = lb.__offResize;
      lb.__offResize = () => { off && off(); ro.disconnect(); };
    }
  }

  if (dockRail && !deck) {
    const oldOff = lb.__offResize;
    addEventListener("resize", schedulePlayerLayout, { passive: true });
    lb.__offResize = () => { oldOff && oldOff(); removeEventListener("resize", schedulePlayerLayout); };
  }

  {
    const resized = schedulePlayerLayout;
    const ro = new ResizeObserver(updateFade);
    ro.observe(scroller); ro.observe(artistBox);
    document.addEventListener("fullscreenchange", resized);
    window.visualViewport?.addEventListener("resize", resized);
    const off = lb.__offResize;
    lb.__offResize = () => {
      off?.(); ro.disconnect(); document.removeEventListener("fullscreenchange", resized);
      window.visualViewport?.removeEventListener("resize", resized);
    };
  }

  // touch, full player: ← → swipe changes clips (follows the finger, commits
  // past a quarter screen or a flick, rubber-bands at the ends); on mobile a
  // vertical drag moves the whole panel — ↓ tucks it into the footer,
  // ↑ (a decisive pull) closes it, anything less springs back.
  // These live on the PANEL, not the video: a finger that lands on the shop
  // button or the artist pills expects the sheet to move too, and a sheet that
  // only responds over the video reads as a sheet that does not move at all —
  // which is how the minimize gesture stayed undiscovered. Nothing locks until
  // the finger has travelled 12px, so every tap underneath still lands.
  {
    const max = model.videos.length - 1;
    let sx = 0, sy = 0, lock = null, dx = 0, dy = 0, lastX = 0, lastY = 0, lastT = 0, vx = 0, vy = 0;
    let noH = false, inScroller = false, onVideo = false;
    // The control bar is only DRAGGABLE — scrubbable — once a tap has brought it
    // up, so the strip above it can carry the swipe the rest of the time. There is
    // no API for native control visibility, so this models it: up while paused
    // (they stay up then), and for a few seconds after a tap on the video, which is
    // about when both iOS and Android auto-hide them. Deliberately biased towards
    // "up": guessing that way merely ignores a swipe, which is what the whole strip
    // used to do, while guessing the other way steals a scrub and loses the
    // viewer's place in the clip.
    const CONTROLS_LINGER = 4000;
    let lastVideoTap = 0;
    const controlsProbablyUp = () => video.paused || Date.now() - lastVideoTap < CONTROLS_LINGER;
    const atEdge = d => (d > 0 && current() === 0) || (d < 0 && current() === max);
    const springBack = () => {
      video.style.transition = "transform 0.3s ease";
      video.style.transform = "translateX(0)";
    };
    // a gesture that commits must not also fire the control it happened to end
    // on: those controls are a navigation and a purchase. preventDefault during
    // the drag suppresses the click on most engines, but not dependably enough
    // to gamble a cart on, so the next click is swallowed explicitly.
    let swallow = false, swallowT = 0;
    const swallowNextClick = () => {
      swallow = true;
      clearTimeout(swallowT);
      swallowT = setTimeout(() => { swallow = false; }, 500);
    };
    panel.addEventListener("click", e => {
      if (!swallow) return;
      swallow = false;
      clearTimeout(swallowT);
      e.preventDefault();
      e.stopPropagation();
    }, true);   // capture — ahead of any button's own handler
    // a bottom sheet may only be pulled down from the top of its content, or
    // dragging down to read the artist bio would dismiss the player instead
    const vOK = d => {
      if (!inScroller) return true;
      if (scroller.scrollHeight <= scroller.clientHeight + 2) return true;
      return scroller.scrollTop <= 0 && d > 0;
    };
    // the whole sheet is grabbable, minus the regions that own the same gesture.
    // Stated once here rather than re-decided per element, so the sheet can gain
    // content later without every new part needing its own wiring.
    panel.addEventListener("touchstart", e => {
      lock = null;
      if (lb.classList.contains("minimized") || e.touches.length !== 1) return;
      const t = e.touches[0], tgt = e.target;
      // the buying sheet's options block is its own scroller full of controls —
      // never move or dismiss the player from in there, mid-purchase
      if (tgt.closest?.(".demo-cta-casewrap") || (inGrid() && tgt.closest?.(".demo-deck"))) return;
      // the control bar's own strip, but only while the bar is actually up:
      // 48px is its real height, where the old 64 left ~18px of picture above it
      // that silently swallowed swipes
      onVideo = tgt === video;
      if (onVideo && t.clientY > video.getBoundingClientRect().bottom - 48 && controlsProbablyUp()) return;
      noH = !!tgt.closest?.(".demo-tabs,.demo-dock-grid");    // the pill strip owns sideways
      inScroller = !!tgt.closest?.(".demo-scroll");
      sx = lastX = t.clientX; sy = lastY = t.clientY; dx = 0; dy = 0; vx = 0; vy = 0; lastT = e.timeStamp;
      lock = "?";
    }, { passive: true });
    panel.addEventListener("touchmove", e => {
      if (lock === null) return;
      const t = e.touches[0];
      dx = t.clientX - sx;
      dy = t.clientY - sy;
      if (lock === "?") {
        if (Math.abs(dx) < 12 && Math.abs(dy) < 12) return;
        lock = Math.abs(dx) > Math.abs(dy)
          // single-clip players have nothing to swipe to, and on the pill strip
          // sideways is its own scroll — leaving it unlocked lets that happen
          ? (max > 0 && !noH ? "h" : null)
          : (mq.matches && vOK(dy) ? "v" : null);   // vertical is mobile-only
        if (lock === null) return;
      }
      e.preventDefault();
      vx = (t.clientX - lastX) / Math.max(1, e.timeStamp - lastT);
      vy = (t.clientY - lastY) / Math.max(1, e.timeStamp - lastT);
      lastX = t.clientX; lastY = t.clientY; lastT = e.timeStamp;
      if (lock === "h") {
        video.style.transition = "none";
        video.style.transform = `translateX(${dx * (atEdge(dx) ? 0.25 : 0.9)}px)`; // rubber-band at the ends
      } else {
        panel.style.transition = "none";
        panel.style.transform = `translateY(${dy * 0.9}px)`;
        // pulling up previews the close — the panel starts letting go
        panel.style.opacity = dy < 0 ? String(Math.max(0.35, 1 + dy / 450)) : "1";
      }
    }, { passive: false });
    const onRelease = () => {
      const l = lock;
      lock = null;
      // a touch on the video that never travelled 12px was a tap, and a tap is what
      // brings the controls up — from here the bottom strip yields to scrubbing
      if (l === "?" && onVideo) lastVideoTap = Date.now();
      if (l === "h") {
        const commit = !atEdge(dx) &&
          (Math.abs(dx) > Math.min(innerWidth / 4, 140) || (Math.abs(vx) > 0.5 && Math.abs(dx) > 40));
        if (!commit) return springBack();
        slideTo(dx < 0 ? 1 : -1);
        swallowNextClick();
      } else if (l === "v") {
        const closeIt = dy < -160 || (vy < -0.8 && dy < -80);   // close needs a decisive pull
        const minimizeIt = dy > 90 || (vy > 0.5 && dy > 50);
        if (closeIt) {
          panel.style.transition = "transform 0.22s ease, opacity 0.22s ease";
          panel.style.transform = "translateY(-40vh)";
          panel.style.opacity = "0";
          setTimeout(close, 200);
          swallowNextClick();
        } else if (minimizeIt) {
          panel.style.transition = panel.style.transform = panel.style.opacity = "";
          btnMin.click();       // synchronous, so it runs BEFORE the flag is set…
          swallowNextClick();   // …and the flag then catches the real deferred click
        } else {
          panel.style.transition = "transform 0.25s ease, opacity 0.25s ease";
          panel.style.transform = "translateY(0)";
          panel.style.opacity = "1";
          setTimeout(() => { panel.style.transition = panel.style.transform = panel.style.opacity = ""; }, 280);
        }
      }
    };
    panel.addEventListener("touchend", onRelease);
    panel.addEventListener("touchcancel", () => { lock = null; springBack(); panel.style.transition = panel.style.transform = panel.style.opacity = ""; });
    if (max > 0) warmNeighbors(start);
  }

  // touch, footer bar: dragging it down slides it off — dismissed
  {
    let fy = 0, fOn = false, fdy = 0, fLastY = 0, fLastT = 0, fvy = 0;
    panel.addEventListener("touchstart", e => {
      fOn = false;
      if (!mq.matches || !lb.classList.contains("minimized") || e.touches.length !== 1) return;
      if (e.target.closest?.(".demo-scroll,.demo-dock-grid")) return;
      fy = fLastY = e.touches[0].clientY; fdy = 0; fvy = 0; fLastT = e.timeStamp;
      fOn = true;
    }, { passive: true });
    panel.addEventListener("touchmove", e => {
      if (!fOn) return;
      const t = e.touches[0];
      fdy = t.clientY - fy;
      if (fdy < 8) return; // only downward drags are the dismiss gesture
      e.preventDefault();
      fvy = (t.clientY - fLastY) / Math.max(1, e.timeStamp - fLastT);
      fLastY = t.clientY; fLastT = e.timeStamp;
      panel.style.transition = "none";
      panel.style.transform = `translateY(${fdy * 0.9}px)`;
    }, { passive: false });
    const fRelease = () => {
      if (!fOn) return;
      fOn = false;
      if (fdy > 60 || (fvy > 0.5 && fdy > 30)) {
        panel.style.transition = "transform 0.2s ease, opacity 0.2s ease";
        panel.style.transform = "translateY(110%)";
        panel.style.opacity = "0";
        setTimeout(close, 180);
      } else {
        panel.style.transition = "transform 0.25s ease";
        panel.style.transform = "translateY(0)";
        setTimeout(() => { panel.style.transition = panel.style.transform = ""; }, 280);
      }
    };
    panel.addEventListener("touchend", fRelease);
    panel.addEventListener("touchcancel", () => { fOn = false; panel.style.transition = panel.style.transform = panel.style.opacity = ""; });
  }

  // cta bar: reveal after ~4s of watching; add-to-cart wiring is buy-bar only
  // (the homepage "View in shop" variant is a plain link and needs none)
  const cta = lb.querySelector(".demo-cta");
  if (cta) {
    const reveal = () => cta.classList.add("visible");
    video.addEventListener("timeupdate", () => { if (video.currentTime >= 4) reveal(); });
    video.addEventListener("ended", reveal);
    // the growing bar squeezes the mobile sheet's scroll area — re-check the fade hint
    cta.addEventListener("transitionend", updateFade);
  }
  const wirePurchase = () => {
    if (!cta || !buyCtx) return;
    const btnFirst = cta.querySelector(".demo-cta-btn");
    const btnAdd = cta.querySelector(".demo-cta-add");
    const caseWrap = cta.querySelector(".demo-cta-casewrap");
    const casePick = cta.querySelector(".demo-case-picker");
    const err = cta.querySelector(".demo-cta-error");

    const addToCart = async (caseId, actBtn) => {
      if (actBtn.disabled || !lb.isConnected) return;
      // the instrument LAST: the last item of one add lands on top of the basket
      const items = [{ id: buyCtx.variantId, quantity: 1, properties: buyCtx.getProperties() }];
      if (caseId) items.unshift({ id: +caseId, quantity: 1 });
      actBtn.disabled = true;
      actBtn.textContent = AYASA_t("js.core.adding");
      try {
        // the basket rules (ayasa-cart-rules-2.js): at most 3 of a model, and
        // Shopify's own stock message (which names the stock) never shows
        await window.AyasaCart.add(items, { instruments: [{ handle: buyCtx.handle, quantity: 1 }], pan: true });
        try { await instrumentsFirst(); } catch (e) { console.error("basket order:", e); }
        // Which clip preceded this sale. Shopify carries cart attributes into the
        // order permanently, so the sale remembers — costs nothing now, and it is
        // history that cannot be recovered later if we skip it. Nothing reads it
        // yet; attribution waits until the volume makes it mean something.
        if (watchTracker.id) {
          fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ attributes: { "_video": watchTracker.id } })
          }).catch(() => {});   // never let bookkeeping fail a purchase
        }
        cta.querySelector(".demo-cta-row").innerHTML = `
          <p class="demo-cta-price"><strong>${AYASA_t("js.core.added_to_cart")}</strong></p>
          ${btnAdd ? "" : `<a class="btn btn-primary demo-cta-btn" href="/cart">${AYASA_t("js.core.view_cart")}</a>`}`;
        if (btnAdd) btnAdd.outerHTML = `<a class="btn btn-primary demo-cta-add" href="/cart">${AYASA_t("js.core.view_cart")}</a>`;
        if (caseWrap) caseWrap.hidden = true;
        refreshCartBubble(); // this add stays on the page: the header number follows
      } catch (e2) {
        err.textContent = e2.message;
        err.hidden = false;
        actBtn.disabled = false;
        actBtn.textContent = AYASA_t("js.core.add_to_cart");
      }
    };

    // step 1: "Order now" borrows the page's own options block — moved, not
    // cloned, so the case picker, colour tiles, size chips and validation are
    // literally the same elements, already wired. close() puts it back.
    btnFirst.addEventListener("click", () => {
      err.hidden = true;
      // buying from the mini-player: bring the full lightbox back first
      if (lb.classList.contains("minimized")) btnMin.click();
      if (!buyCtx.caseSelect) return addToCart(null, btnFirst);
      if (btnFirst.classList.contains("fading")) return;
      btnFirst.classList.add("fading");
      setTimeout(() => {
        btnFirst.hidden = true;
        const opts = buyCtx.options || document.getElementById("buyOptions");
        if (opts && caseWrap && !caseWrap.contains(opts)) {
          lb.__optsHome = buyCtx.options ? null : opts.parentElement;      // remembered for close()
          lb.__optsNext = opts.nextElementSibling;
          opts.classList.remove("collapsible", "open"); // no fold inside the sheet
          caseWrap.appendChild(opts);
        }
        if (!lb.isConnected) return;
        caseWrap.hidden = false;
        btnAdd.hidden = false;
        // the phone sheet becomes a checkout: video shrinks, tabs step aside,
        // options take the middle and Add to cart holds the bottom edge
        lb.classList.add("buying");
        requestAnimationFrame(() => { layoutDeck(); layoutBar(); updateFade(); });
        if (!mq.matches) caseWrap.scrollIntoView({ block: "nearest", behavior: "smooth" });
      }, 320);
    });

    // step 2: the big button bundles handpan + chosen case + t-shirt
    if (btnAdd) {
      btnAdd.addEventListener("click", () => {
        err.hidden = true;
        const pageCase = buyCtx.caseSelect;
        const pageShirt = buyCtx.options ? buyCtx.options.querySelector("#shirtSize") : document.getElementById("shirtSize");
        const needCase = !pageCase.value || !pageCase.selectedOptions[0] || pageCase.selectedOptions[0].disabled;
        const needShirt = pageShirt && !pageShirt.value;
        if (needCase || needShirt) {
          showChoicePopup(choiceMessage(needCase, needShirt));
          const target = needCase
            ? cta.querySelector("#caseTrigger") || cta.querySelector(".case-picker")
            : cta.querySelector("#shirtTrigger") || cta.querySelector("#shirtSizes");
          target?.scrollIntoView({ block: "nearest", behavior: "smooth" });
          return;
        }
        addToCart(pageCase.value, btnAdd);
      });
    }

    // nothing to wire for the case or t-shirt here any more: the moved block
    // brings the product page's own listeners with it, and they already drive
    // the hidden selects this bar reads.
  };
  wirePurchase();

  video.play().catch(() => {}); // restore/iOS may refuse — restoreMiniPlayer escalates from here
  markWatched(model.videos[start].file);
  watchTracker.start(videoId(model.videos[start].file));
  video.addEventListener("timeupdate", () => watchTracker.tick(video));
  video.addEventListener("ended", () => watchTracker.finished());
  // "Order now" / "View in shop" is the click closest to the thing we care about
  lb.querySelectorAll(".demo-cta-btn, .demo-cta-add, .demo-mini-shop").forEach(b =>
    b.addEventListener("click", () => watchTracker.shopClick()));
  // "View in shop" keeps the music: minimizing before the navigation makes
  // pagehide stash the state, and the product page resurrects the mini-player.
  // Anchors only — the buyCtx "Order now" button stays a full-screen checkout.
  lb.querySelectorAll("a.demo-cta-btn, a.demo-shop-link, a.demo-mini-shop").forEach(a =>
    a.addEventListener("click", () => {
      if (!lb.classList.contains("minimized")) btnMin.click();
    }));
  // Other pages show this product's server-formatted price. Ordering navigates
  // to its real form; the link's existing minimize handler preserves playback.
  if (shop && cta) {
    lb.classList.add("remote-purchase");
    const price = cta.querySelector(".demo-remote-price");
    const order = cta.querySelector(".demo-remote-order");
    let loading = false, pendingOrder = false, unavailable = false;
    order.addEventListener("click", e => {
      if (unavailable) return;
      e.preventDefault(); e.stopImmediatePropagation();
      pendingOrder = true;
      order.textContent = AYASA_t("js.core.loading");
      if (!loading) loadPrice();
    }, true);
    const loadPrice = async () => {
      loading = true;
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 10000);
      try {
        const url = new URL(shop.url, location.href);
        const match = url.pathname.match(/\/products\/([^/]+)\/?$/);
        if (url.origin !== location.origin || !match) throw new Error("Not a local product");
        const handle = decodeURIComponent(match[1]);
        const destination = new URL(url); destination.hash = "buyForm";
        order.href = destination.href;
        const response = await fetch(url.href, { credentials: "same-origin", cache: "no-cache", signal: controller.signal });
        if (!response.ok) throw new Error("Product unavailable");
        const doc = new DOMParser().parseFromString(await response.text(), "text/html");
        const product = doc.querySelector(".product-section[data-handle]");
        if (!product || product.dataset.handle !== handle || !product.dataset.price) throw new Error("Missing product price");
        if (!lb.isConnected) return;
        price.textContent = product.dataset.price;
        cta.querySelectorAll(".demo-cta-price s").forEach(el => el.remove());
        if (product.dataset.compare) {
          const compare = document.createElement("s");
          compare.textContent = product.dataset.compare; price.before(compare);
        }
        if (product.dataset.available !== "true") { unavailable = true; pendingOrder = false; order.textContent = AYASA_t("js.core.view_availability"); }
        if (product.dataset.available === "true") {
          const options = product.querySelector("#buyOptions");
          const variant = product.querySelector('#buyForm [name="id"]');
          if (!options) throw new Error("Missing product options");
          const requiredCase = options.querySelector("#casePicker");
          if (requiredCase && !options.querySelector("#caseSelect")) throw new Error("Missing case choices");
          if (options.querySelector("#shirtPicker") && (!options.querySelector("#shirtSize") || !options.querySelector("#shirtColor"))) throw new Error("Missing shirt choices");
          if (!variant || !/^\d+$/.test(variant.value)) throw new Error("Missing product variant");
          if (options) {
            options.querySelectorAll("script").forEach(el => el.remove());
            initPlayerPurchaseOptions(options, null);
          }
          buyCtx = {
            variantId: Number(variant.value), handle, price: product.dataset.price,
            compareAt: product.dataset.compare || "", available: true,
            options, caseSelect: options?.querySelector("#caseSelect"),
            getProperties: () => {
              const size = options?.querySelector("#shirtSize");
              const color = options?.querySelector("#shirtColor");
              return size?.value && size.value !== "No free t-shirt"
                ? { "Free t-shirt size": size.value, "Free t-shirt color": color?.value || "" } : {};
            }
          };
          const host = document.createElement("div"); host.innerHTML = purchaseHTML();
          cta.replaceChildren(...host.firstElementChild.childNodes);
          cta.classList.remove("demo-cta-remote");
          lb.classList.remove("remote-purchase");
          wirePurchase();
          if (pendingOrder) cta.querySelector(".demo-cta-btn").click();
          cta.querySelectorAll(".demo-cta-btn,.demo-cta-add").forEach(btn =>
            btn.addEventListener("click", () => watchTracker.shopClick()));
        }

      } catch (_) {
        if (lb.isConnected) {
          price.textContent = AYASA_t("js.core.options_unavailable"); order.textContent = AYASA_t("js.core.retry_order");
          if (!cta.querySelector(".demo-order-fallback")) {
            const link = document.createElement("a");
            link.className = "demo-order-fallback"; link.textContent = AYASA_t("js.core.view_in_shop"); link.href = shop.url;
            link.addEventListener("click", () => { if (!lb.classList.contains("minimized")) btnMin.click(); });
            cta.querySelector(".demo-cta-inner").append(link);
          }
        }
      } finally { clearTimeout(timeout); loading = false; }
      if (lb.isConnected) { layoutDeck(); layoutBar(); updateFade(); }
    };
    loadPrice();
  }
  if (wasMin) btnMin.click(); // browse mode carries over — the new player starts minimized
  // through the buttons themselves, so the arrows and their labels come along
  // with the classes rather than drifting out of step with them
  if (wasCompact) lb.querySelector(".demo-side-small")?.click();
  if (wasMirror) lb.querySelector(".demo-side-mirror")?.click();
  // a player can open at any clip — the artist pages open a model at the one you
  // tapped — so start with that pill centred instead of off to the right. Instant,
  // because this is a starting position and not a movement. Runs after any
  // open-minimized docking above, so it measures the strip's final home.
  splitTabRows();
  layoutDeck();
  layoutBar();
  // a web font landing late changes the height of every line it touches, and the
  // bar's two blocks are matched by measurement rather than by luck
  document.fonts && document.fonts.ready && document.fonts.ready.then(() => { fontRevision++; schedulePlayerLayout(); });
  centreActivePill(tabEls[current()], "auto");
  updateFade();   // the split changes what is hidden off to the side
}

// ---------- scale switcher (product pages) ----------
function scaleItemHTML(s, currentHandle) {
  const model = typeof MODELS !== "undefined" && MODELS.find(m => m.name === s.name && m.top);
  const icon = model
    ? noteMapSVG(model)
    : `<span class="scale-badge">${(s.name.match(/^[A-G]#?\d?/) || ["·"])[0]}</span>`;
  const active = s.handle === currentHandle;
  return `
    <a class="scale-item${active ? " active" : ""}" href="/products/${s.handle}"${active ? ' aria-current="page"' : ""}>
      <span class="scale-icon">${icon}</span>
      <strong>${s.name}</strong>
      <span class="scale-price" data-handle="${s.handle}"></span>
    </a>`;
}
const __productCache = {};
function fetchProduct(handle) {
  if (!__productCache[handle]) {
    __productCache[handle] = fetch(`/products/${handle}.js`)
      .then(r => (r.ok ? r.json() : null))
      .catch(() => null);
  }
  return __productCache[handle];
}
function fetchPrice(handle) {
  return fetchProduct(handle).then(p =>
    (p ? ayasaMoney(p.price, true) : ""));
}

// ---------- live availability (two states — mirrors availability-badge.liquid) ----------
// The ships: tag is a date SOURCE, not a state switch: a FUTURE date wins,
// otherwise the shelf. (/products/{handle}.js exposes tags but not inventory
// quantity, so the brief sold-out-awaiting-restock gap renders as in stock
// here; the server-rendered product-page badge is exact.)
function availabilityFromProduct(p) {
  const tag = (p.tags || []).find(t => t.startsWith("ships:"));
  // a handpan without a ships: tag has nothing free and no date (Roy, 08-10):
  // never "Sold out", only "No date yet" (availability-badge.liquid says the same)
  if (!tag && (p.type === "Handpan" || (p.tags || []).includes("instrument"))) return { cls: "badge-order", text: AYASA_t("js.core.no_date_yet") };
  const ship = tag ? new Date(tag.slice(6)) : null;
  if (ship && !isNaN(ship) && ship > new Date()) {
    const nice = ship.toLocaleDateString(AYASA_LOCALE === "en" ? "en-GB" : AYASA_LOCALE, { day: "numeric", month: "long", year: "numeric" });
    return { cls: "badge-order", text: AYASA_t("js.core.made_for_you_ships", { date: nice }) };
  }
  if (!p.available) return { cls: "badge-soldout", text: AYASA_t("js.core.sold_out") };
  return { cls: "badge-stock", text: AYASA_t("js.core.in_stock_ships") };
}
function loadCardAvailability(root) {
  root.querySelectorAll(".badge[data-handle]").forEach(el => {
    if (el.dataset.loaded) return;
    el.dataset.loaded = "1";
    fetchProduct(el.dataset.handle).then(p => {
      if (!p) return; // fetch failed — keep the data-file fallback text
      const a = availabilityFromProduct(p);
      el.classList.remove("badge-stock", "badge-order", "badge-soldout");
      el.classList.add(a.cls);
      el.textContent = a.text;
    });
  });
}

function loadScalePrices(root) {
  root.querySelectorAll(".scale-price[data-handle]").forEach(el => {
    if (el.dataset.loaded) return;
    el.dataset.loaded = "1";
    fetchProduct(el.dataset.handle).then(p => {
      el.textContent = p ? ayasaMoney(p.price, true) : "";
      // sold-out one-offs disappear site-wide — the specials medallions too.
      // So do scales with no product in Shopify yet (the fetch comes back
      // empty); each one appears by itself once its product exists.
      // The current page's own medallion stays so the switcher keeps context.
      const item = el.closest(".scale-item");
      if ((!p || !p.available) && item && !item.classList.contains("active")) {
        const grid = item.parentElement;
        item.remove();
        // the last medallion gone takes the "Find something special" heading with it
        if (grid && grid.classList.contains("scale-grid") && !grid.querySelector(".scale-item")) {
          [grid.previousElementSibling, grid.previousElementSibling?.previousElementSibling]
            .forEach(n => { if (n && /more-scales-(label|sub)/.test(n.className)) n.remove(); });
          grid.remove();
        }
      }
    });
  });
}
// in the switcher, range cards whisper their price instead of "View in shop"
function swapLinkPrices(root) {
  root.querySelectorAll(".scale-cards .model-link").forEach(link => {
    if (link.dataset.priced) return;
    link.dataset.priced = "1";
    const handle = (link.getAttribute("href").match(/\/products\/([^/?#]+)/) || [])[1];
    if (!handle) return;
    link.classList.add("model-link-price");
    link.textContent = "";
    fetchPrice(handle).then(t => { link.textContent = t; });
  });
}
function initScaleNav() {
  const nav = document.getElementById("scaleNav");
  if (!nav || typeof SCALES === "undefined" || typeof MODELS === "undefined") return;
  // a condition page counts as its base model for the "you are here" marking
  const current = (nav.dataset.current || "").replace(/-(scratched|spotted)$/, "");
  const premiumModels = MODELS.filter(m => m.range === "premium");
  const elementsModels = MODELS.filter(m => m.range === "elements");
  // hybrid: full range cards for modelled scales, medallions for the rest
  const carded = new Set(premiumModels.map(m => m.name));
  const rest = SCALES.filter(s => !carded.has(s.name));
  const specialsHTML = rest.length ? `
    <h3 class="more-scales-label">${AYASA_t("js.core.find_something_special")}</h3>
    <p class="more-scales-sub">${AYASA_t("js.core.specials_sub")}</p>
    <div class="scale-grid">${rest.map(s => scaleItemHTML(s, current)).join("")}</div>` : "";
  // one always-open range: every card (filterable) + specials medallions,
  // with a pill row above and below sharing a single filter state
  const ordered = [...premiumModels, ...elementsModels];
  const CHIPS = [
    { key: "all", label: AYASA_t("js.core.all") },
    { key: "premium", label: "Premium" },
    { key: "elements", label: "Elements" },
    { key: "d-minor", label: AYASA_t("js.core.family_d_minor") },
    { key: "f#-minor", label: AYASA_t("js.core.family_fs_minor") },
    { key: "e-minor", label: AYASA_t("js.core.family_e_minor") },
    { key: "other", label: AYASA_t("js.core.other") }
  ];
  const body = nav.querySelector(".scale-panel-body");
  // the second pill row sits where the cards end, before the specials
  body.innerHTML = `<div class="range-grid scale-cards">${ordered.map(modelCard).join("")}</div>
    <div class="scale-filters scale-filters-bottom" role="group" aria-label="${AYASA_t("js.core.filter_scales")}"></div>
    ${specialsHTML}`;
  const cards = [...body.querySelectorAll(".scale-cards .model-card")];
  cards.forEach((el, i) => {
    el.dataset.range = ordered[i].range;
    el.dataset.family = ordered[i].family || "other";
  });
  const link = body.querySelector(`.model-link[href="/products/${current}"]`);
  if (link) link.closest(".model-card").classList.add("scale-current");

  const rows = [...nav.querySelectorAll(".scale-filters")];
  const chipHTML = CHIPS.map(c =>
    `<button type="button" class="filter-chip${c.key === "all" ? " on" : ""}" data-filter="${c.key}" aria-pressed="${c.key === "all"}">${c.label}</button>`
  ).join("");
  rows.forEach(r => { r.innerHTML = chipHTML; });
  const applyFilter = key => {
    rows.forEach(r => r.querySelectorAll(".filter-chip").forEach(c => {
      const on = c.dataset.filter === key;
      c.classList.toggle("on", on);
      c.setAttribute("aria-pressed", on);
    }));
    cards.forEach(el => {
      el.hidden = !(key === "all" || el.dataset.range === key || el.dataset.family === key);
    });
  };
  rows.forEach(r => r.addEventListener("click", e => {
    const chip = e.target.closest(".filter-chip");
    if (!chip) return;
    // only the TOP row is railed; a click on the bottom one keeps the anti-jump,
    // which is exactly right there — you are at the end of the cards already
    const rail = r.closest(".pill-rail");
    const pinned = !!rail && rail.classList.contains("stuck");   // before the filter
    // hiding cards collapses the grid, which yanks everything below it up the
    // screen — pin the row you clicked so only the cards appear to move
    const anchor = r.getBoundingClientRect().top;
    // radio-style; re-clicking the active chip falls back to All
    applyFilter(chip.classList.contains("on") ? "all" : chip.dataset.filter);
    if (pinned) {
      alignToFilteredTop(rail, ".scale-cards", ".model-card", true);
    } else {
      // instant, not the page's smooth default — a smooth correction *is* the jump
      scrollBy({ top: r.getBoundingClientRect().top - anchor, behavior: "instant" });
    }
  }));

  loadScalePrices(nav);
  swapLinkPrices(nav);
  loadCardAvailability(nav);
}

// ---------- artist page ----------
// Instrument rail (minimal horizontal cards from the artist's curated `plays`
// list, first N visible) + listening room (round-robin video strip: every
// unique scale once, then the second videos, and so on). Also VideoObject LD.
function initArtistPage() {
  // intro: a few lines, the rest behind Read more. Clipped rather than hidden,
  // so the whole story stays crawlable on a page meant to rank for his name.
  // Runs first and unconditionally — most artist pages carry a story but no
  // footage, and the button must still work there.
  const introText = document.getElementById("artistIntroText");
  const relationMore = document.getElementById("artistRelationMore");
  if (introText && relationMore) {
    const sync = () => {
      if (introText.dataset.open) return;
      introText.classList.add("clipped");
      relationMore.hidden = introText.scrollHeight <= introText.clientHeight + 2;
    };
    relationMore.addEventListener("click", () => {
      introText.dataset.open = "1";
      introText.classList.remove("clipped");
      relationMore.hidden = true;
    });
    sync();
    addEventListener("resize", sync, { passive: true });
    if (document.fonts?.ready) document.fonts.ready.then(sync);
  }

  const rail = document.getElementById("artistPlays");
  if (!rail || typeof ARTISTS === "undefined") return;
  const artist = rail.dataset.artist;
  const info = ARTISTS[artist] || {};
  const plays = info.plays || [];
  // an empty rail must not silence the listening room: "video on the page,
  // instrument not in the rail" is a valid state — artists borrow instruments
  // they do not own, and the studio asks the rail question separately
  if (!plays.length && !(info.clips || []).length) return;

  // --- the instruments he plays: the real range cards, sent back to the shop ---
  // Only the scales with a full MODELS entry can render a card (note map, desc,
  // Listen button); a `plays` entry with no model is skipped rather than shown
  // as a stub.
  const playedModels = typeof MODELS !== "undefined"
    ? plays.map(p => MODELS.find(m => m.name === p.name)).filter(Boolean)
    : [];
  if (playedModels.length) {
    rail.innerHTML = `<div class="range-grid scale-cards">${playedModels.map(modelCard).join("")}</div>`;
    swapLinkPrices(rail);        // a price reads better than "View in shop" here
    loadCardAvailability(rail);
  } else {
    rail.hidden = true;
    // the "X plays" heading would sit orphaned above a hidden grid
    document.querySelector(".artist-plays-head")?.setAttribute("hidden", "");
  }

  // --- listening room ---
  const strip = document.getElementById("artistVideos");
  if (!strip) return;
  // the studio's own order, one flat list across instruments — the rail above
  // and this strip are ordered independently on purpose. Data files from
  // before `clips` existed fall back to the old per-instrument interleave.
  let flat = (info.clips || []).map(c =>
    ({ p: { name: c.name, mode: c.mode, handle: c.handle }, file: c.file }));
  if (!flat.length) {
    const rounds = [];
    plays.forEach(p => (p.videos || []).forEach((file, vi) => {
      (rounds[vi] = rounds[vi] || []).push({ p, file, vi });
    }));
    flat = rounds.flat();
  }
  // data-i indexes the FULL list, never the filtered view — the lightbox reads
  // it to know what to play, so filtering must not renumber anything
  strip.innerHTML = flat.map((e, i) => `
    <article class="demo-card" data-i="${i}" data-scale="${e.p.handle}" tabindex="0" role="button" aria-label="${AYASA_t("js.core.watch_artist_play", { artist, scale: e.p.name })}">
      <img ${posterAttrs(e.file)} alt="" loading="lazy">
      <span class="demo-card-play" aria-hidden="true">▶</span>
      <div class="demo-card-info">
        <strong>${e.p.name}</strong>
        <span>${e.p.mode}</span>
      </div>
    </article>`).join("");

  // one pill per scale he plays, same chip component as the range and shop
  const filters = document.getElementById("artistFilters");
  if (filters) {
    const scales = [];
    flat.forEach(e => {
      if (!scales.some(s => s.handle === e.p.handle)) scales.push({ handle: e.p.handle, name: e.p.name });
    });
    // two rows, packed independently, so a pill is only ever as wide as its own
    // text — same arrangement as the player's tab rows
    filters.innerHTML =
      `<div class="artist-filter-row" role="presentation">` +
      `<button type="button" class="filter-chip on" data-filter="all" aria-pressed="true">${AYASA_t("js.core.all")}</button>` +
      scales.map(s =>
        `<button type="button" class="filter-chip" data-filter="${s.handle}" aria-pressed="false">${s.name}</button>`
      ).join("") +
      `</div><div class="artist-filter-row" role="presentation"></div>`;

    // Where the second row starts. Lifted from the player's splitTabRows: the cut
    // lands where the running width passes half the total, so both rows come out
    // about the same LENGTH rather than the same count — the strip scrolls as far
    // as its longest row and no further. Sequential, never re-ordered: "All" has
    // to stay first, and the scales keep the order the rail gave them.
    const filterRows = [...filters.querySelectorAll(".artist-filter-row")];
    const phone = matchMedia("(max-width: 900px)");
    const splitArtistFilters = () => {
      filterRows[0].append(...[...filterRows[1].children]);   // back to one row: idempotent
      if (!phone.matches) return;                             // desktop wraps freely
      const pills = [...filterRows[0].children];
      if (pills.length < 2) return;
      const gap = parseFloat(getComputedStyle(filterRows[0]).columnGap) || 0;
      const widths = pills.map(p => p.getBoundingClientRect().width + gap);
      const total = widths.reduce((a, b) => a + b, 0) - gap;
      if (total <= filters.clientWidth + 2) return;           // one row already fits
      let run = 0, cut = pills.length;
      for (let i = 0; i < pills.length; i++) {
        run += widths[i];
        if (run >= total / 2) {
          // the pill straddling the halfway mark goes whichever way leaves the
          // LONGER row shorter
          const takingIt = Math.max(run - gap, total - run);
          const leavingIt = Math.max(run - widths[i] - gap, total - run + widths[i]);
          cut = leavingIt < takingIt ? i : i + 1;
          break;
        }
      }
      if (cut < 1) cut = 1;                                   // never strand the top row empty
      if (cut < pills.length) filterRows[1].append(...pills.slice(cut));
    };
    splitArtistFilters();
    addEventListener("resize", splitArtistFilters, { passive: true });
    phone.addEventListener("change", splitArtistFilters);

    // Slide the tapped pill to the middle of the strip, the way the player centres
    // the artist whose clip is playing — a pill at the edge reads as half-hidden,
    // and the ones after it look like they do not exist. The browser clamps at both
    // ends, so the first and last come as close to centre as the scroll allows.
    // The STRIP scrolls, never the page: measured and moved by hand, because
    // scrollIntoView would drag the whole page to it.
    const centreFilterPill = (pill, behavior) => {
      if (filters.scrollWidth <= filters.clientWidth + 2) return;   // nothing to scroll
      const pr = pill.getBoundingClientRect(), wr = filters.getBoundingClientRect();
      const dx = (pr.left + pr.right) / 2 - (wr.left + wr.right) / 2;
      if (Math.abs(dx) > 1) filters.scrollBy({ left: dx, behavior });
    };
    // the chips are measured, so re-split once the webfont has settled their width
    if (document.fonts?.ready) document.fonts.ready.then(splitArtistFilters);
    filters.addEventListener("click", e => {
      const chip = e.target.closest(".filter-chip");
      if (!chip) return;
      // radio-style; re-tapping the active chip falls back to All
      const key = chip.classList.contains("on") ? "all" : chip.dataset.filter;
      const rail = filters.closest(".pill-rail");
      const pinned = !!rail && rail.classList.contains("stuck");   // before the filter
      filters.querySelectorAll(".filter-chip").forEach(c => {
        const on = c.dataset.filter === key;
        c.classList.toggle("on", on);
        c.setAttribute("aria-pressed", on);
      });
      strip.querySelectorAll(".demo-card").forEach(card => {
        card.hidden = !(key === "all" || card.dataset.scale === key);
      });
      // the tapped pill slides to the middle: sideways, inside the strip
      centreFilterPill(chip, "smooth");
      // and pinned, the page lands on the first clip left standing: downward,
      // outside it. Two axes, two scrollers, neither fighting the other.
      alignToFilteredTop(rail, ".artist-video-grid", ".demo-card", pinned);
    });
  }
  const numerals = ["", " · II", " · III", " · IV", " · V"];
  const openAt = i => {
    const e = flat[i];
    // if the model exists in the range data, open with its FULL video list so
    // other artists' takes (Immanuel, Vybeshift, …) are right there as tabs
    const model = typeof MODELS !== "undefined" &&
      MODELS.find(m => m.name === e.p.name && m.videos && m.videos.length);
    if (model) {
      const selected = playerSelectionForClip(model, { file: e.file, artist });
      openDemoLightbox({ ...selected.model, productHandle: model.productHandle || e.p.handle }, selected.index);
      return;
    }
    // no MODELS entry: the tab list is this artist's own takes on the SAME
    // instrument, in strip order — works for clips and the legacy shape alike
    const same = flat.filter(x => x.p.name === e.p.name);
    openDemoLightbox({
      name: e.p.name,
      scale: e.p.mode,
      productHandle: e.p.handle,
      videos: same.map((x, n) => ({ artist: `${artist}${numerals[n] || ""}`, file: x.file }))
    }, Math.max(0, same.indexOf(e)));
  };
  strip.addEventListener("click", ev => {
    const c = ev.target.closest(".demo-card");
    if (c) openAt(+c.dataset.i);
  });
  strip.addEventListener("keydown", ev => {
    const c = ev.target.closest(".demo-card");
    if (c && (ev.key === "Enter" || ev.key === " ")) { ev.preventDefault(); openAt(+c.dataset.i); }
  });

  // --- VideoObject structured data ---
  const ld = document.createElement("script");
  ld.type = "application/ld+json";
  ld.textContent = JSON.stringify({
    "@context": "https://schema.org",
    "@graph": flat.map(e => ({
      "@type": "VideoObject",
      "name": AYASA_t("js.core.ld_video_name", { artist, scale: e.p.name }),
      "description": AYASA_t("js.core.ld_video_description", { artist, scale: e.p.name, mode: e.p.mode }),
      "thumbnailUrl": new URL(posterOf(e.file), location.href).href,
      "contentUrl": new URL(e.file, location.href).href,
      "uploadDate": rail.dataset.published || "2026-01-01"
    }))
  });
  document.head.appendChild(ld);
}

// PROTOTYPE: resurrect the minimized player across page loads.
// On leave: stash which video + timestamp if (and only if) the player is minimized.
addEventListener("pagehide", () => {
  const lb = document.querySelector(".demo-lightbox");
  if (lb && lb.classList.contains("minimized") && lb.__state) {
    sessionStorage.setItem("ayasaMiniPlayer", JSON.stringify(lb.__state()));
  } else {
    sessionStorage.removeItem("ayasaMiniPlayer");
  }
});

// On arrival: rebuild the mini player (desktop corner / mobile footer), seeked
// to where it was, and resume by escalation: unmuted (Chrome carries the tap
// through same-site navigation) → muted with an unmute chip (WebKit/iOS allows
// silent autoplay only) → paused with native controls as the last resort.
function restoreMiniPlayer() {
  let saved = null;
  try { saved = JSON.parse(sessionStorage.getItem("ayasaMiniPlayer")); } catch (e) { /* corrupt state */ }
  if (!saved || typeof MODELS === "undefined") return;
  const model = MODELS.find(m => m.name === saved.name && m.videos && m.videos.length);
  if (!model) return;
  const selected = saved.clip && typeof saved.clip.file === "string" && typeof saved.clip.artist === "string"
    ? playerSelectionForClip(model, saved.clip)
    : { model, index: Math.max(0, Math.min(saved.index || 0, model.videos.length - 1)) };
  openDemoLightbox(selected.model, selected.index);
  const lb = document.querySelector(".demo-lightbox");
  if (!lb) return;
  lb.querySelector(".demo-min").click(); // dock straight into the corner/footer
  // and back into the shape it was left in, for the same reason
  if (saved.compact) lb.querySelector(".demo-side-small")?.click();
  if (saved.mirror) lb.querySelector(".demo-side-mirror")?.click();
  const v = lb.querySelector("video");
  const seek = () => { v.currentTime = saved.time || 0; };
  if (v.readyState >= 1) seek();
  else v.addEventListener("loadedmetadata", seek, { once: true });
  v.play().catch(() => {
    v.muted = true;
    v.play().then(() => {
      const chip = document.createElement("button");
      chip.type = "button";
      chip.className = "demo-unmute";
      chip.textContent = AYASA_t("js.core.tap_for_sound");
      lb.querySelector(".demo-panel").appendChild(chip);
      chip.addEventListener("click", () => { v.muted = false; }); // a tap is a gesture — sound allowed
      v.addEventListener("volumechange", () => { if (!v.muted) chip.remove(); }); // native unmute counts too
    }).catch(() => { v.muted = false; }); // even muted refused: rest on the poster, controls resume
  });
}

function initDemoButtons() {
  document.addEventListener("click", e => {
    const btn = e.target.closest(".hear-btn");
    if (btn) openDemoLightbox(MODELS[+btn.dataset.model]);
  });
}

// ============================================================
// Shortlist — Phase 0 (docs/WISHLIST-PLAN.md §3)
// Hearts write to localStorage so launch-day shortlists arrive
// pre-populated; the popup collects the waitlist email; every
// click pushes a dataLayer event for the pixel/audience work.
// ============================================================
const SHORTLIST_KEY = "ayasa:shortlist";
// Save-to-account: Flow serves the customer wishlist on its own host. Empty
// until Ralf's host exists (filled in theme settings -> window.AYASA_WISHLIST_URL);
// while empty, the save button and the popup line do not render. Handles ride
// in ?h=, comma-separated, at most 50. Plain navigation, never a fetch; the
// local list is NOT cleared after sending.
const WISHLIST_ACCOUNT_URL = ((typeof window !== "undefined" && window.AYASA_WISHLIST_URL) || "").trim();
function wishlistAccountLink() {
  if (!WISHLIST_ACCOUNT_URL) return "";
  const h = handlesNotInAccount().slice(0, 50).map(i => i.handle).join(",");
  return withCart(WISHLIST_ACCOUNT_URL + (WISHLIST_ACCOUNT_URL.includes("?") ? "&" : "?") + "h=" + encodeURIComponent(h));
}
// What the account already holds (Roy, 20-10, option A; Flow#944): the account
// host answers GET /account/wishlist/state with { signedIn, handles } to the
// shop's own origins only, the sign-in cookie riding along (same site). A
// signed-in customer is then not asked to save scales that are already in the
// account. Never blocks anything: until it answers, or when it fails, the
// wishlist behaves exactly as before.
// Signed in, the hearts ARE the account (Roy, 20-10): a heart adds, an un-heart
// removes, through POST /account/wishlist/items {add, remove} → {signedIn,
// handles}; on arrival the two lists are merged both ways, so nothing hearted
// on either side is lost. A failed save keeps the heart locally and brings the
// Save button back for it.
const ACCOUNT_BASE = WISHLIST_ACCOUNT_URL ? WISHLIST_ACCOUNT_URL.split("/wishlist/import")[0] : "";
const ACCOUNT_ORIGIN = (() => { try { return ACCOUNT_BASE ? new URL(ACCOUNT_BASE).origin : ""; } catch { return ""; } })();
let accountState = null; // { signedIn, handles } once the account host answered
let accountStateCall = null;
function fetchAccountState() {
  if (!ACCOUNT_BASE) return Promise.resolve(null);
  if (!accountStateCall) {
    accountStateCall = fetch(ACCOUNT_BASE + "/wishlist/state", { credentials: "include", headers: { Accept: "application/json" } })
      .then(r => (r.ok ? r.json() : null))
      .then(d => {
        if (d && typeof d.signedIn === "boolean") {
          accountState = { signedIn: d.signedIn, handles: Array.isArray(d.handles) ? d.handles.map(String) : [] };
          if (accountState.signedIn) return mergeWithAccount().then(() => accountState);
        }
        return accountState;
      })
      .catch(() => accountState)
      .finally(() => { accountStateCall = null; });
  }
  return accountStateCall;
}
// the hearts the account does not hold yet: all of them unless signed in (a
// save on its way counts as held, until it fails)
const accountSaving = new Set();
function handlesNotInAccount() {
  const list = getShortlist();
  if (!accountState || !accountState.signedIn) return list;
  const saved = new Set(accountState.handles);
  return list.filter(i => !saved.has(i.handle) && !accountSaving.has(i.handle));
}
// one add/remove call to the account; resolves true when the account took it
function syncAccount(add, remove) {
  if (!ACCOUNT_BASE || !accountState?.signedIn || (!add.length && !remove.length)) return Promise.resolve(false);
  add.forEach(h => accountSaving.add(h));
  return fetch(ACCOUNT_BASE + "/wishlist/items", {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ add: add.slice(0, 50), remove: remove.slice(0, 50) })
  })
    .then(r => r.json().catch(() => null).then(d => ({ ok: r.ok, status: r.status, d })))
    .then(({ ok, status, d }) => {
      if (status === 401) { accountState = { signedIn: false, handles: [] }; return false; }
      if (!ok || !d || !Array.isArray(d.handles)) return false;
      accountState = { signedIn: !!d.signedIn, handles: d.handles.map(String) };
      return true;
    })
    .catch(() => false)
    .then(done => {
      add.forEach(h => accountSaving.delete(h));
      // the heart already said "Saved to your Ayasa account": put that right
      if (!done && add.length) shortlistToast(AYASA_t("js.core.account_save_failed"));
      refreshShortlistUI();
      return done;
    });
}
// signed in on arrival: account scales fill the hearts here, hearts from this
// browser go into the account
function mergeWithAccount() {
  const list = getShortlist();
  const here = new Set(list.map(i => i.handle));
  const fromAccount = accountState.handles.filter(h => !here.has(h)).slice(0, 50);
  const toAccount = list.map(i => i.handle).filter(h => !accountState.handles.includes(h));
  const filled = fromAccount.length
    ? Promise.all(fromAccount.map(h => fetchProduct(h).then(p => ({ handle: h, name: (p?.title || h).split(" - ")[0], added: Date.now() }))))
        .then(items => {
          const now = getShortlist();
          const add = items.filter(i => !now.some(n => n.handle === i.handle));
          try { localStorage.setItem(SHORTLIST_KEY, JSON.stringify(now.concat(add))); } catch { /* private mode */ }
        })
    : Promise.resolve();
  return filled.then(() => {
    refreshShortlistUI();
    if (toAccount.length) syncAccount(toAccount, []);
  });
}
// The cart number travels to the account host (its own cart icon shows it
// until the next visit): read from the header's cart bubble, 0 when empty.
function cartItemCount() {
  const n = parseInt(document.querySelector("#nav .nav-cart sup")?.textContent || "0", 10);
  return Number.isFinite(n) && n > 0 ? n : 0;
}
// redraw the header's cart number from the real basket (for adds that stay on
// the page; every other add goes to /cart, which renders it fresh)
function refreshCartBubble() {
  const cartLink = document.querySelector("#nav .nav-cart");
  if (!cartLink) return Promise.resolve();
  return fetch("/cart.js", { headers: { Accept: "application/json" } })
    .then(r => (r.ok ? r.json() : null))
    .then(c => {
      if (!c) return;
      let sup = cartLink.querySelector("sup");
      if (c.item_count > 0) {
        if (!sup) { sup = document.createElement("sup"); cartLink.appendChild(sup); }
        sup.textContent = c.item_count;
      } else sup?.remove();
    })
    .catch(() => {});
}
function withCart(url) {
  try {
    const u = new URL(url, location.href);
    u.searchParams.set("cart", String(cartItemCount()));
    return u.toString();
  } catch { return url; }
}
// every link to the account host (header Account icon, Save, View) gets the
// cart number at the moment it is followed, so it is never stale
function initAccountLinks() {
  if (!ACCOUNT_ORIGIN) return;
  const stamp = a => { if (a && a.origin === ACCOUNT_ORIGIN) a.href = withCart(a.href); };
  document.querySelectorAll("a[href]").forEach(stamp);
  ["click", "auxclick", "contextmenu"].forEach(type =>
    document.addEventListener(type, e => stamp(e.target.closest?.("a[href]")), true));
}
const HEART_SVG = `<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M12 20.3C7.2 16.6 3.5 13.5 3.5 9.9 3.5 7.2 5.6 5 8.2 5c1.5 0 3 .7 3.8 1.9C12.8 5.7 14.3 5 15.8 5c2.6 0 4.7 2.2 4.7 4.9 0 3.6-3.7 6.7-8.5 10.4z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>`;

function getShortlist() {
  try { return JSON.parse(localStorage.getItem(SHORTLIST_KEY)) || []; } catch { return []; }
}
function trackShortlist(event, handle) {
  (window.dataLayer = window.dataLayer || []).push({ event: `shortlist_${event}`, scale: handle || "" });
}
function toggleShortlist(handle, name) {
  let list = getShortlist();
  const added = !list.some(i => i.handle === handle);
  if (added) list.push({ handle, name, added: Date.now() });
  else list = list.filter(i => i.handle !== handle);
  try { localStorage.setItem(SHORTLIST_KEY, JSON.stringify(list)); } catch { /* private mode — session-only */ }
  trackShortlist(added ? "add" : "remove", handle);
  if (accountState?.signedIn) syncAccount(added ? [handle] : [], added ? [] : [handle]);
  refreshShortlistUI();
  return added;
}
function refreshShortlistUI() {
  const list = getShortlist();
  const has = handle => list.some(i => i.handle === handle);
  document.querySelectorAll(".shortlist-heart[data-handle], .shortlist-btn[data-handle]").forEach(b => {
    const on = has(b.dataset.handle);
    b.classList.toggle("on", on);
    b.setAttribute("aria-pressed", on);
    const label = b.querySelector(".sl-label");
    if (label) label.textContent = on ? AYASA_t("js.core.on_wishlist") : AYASA_t("js.core.add_to_wishlist");
    // icon-only buttons explain themselves through the hover tooltip
    if (b.title) b.title = on ? AYASA_t("js.core.on_wishlist") : AYASA_t("js.core.add_to_wishlist");
  });
  const navBtn = document.getElementById("navShortlist");
  const panel = document.querySelector(".shortlist-panel");
  if (navBtn) {
    // while the panel is open, keep its anchor — removing the last scale
    // shows the empty state instead of yanking both away mid-interaction
    navBtn.hidden = list.length === 0 && (!panel || panel.hidden);
    const count = document.getElementById("navShortlistCount");
    if (count) count.textContent = list.length;
  }
  if (panel && !panel.hidden) renderShortlistPanel(panel);
}
function shortlistToast(msg) {
  document.querySelector(".shortlist-toast")?.remove();
  const t = document.createElement("div");
  t.className = "choice-popup shortlist-toast";
  t.setAttribute("role", "status");
  t.textContent = msg;
  document.body.appendChild(t);
  setTimeout(() => { t.classList.add("out"); setTimeout(() => t.remove(), 400); }, 2200);
}
function renderShortlistPanel(panel) {
  const list = getShortlist();
  const signed = localStorage.getItem("ayasa:shortlist:signed");
  const close = `<button type="button" class="sl-panel-close" aria-label="${AYASA_t("js.core.close_wishlist")}">×</button>`;
  panel.innerHTML = list.length ? `
    ${close}
    <p class="sl-panel-head">${AYASA_t("js.core.your_wishlist")}</p>
    <ul class="sl-panel-list">
      ${list.map(i => `
        <li>
          <a href="/products/${i.handle}">${i.name}</a>
          <button type="button" class="sl-panel-remove" data-handle="${i.handle}" data-name="${i.name}" aria-label="${AYASA_t("js.core.remove_name_from_wishlist", { name: i.name })}">×</button>
        </li>`).join("")}
    </ul>
    ${WISHLIST_ACCOUNT_URL ? "" : `<label class="sl-check sl-notify" id="slNotifyRow" hidden>
      <input type="checkbox" id="slNotifyBox"${localStorage.getItem("ayasa:notify-availability") ? " checked" : ""}>
      <span>${AYASA_t("js.core.notify_sooner")}</span>
    </label>`}
    ${WISHLIST_ACCOUNT_URL
      // the account is live (Roy, 20-10): the panel points there, and the
      // waitlist's notify box and signup button go (they need its email form)
      ? accountPanelFoot(list)
      : `<p class="sl-panel-note">${AYASA_t("js.core.compare_at_launch")}</p>
    ${signed ? "" : `<button type="button" class="sl-panel-signup" id="slPanelSignup">${AYASA_t("js.core.notify_at_launch")}</button>`}`}`
    : `${close}
       <p class="sl-panel-head">${AYASA_t("js.core.wishlist_empty")}</p>
       <p class="sl-panel-note">${AYASA_t("js.core.wishlist_empty_hint")}</p>`;
  // the notify opt-in only makes sense when something on the list isn't on the shelf
  if (list.length) {
    Promise.all(list.map(i => fetchProduct(i.handle))).then(ps => {
      const someWait = ps.filter(Boolean).some(p => availabilityFromProduct(p).cls !== "badge-stock");
      const row = panel.querySelector("#slNotifyRow");
      if (row && someWait) row.hidden = false;
    });
  }
}
// the panel's foot while the account is live: signed in with every heart in the
// account → no button, a link to it; signed in with some missing → save just
// those; otherwise (signed out, or no answer yet) → save them all, as before
function accountPanelFoot(list) {
  const missing = handlesNotInAccount();
  if (accountState?.signedIn && !missing.length) {
    return `<p class="sl-panel-note">${AYASA_t("js.core.saved_in_account")}</p>
    <a class="btn btn-ghost sl-panel-account" href="${withCart(ACCOUNT_BASE + "/wishlist")}">${AYASA_t("js.core.view_account_wishlist")}</a>`;
  }
  if (accountState?.signedIn && missing.length < list.length) {
    const n = missing.length;
    return `<p class="sl-panel-note">${AYASA_t(n === 1 ? "js.core.not_in_account_one" : "js.core.not_in_account_other", { n })}</p>
    <a class="btn btn-primary sl-panel-account" href="${wishlistAccountLink()}">${AYASA_t("js.core.save_n_more", { n })}</a>`;
  }
  return `<p class="sl-panel-note">${AYASA_t("js.core.saved_in_browser")}</p>
    <a class="btn btn-primary sl-panel-account" href="${wishlistAccountLink()}">${AYASA_t("js.core.save_to_account")}</a>`;
}
// silently add tags to an already-signed-up customer (Shopify appends tags on
// repeat customer-form posts). Returns false on failure or a bot challenge.
function postCustomerTags(email, tags) {
  const form = document.getElementById("shortlistForm");
  if (!form || !email) return Promise.resolve(false);
  const fd = new FormData();
  fd.append("form_type", "customer");
  fd.append("utf8", "✓");
  fd.append("contact[email]", email);
  fd.append("contact[tags]", tags.join(", "));
  return fetch(form.action, { method: "POST", body: fd, headers: { Accept: "text/html" } })
    .then(r => r.ok && !(r.url || "").includes("challenge"))
    .catch(() => false);
}
function openShortlistPopup(name) {
  const pop = document.getElementById("shortlistPopup");
  if (!pop) return false;
  const scaleEl = document.getElementById("slPopupScale");
  if (scaleEl) scaleEl.textContent = name;
  const acctLink = document.getElementById("slAccountLink");
  if (acctLink) {
    const url = wishlistAccountLink();
    if (url) acctLink.href = url;
  }
  pop.hidden = false;
  document.getElementById("slEmail")?.focus();
  return true;
}
function initShortlist() {
  initAccountLinks();
  if (getShortlist().length) fetchAccountState(); // ready before the first panel or pop-up
  // one delegated handler: cards re-render (scale switcher, keep-exploring),
  // so per-element listeners would leak or miss
  const heartAction = el => {
    const { handle, name } = el.dataset;
    if (!handle) return;
    const added = toggleShortlist(handle, name || handle);
    if (el.classList.contains("shortlist-heart")) {
      el.classList.remove("pop");
      void el.offsetWidth; // restart the animation
      if (added) el.classList.add("pop");
    }
    if (!added) return shortlistToast(AYASA_t("js.core.removed_from_wishlist"));
    if (accountState?.signedIn) return shortlistToast(AYASA_t("js.core.saved_to_account"));
    const n = getShortlist().length;
    // two asks maximum, ever: the first save (once per session) and the third
    // saved scale (once, flagged so remove/re-add can't re-fire it). Signing up
    // silences both.
    if (!localStorage.getItem("ayasa:shortlist:signed")) {
      if (!sessionStorage.getItem("ayasa:shortlist:popup")) {
        sessionStorage.setItem("ayasa:shortlist:popup", "1");
        if (openShortlistPopup(name || handle)) return;
      } else if (n >= 3 && !localStorage.getItem("ayasa:shortlist:popup3")) {
        localStorage.setItem("ayasa:shortlist:popup3", "1");
        if (openShortlistPopup(name || handle)) return;
      }
    }
    shortlistToast(AYASA_t(n === 1 ? "js.core.noted_count_one" : "js.core.noted_count_other", { n }));
  };
  document.addEventListener("click", e => {
    const remove = e.target.closest(".sl-panel-remove");
    if (remove) { toggleShortlist(remove.dataset.handle, remove.dataset.name); return; }
    const el = e.target.closest(".shortlist-heart, .shortlist-btn");
    if (!el) return;
    e.preventDefault(); // hearts sit inside/over card links — never navigate
    e.stopPropagation();
    heartAction(el);
  });
  // shop-grid hearts are spans (a <button> inside the card <a> is invalid HTML)
  document.addEventListener("keydown", e => {
    if (e.key !== "Enter" && e.key !== " ") return;
    const el = e.target.closest?.('.shortlist-heart[role="button"]');
    if (!el) return;
    e.preventDefault();
    heartAction(el);
  });

  // header heart → dropdown panel
  const navBtn = document.getElementById("navShortlist");
  const nav = document.getElementById("nav");
  if (navBtn && nav) {
    const panel = document.createElement("div");
    panel.className = "shortlist-panel";
    panel.hidden = true;
    nav.appendChild(panel);
    const closePanel = () => {
      panel.hidden = true;
      navBtn.setAttribute("aria-expanded", "false");
      refreshShortlistUI(); // re-evaluate the heart's visibility (list may be empty now)
    };
    navBtn.addEventListener("click", () => {
      if (panel.hidden) {
        panel.hidden = false;
        navBtn.setAttribute("aria-expanded", "true");
        renderShortlistPanel(panel);
        // ask the account again (the customer may have saved or signed in
        // since), then redraw if the answer changes what the foot shows
        fetchAccountState().then(() => { if (!panel.hidden) renderShortlistPanel(panel); });
      } else closePanel();
    });
    document.addEventListener("click", e => {
      // removing an item re-renders the panel and detaches the clicked × —
      // a detached target is not "outside", so don't let it close the panel
      if (!document.body.contains(e.target)) return;
      if (!panel.hidden && !panel.contains(e.target) && !navBtn.contains(e.target)) closePanel();
    });
    // panel controls (delegated — the panel re-renders on every list change)
    panel.addEventListener("click", e => {
      if (e.target.closest(".sl-panel-close")) return closePanel();
      if (e.target.closest("#slPanelSignup")) {
        closePanel();
        openShortlistPopup(getShortlist()[0]?.name || AYASA_t("js.core.your_wishlist"));
      }
    });
    panel.addEventListener("change", e => {
      const box = e.target.closest("#slNotifyBox");
      if (!box) return;
      if (!box.checked) { localStorage.removeItem("ayasa:notify-availability"); return; } // local only — see plan doc
      localStorage.setItem("ayasa:notify-availability", "1");
      const email = localStorage.getItem("ayasa:shortlist:email");
      if (!email) {
        // no email on record yet — the signup popup carries the tag from here
        closePanel();
        openShortlistPopup(getShortlist()[0]?.name || AYASA_t("js.core.your_wishlist"));
        return;
      }
      postCustomerTags(email, ["shortlist-waitlist", "notify-availability", ...getShortlist().map(i => `wants:${i.handle}`)])
        .then(ok => {
          if (ok) { trackShortlist("notify_optin"); shortlistToast(AYASA_t("js.core.notify_optin_done")); }
          else { box.checked = false; localStorage.removeItem("ayasa:notify-availability"); shortlistToast(AYASA_t("js.core.something_went_wrong")); }
        });
    });
  }

  // return trip from a native full-page POST (bot-challenge path): Shopify
  // redirects back with ?customer_posted=true — promote the stashed email
  // to the signed state. The footer newsletter form never stashes one, so
  // its posts are ignored here.
  if (location.search.includes("customer_posted=true")) {
    const pending = localStorage.getItem("ayasa:shortlist:pending-email");
    if (pending) {
      localStorage.setItem("ayasa:shortlist:signed", "1");
      localStorage.setItem("ayasa:shortlist:email", pending);
      localStorage.removeItem("ayasa:shortlist:pending-email");
      trackShortlist("waitlist_signup");
      shortlistToast(AYASA_t("js.core.on_the_list"));
      const url = new URL(location);
      url.searchParams.delete("customer_posted");
      history.replaceState(null, "", url);
    }
  }

  // waitlist popup: close + AJAX submit (native-POST fallback for the bot challenge)
  const pop = document.getElementById("shortlistPopup");
  if (pop) {
    pop.querySelectorAll("[data-sl-close]").forEach(el => el.addEventListener("click", () => { pop.hidden = true; }));
    document.addEventListener("keydown", e => { if (e.key === "Escape" && !pop.hidden) pop.hidden = true; });
    const form = document.getElementById("shortlistForm");
    if (form) form.addEventListener("submit", async e => {
      e.preventDefault();
      const err = document.getElementById("slError");
      err.hidden = true;
      // tag the signup with every scale saved so far → who-wants-what in admin.
      // The disclosure under the button names the newsletter, so the tag is
      // unconditional; notify-availability rides along when the panel box asked.
      const tags = ["shortlist-waitlist", "newsletter", ...getShortlist().map(i => `wants:${i.handle}`)];
      if (localStorage.getItem("ayasa:notify-availability")) tags.push("notify-availability");
      document.getElementById("slTags").value = tags.join(", ");
      const btn = form.querySelector('[type="submit"]');
      btn.disabled = true;
      const email = (document.getElementById("slEmail")?.value || "").trim();
      // stash the email before submitting: if the bot challenge forces a
      // full-page POST, the ?customer_posted=true return trip (handled below)
      // promotes it to the signed state
      localStorage.setItem("ayasa:shortlist:pending-email", email);
      const succeed = () => {
        localStorage.setItem("ayasa:shortlist:signed", "1");
        // kept in the shopper's own browser so the notify box can tag them later without re-asking
        localStorage.setItem("ayasa:shortlist:email", email);
        localStorage.removeItem("ayasa:shortlist:pending-email");
        trackShortlist("waitlist_signup");
        form.hidden = true;
        document.getElementById("slSuccess").hidden = false;
      };
      try {
        const r = await fetch(form.action, { method: "POST", body: new FormData(form), headers: { Accept: "text/html" } });
        // Shopify's bot check ("Verifying your connection…") comes back as an
        // inline 403 or a /challenge redirect — either way only a real
        // navigation can pass it, so hand over to a native full-page POST
        if (r.status === 403 || (r.url && r.url.includes("challenge"))) { form.submit(); return; }
        if (!r.ok) throw new Error();
        succeed();
      } catch {
        // network error mid-redirect etc. — the native post is the reliable path
        form.submit();
      }
    });
  }

  refreshShortlistUI();
}

// ---------- mobile scroll spotlight ----------
// Touch screens have no hover, so cards light up by scroll position instead —
// a continuous dimmer, not a switch. Full effect on the focus line (centre of
// the unobstructed viewport; the docked mini player shrinks it), a small
// plateau so the featured card holds its moment, then a smoothstep fade to
// zero toward the screen edges. No floor: edge cards rest fully dark.
// CSS reads --spot only under @media (hover: none) — desktop stays pure hover.
function initScrollSpotlight() {
  if (!matchMedia("(hover: none)").matches) return;
  const cards = document.querySelectorAll(".model-card, .shop-card");
  if (!cards.length) return;
  const PLATEAU = 0.10, FALLOFF = 0.45; // viewport-height fractions
  const onScreen = new Set();
  const reset = c => { c.classList.remove("spot"); c.style.removeProperty("--spot"); };
  let queued = false;
  const update = () => {
    queued = false;
    const vh = innerHeight;
    // focus line: centre of what's actually visible above the docked player
    const player = document.querySelector(".demo-lightbox.minimized .demo-panel");
    const focus = (vh - (player ? player.offsetHeight : 0)) / 2;
    onScreen.forEach(c => {
      const r = c.getBoundingClientRect();
      const d = Math.abs(r.top + r.height / 2 - focus) / vh;
      let t = d <= PLATEAU ? 1 : Math.max(0, 1 - (d - PLATEAU) / FALLOFF);
      t *= t * (3 - 2 * t); // smoothstep — eases both the rise and the fade
      if (t > 0.001) {
        c.classList.add("spot");
        c.style.setProperty("--spot", t.toFixed(3));
      } else reset(c);
    });
  };
  const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => (e.isIntersecting ? onScreen.add(e.target) : (onScreen.delete(e.target), reset(e.target))));
    schedule();
  }, { rootMargin: "20% 0px 20% 0px" });
  cards.forEach(c => io.observe(c));
  addEventListener("scroll", schedule, { passive: true, capture: true });
  addEventListener("resize", schedule, { passive: true });
}

// ---------- homepage video bands ----------
// A strip of the hero video in each gap between sections: full page width,
// faded top and bottom, showing a different horizontal slice of the frame at
// each joint and wrapping back to the top of the frame when it runs out.
//
// One <video> per band, each cropped by its band's overflow — NOT one shared
// video blitted into canvases. The canvas version could not work: Chrome will
// not run a video it considers invisible, so the off-screen source element
// stayed paused at t=0 and every band drew a black frame. Measured: a 2x2
// transparent video never starts, a 160x90 visible one plays. Real elements
// also make the browser's own power saving do the right thing — it pauses the
// bands that are off screen, so however many bands exist, only the one or two
// actually in view are ever decoding.
function initHomeBands() {
  if (window.AyasaHomeLayout) { window.AyasaHomeLayout.mount(typeof AYASA_CFG !== 'undefined' ? AYASA_CFG.homeBands : {}); return; }
  const cfg = (typeof AYASA_CFG !== "undefined" && AYASA_CFG.homeBands) || null;
  if (!cfg || cfg.on === false) return;
  const root = document.documentElement;

  // the gap travels even when the bands are off: it is the page's rhythm,
  // not part of the effect
  if (cfg.gap) root.style.setProperty("--home-gap-d", cfg.gap + "px");
  if (cfg.gapMobile) root.style.setProperty("--home-gap-m", cfg.gapMobile + "px");
  // Only the baseline offset is shared. Height, both ramps and strength belong
  // to each band now — the page wants a whisper at one joint and a tall wash at
  // another — so they are set on the element, not here.
  root.style.setProperty("--band-off", (cfg.offset ?? 30) + "px");

  // Each joint is named for the two sections it sits between and is hosted by
  // the second of them, so the band hangs upward out of the section it belongs
  // to and its offset is measured from the end of the previous one's content.
  // Every selector is qualified with .home-sect, which only index.json's
  // sections wear. Without it the artists PAGE, whose section is also
  // id="artists", grew a band of its own.
  const JOINTS = [
    ["hero-stats", ".home-sect#stats"], ["stats-range", ".home-sect#range"],
    ["range-ember", ".home-sect#ember"], ["ember-artists", ".home-sect#artists"],
    ["artists-reviews", ".home-sect#reviews"], ["reviews-story", ".home-sect#story"],
    ["story-buying", ".home-sect#buying"], ["buying-faq", ".home-sect#faq"],
    ["faq-explore", ".home-sect#explore"],
    ["range-elements", ".home-sect#range .elements-head"]   // the odd one: inside #range
  ];
  const want = cfg.joints || {};
  const src = window.AYASA_ASSET ? window.AYASA_ASSET(cfg.source || "hero.mp4") : (cfg.source || "hero.mp4");
  const still = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const bands = [];

  JOINTS.forEach(([key, sel]) => {
    // a joint is { on, drop } now; a bare boolean is the older shape
    const spec = want[key];
    const lit = spec && typeof spec === "object" ? spec.on : !!spec;
    if (!lit) return;
    const host = document.querySelector(sel);
    if (!host) return;
    const el = document.createElement("div");
    el.className = "home-band";
    el.setAttribute("aria-hidden", "true");        // decorative, nothing to announce
    const v = document.createElement("video");
    v.muted = true; v.loop = true; v.playsInline = true; v.preload = "none";
    // The attributes, not the properties: a bare play() call on a freshly made
    // element does not start it (measured — it resolves and the video stays
    // paused at t=0), while the declarative autoplay attribute does, and it is
    // also what iOS reads for muted inline video. Not set under reduced motion,
    // where the band holds one frame instead.
    v.setAttribute("muted", ""); v.setAttribute("playsinline", ""); v.setAttribute("loop", "");
    if (!still) v.setAttribute("autoplay", "");
    el.appendChild(v);
    // this band's own shape. A number that is absent falls back to the
    // stylesheet's value rather than to a literal here, so there is one place
    // the defaults live.
    const px = (prop, val) => {
      if (Number.isFinite(Number(val))) el.style.setProperty(prop, Math.round(Number(val)) + "px");
    };
    px("--band-drop", spec?.drop);
    px("--band-h", spec?.height);
    px("--band-fade-t", spec?.fadeTop);
    px("--band-fade-b", spec?.fadeBottom);
    if (Number.isFinite(Number(spec?.opacity))) {
      el.style.setProperty("--band-op", String(Number(spec.opacity) / 100));
    }
    host.prepend(el);
    // .elements-head is not a .home-sect, so it has to become the anchor itself
    if (!host.classList.contains("home-sect")) {
      host.style.position = "relative";
      el.style.setProperty("--gap-above", "0px");
    }
    bands.push({ el, v, live: false, near: false });
  });
  if (!bands.length) return;

  // Which slice of the frame each band shows. The video is laid out at page
  // width, so its drawn height is pageW * (vh/vw) — 1920x1080 across a 1425px
  // page is 801px of frame to walk down.
  //
  // A running cursor, not i * bandHeight: the bands are different heights now,
  // so multiplying by any one of them would overlap some slices and skip past
  // others. The cursor takes each band its own height further down the frame
  // and returns to the top when the next one would not fit whole.
  function place() {
    const pageW = root.clientWidth || window.innerWidth;
    // a hidden or not-yet-laid-out document reports 0, and writing that would
    // collapse every band to nothing; leave the last good value in place
    if (!pageW) return;
    root.style.setProperty("--page-w", pageW + "px");
    const drawnH = pageW * 1080 / 1920;
    let cursor = 0;
    bands.forEach(b => {
      const h = b.el.getBoundingClientRect().height || 170;
      if (cursor + h > drawnH) cursor = 0;
      // a band taller than the whole frame simply starts at the top
      b.el.style.setProperty("--slice", Math.max(0, Math.round(cursor)) + "px");
      cursor += h;
    });
  }

  const syncBand = b => {
    clearTimeout(b.releaseTimer);
    if (!b.near || backgroundMediaBlocked()) {
      b.v.pause();
      if (!b.near && b.live) b.releaseTimer = setTimeout(() => {
        if (!b.near) { b.v.removeAttribute("src"); b.v.load(); b.live = false; }
      }, 15000);
      return;
    }
    if (!b.live) {
      b.live = true;
      if (still) b.v.addEventListener("loadeddata", () => { b.v.currentTime = 0.1; }, { once: true });
      b.v.src = src; b.v.load();
    }
    if (!still && b.v.paused) b.v.play().catch(() => {});
  };
  const syncBands = () => bands.forEach(syncBand);
  document.addEventListener("ayasa:player-visibility", syncBands);
  document.addEventListener("visibilitychange", syncBands);
  bands.forEach(b => b.v.addEventListener("play", () => {
    if (!b.near || backgroundMediaBlocked()) b.v.pause();
  }));
  // Attach only near the viewport; release distant buffers after a short grace.
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => {
      const b = bands.find(x => x.el === e.target);
      if (!b) return;
      b.near = e.isIntersecting;
      syncBand(b);
    });
  }, { rootMargin: "300px 0px" });

  place();
  window.addEventListener("resize", place, { passive: true });
  bands.forEach(b => io.observe(b.el));
}

// ---------- scroll reveal ----------
function initReveal() {
  // NB: threshold is a fraction of the ELEMENT, not the screen. The 46-artist
  // grid is ~8200px tall on a phone, so 12% of it can never be on screen at
  // once and the grid stayed at opacity 0 forever. Trigger instead when the
  // element's edge clears the bottom eighth of the viewport — same feel for
  // card-sized elements, but height can no longer disable the reveal.
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add("visible"); io.unobserve(e.target); } });
  }, { rootMargin: "0px 0px -12% 0px" });
  document.querySelectorAll(".reveal").forEach(el => io.observe(el));
}

// ---------- nav ----------
function initNav() {
  const nav = document.getElementById("nav");
  const burger = document.getElementById("navBurger");
  const links = document.getElementById("navLinks");
  addEventListener("scroll", () => nav.classList.toggle("scrolled", scrollY > 40), { passive: true });
  nav.classList.toggle("scrolled", scrollY > 40);
  burger.addEventListener("click", () => {
    const open = links.classList.toggle("open");
    burger.classList.toggle("open", open);
    burger.setAttribute("aria-expanded", open);
  });
  links.querySelectorAll("a").forEach(a => a.addEventListener("click", () => {
    links.classList.remove("open");
    burger.classList.remove("open");
    burger.setAttribute("aria-expanded", "false");
  }));
}

// ---------- sticky filter rails ----------
// Every filter row on the site pins itself under the nav once you scroll past it
// and lets go where its own grid ends: homepage range, shop toolbar, product-page
// scales, artist listening room.
//
// The row is WRAPPED rather than made sticky itself. Below 900px these rows are
// horizontal scrollers, and a sticky box inside its own scroll container sticks
// to that container — i.e. sits there doing nothing. The wrapper is a plain block
// in the section's flow, so it sticks against the page and releases at its
// parent's end, which is why each rail's parent is chosen deliberately in the
// markup (see .range-filterable, .artist-listen).
const PILL_RAILS = [];
function publishNavHeight() {
  const nav = document.getElementById("nav");
  if (!nav) return 0;
  // its bottom, not its height: in business mode the strip above it pushes
  // the nav down, and what sticks must stick under both (snippets/ayasa-business-strip.liquid)
  const h = Math.round(nav.getBoundingClientRect().bottom);
  document.documentElement.style.setProperty("--nav-h", `${h}px`);
  return h;
}
// needsChips: a pure pill row with nothing to choose between is not worth pinning
// — one lone "All" (an artist with the listening room on but no footage yet) would
// otherwise ride down the page as a blur bar over nothing. The shop toolbar is
// exempt: even with a single category it still carries the count and the sort.
function stickyRail(row, needsChips = true) {
  // already railed (a second init pass, or a row inside one) — leave it alone
  if (!row || row.closest(".pill-rail")) return;
  if (needsChips && row.querySelectorAll(".filter-chip").length < 2) return;
  const rail = document.createElement("div");
  rail.className = "pill-rail";
  row.parentNode.insertBefore(rail, row);
  rail.appendChild(row);
  // Opt this region out of scroll anchoring. When a filter collapses the grid the
  // browser tries to keep the view steady by shifting scrollY itself, which fights
  // alignToFilteredTop for the same pixels and wins — the card landed ~200px high
  // whenever cards ABOVE the first match were the ones hidden. Here the alignment
  // is the deliberate answer to a collapse, so the automatic help is just noise.
  rail.parentElement?.classList.add("pill-rail-scope");
  PILL_RAILS.push(rail);
}
// Sticky has already done the positioning; this only decides when to show the
// backdrop. It reads each rail's own top, the same way .nav.scrolled works.
// An IntersectionObserver on a marker was tried and is wrong twice over: it only
// fires when the crossing state CHANGES, so a rail stays unflagged for the whole
// scroll after it pins, and "not intersecting" cannot tell above-the-fold from
// below it — a rail further down the page came up already wearing its backdrop.
function syncPillRails() {
  PILL_RAILS.forEach(rail => {
    // the line comes from the rail's OWN resolved sticky offset, not from --nav-h:
    // the CSS pins at nav-h plus half a --rail-pad to centre the pills in the band,
    // and a copy of that sum here went stale the moment the CSS gained the offset
    const line = parseFloat(getComputedStyle(rail).top) || 0;
    const r = rail.getBoundingClientRect();
    // pinned means "sitting on the line AND still on screen": once its parent
    // runs out the rail scrolls away with it, and a backdrop on something you
    // can no longer see would keep the class on for the rest of the page
    rail.classList.toggle("stuck", r.top <= line + 0.5 && r.bottom > line);
  });
}
// After a filter runs, land on the top of the first surviving card instead of
// halfway down it: hiding cards collapses the grid, which pulls whatever is left
// up past the pinned row.
//
// `wasPinned` must be sampled BEFORE the filter is applied, and this is the whole
// subtlety. Filtering can shrink the section below your scroll position, at which
// point the rail releases and scrolls off — so a rail read AFTERWARDS reports "not
// pinned" in exactly the case that needs aligning most, leaving you stranded past a
// section that no longer reaches you. Pinned-at-click is what "you were down in the
// grid" actually means.
//
// It only ever moves up. From further up the page the first card is already fully
// visible, and "aligning" would scroll DOWN — the opposite of what a filter asks for.
//
// When a heading sits directly above that card — the Elements block, once a
// tonality empties Premium — the heading becomes the target, otherwise you land on
// cards with nothing left on screen to say which range they belong to.
function alignToFilteredTop(rail, gridSelector, cardSelector, wasPinned) {
  if (!rail || !wasPinned) return;
  const scope = rail.parentElement;
  if (!scope) return;
  // one frame, so the collapsed grid has settled into its new layout before anything
  // is measured against it
  requestAnimationFrame(() => {
    // getClientRects() catches both ways a card can be hidden: [hidden] on the range
    // and artist grids, inline display:none on the shop cards
    const card = [...scope.querySelectorAll(cardSelector)].find(el => el.getClientRects().length);
    if (!card) return;
    const grid = card.closest(gridSelector) || card.parentElement;
    const above = grid && grid.previousElementSibling;
    const lead = above && above.classList.contains("section-head") && above.getClientRects().length
      ? above
      : card;
    // Where the band's underside sits once pinned, derived rather than assumed: the
    // rail's resolved sticky `top` is nav-h + half a --rail-pad, so the difference
    // from nav-h gives that half back, and the backdrop reaches the same half below.
    // Measuring the rail's CURRENT position would be wrong — it may have released.
    const navH = parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--nav-h")) || 0;
    const stickTop = parseFloat(getComputedStyle(rail).top) || navH;
    const half = Math.max(0, stickTop - navH);
    const bandBottom = stickTop + rail.getBoundingClientRect().height + half;
    // LAYOUT coordinates, not getBoundingClientRect: a card that has never been
    // scrolled into view still carries .reveal's translateY(26px), so its rect reads
    // 26px low and then animates up afterwards — landing the card a little behind
    // the band. offsetTop is layout, which transforms do not touch.
    const layoutTop = el => { let y = 0; for (let n = el; n; n = n.offsetParent) y += n.offsetTop; return y; };
    // absolute target, not a delta: scrollTo cannot compound with anything the
    // browser does to scrollY between this measurement and the scroll itself
    const target = layoutTop(lead) - bandBottom - 10;
    if (target >= scrollY - 1) return;         // already clear — never scroll down
    scrollTo({ top: Math.max(0, target), behavior: "smooth" });
  });
}

function initStickyRails() {
  // the shop page rails its whole toolbar, not just the pills: the count and the
  // sort control live in that row, and leaving them behind while the pills travel
  // would strand the two things you reach for together
  stickyRail(document.getElementById("rangeFilters"));
  stickyRail(document.querySelector(".shop-toolbar"), false);
  stickyRail(document.querySelector("#scaleNav .scale-filters"));  // top row only, by design
  stickyRail(document.getElementById("artistFilters"));
  if (!PILL_RAILS.length) return;
  publishNavHeight();
  syncPillRails();
  addEventListener("scroll", syncPillRails, { passive: true });
  let t;
  addEventListener("resize", () => {
    clearTimeout(t);
    t = setTimeout(() => { publishNavHeight(); syncPillRails(); }, 150);
  });
}

// ---------- reduced motion: pause hero video ----------
function initHeroMotion() {
  const v = document.querySelector(".hero-video");
  if (!v) return;
  const motion = matchMedia("(prefers-reduced-motion: reduce)");
  let visible = false;
  v.removeAttribute("autoplay");
  const sync = () => {
    if (!visible || motion.matches || backgroundMediaBlocked()) v.pause();
    else if (v.paused) v.play().catch(() => {});
  };
  new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); }).observe(v);
  document.addEventListener("ayasa:player-visibility", sync);
  document.addEventListener("visibilitychange", sync);
  motion.addEventListener("change", sync);
  // Catch late autoplay readiness or a racing play promise while covered.
  v.addEventListener("play", () => { if (!visible || motion.matches || backgroundMediaBlocked()) v.pause(); });
  sync();
}

// ---------- product page (Shopify) ----------
function initProductPage() {
  const section = document.querySelector(".product-section");
  if (!section) return;

  // note map from PRODUCT_NOTES (assets/ayasa-notes.js), keyed by product handle.
  // A condition page ({base}-scratched / -spotted) is the same instrument, so
  // every handle-keyed lookup falls back to the base model's data — the 3D
  // player, note map and performances must never vanish with the condition.
  const handle = section.dataset.handle;
  const condBase = handle.replace(/-(scratched|spotted)$/, "");
  const notes = typeof PRODUCT_NOTES !== "undefined" && (PRODUCT_NOTES[handle] || PRODUCT_NOTES[condBase]);
  if (notes) {
    const mapEl = document.getElementById("productNoteMap");
    const bottomEl = document.getElementById("productNoteBottom");
    mapEl.innerHTML = noteMapSVG({ name: notes.title, ding: notes.ding, top: notes.top });
    bottomEl.innerHTML = notes.bottom.length
      ? `<b>${AYASA_t("js.core.bottom_count", { n: notes.bottom.length })}</b> ${notes.bottom.join(" ")}`
      : AYASA_t("js.core.topside_only");
    document.getElementById("productNotes").hidden = false;
  }

  // description: two lines on a phone, the rest behind "Read more". Clamp only
  // when the text really overflows, so short descriptions get no button.
  const desc = document.getElementById("productDesc");
  const descMore = document.getElementById("descMore");
  // On desktop the description is trimmed to whatever fits, so the buy button
  // lands level with the gallery's thumbnails. Measured, not a guessed line
  // count — descriptions and window widths both vary.
  function fitDescription() {
    if (!desc || !descMore) return;
    if (matchMedia("(max-width: 900px)").matches) return; // phone path owns it
    // the two edges to line up: the thumbnail row and the buy button's row
    const thumbs = document.getElementById("productThumbs") || document.querySelector(".product-gallery");
    const buyRow = document.querySelector(".buy-row");
    desc.classList.remove("clamped");
    desc.style.removeProperty("-webkit-line-clamp");
    desc.style.removeProperty("margin-bottom");
    if (!thumbs || !buyRow || desc.dataset.open) {
      descMore.hidden = true;
      return;
    }
    const lineH = parseFloat(getComputedStyle(desc).lineHeight) || 24;
    const descH = desc.getBoundingClientRect().height;
    const target = thumbs.getBoundingClientRect().bottom;
    const overshoot = buyRow.getBoundingClientRect().bottom - target;
    const fullLines = Math.round(descH / lineH);
    if (overshoot <= 0) { descMore.hidden = true; return; } // already fits
    const lines = Math.max(3, Math.floor((descH - overshoot) / lineH)); // floor: never a stub
    if (lines >= fullLines) { descMore.hidden = true; return; }
    desc.classList.add("clamped");
    desc.style.setProperty("-webkit-line-clamp", lines);
    descMore.hidden = false;
    // Whole lines only get us within one line-height, and the grid hands back
    // part of any margin (the gallery spans both rows, so slack is shared).
    // A couple of measure-and-adjust passes settle it exactly.
    let margin = 0;
    for (let i = 0; i < 6; i++) {
      const drift = thumbs.getBoundingClientRect().bottom - buyRow.getBoundingClientRect().bottom;
      if (Math.abs(drift) < 1) break;
      margin = Math.max(0, margin + drift);
      desc.style.marginBottom = `${margin}px`;
    }
  }

  if (desc && descMore) {
    const phone = matchMedia("(max-width: 900px)");
    const sync = () => {
      if (!phone.matches) return fitDescription(); // desktop trims to fit instead
      if (desc.dataset.open) return; // already expanded by the reader
      desc.style.removeProperty("-webkit-line-clamp");
      desc.classList.add("clamped");
      descMore.hidden = desc.scrollHeight <= desc.clientHeight + 1;
    };
    descMore.addEventListener("click", () => {
      desc.dataset.open = "1";
      desc.classList.remove("clamped");
      desc.style.removeProperty("-webkit-line-clamp");
      descMore.hidden = true;
    });
    sync();
    phone.addEventListener("change", sync);
    addEventListener("resize", sync, { passive: true });
    if (document.fonts?.ready) document.fonts.ready.then(sync); // metrics settle late
    // the gallery is the measuring stick: re-fit whenever it changes height
    // (the product photo finishing its load is the big one). Observing the
    // gallery and not the info column keeps this loop-free — fitDescription
    // only ever changes the info side.
    const galleryEl = document.querySelector(".product-gallery");
    if (galleryEl && window.ResizeObserver) new ResizeObserver(sync).observe(galleryEl);
  }

  // gallery carousel: product photos + (when the model has videos) a final
  // video slide. Arrows + swipe navigate; the video thumb/slide open the lightbox.
  const demoModel = typeof MODELS !== "undefined" &&
    (MODELS.find(m => m.productHandle === handle && m.videos && m.videos.length) ||
     MODELS.find(m => m.productHandle === condBase && m.videos && m.videos.length));
  const photoBox = document.getElementById("productPhoto");
  const photoImg = photoBox && photoBox.querySelector("img");
  const thumbsBox = document.getElementById("productThumbs");
  if (photoBox && photoImg && thumbsBox) {
    // TEMP: photographer test — swap the gallery for theme-asset crops
    const testGal = typeof TEST_GALLERY !== "undefined" && TEST_GALLERY[handle];
    if (testGal) {
      thumbsBox.innerHTML = testGal.map((src, n) => `
        <button type="button" class="product-thumb${n === 0 ? " active" : ""}" data-src="${src}" aria-label="${AYASA_t("js.core.photo_n", { n: n + 1 })}">
          <img src="${src}" alt="" loading="lazy">
        </button>`).join("");
      photoImg.src = testGal[0];
      photoImg.removeAttribute("srcset");
    }
    // photos only — the performances live in their own strip under the thumbs
    const slides = [...thumbsBox.querySelectorAll(".product-thumb")].map(t => ({ src: t.dataset.src }));
    if (!slides.length) slides.push({ src: photoImg.currentSrc || photoImg.src });
    const thumbEls = [...thumbsBox.querySelectorAll(".product-thumb")];
    const prev = document.getElementById("galPrev");
    const next = document.getElementById("galNext");
    let gi = 0;
    const show = i => {
      gi = (i + slides.length) % slides.length;
      photoImg.src = slides[gi].src;
      photoImg.removeAttribute("srcset");
      thumbEls.forEach((t, n) => t.classList.toggle("active", n === gi));
    };
    if (slides.length > 1) {
      prev.hidden = next.hidden = false;
      prev.addEventListener("click", () => show(gi - 1));
      next.addEventListener("click", () => show(gi + 1));
    }
    thumbEls.forEach((t, n) => t.addEventListener("click", () => show(n)));
    let sx = 0, sy = 0;
    photoBox.addEventListener("touchstart", e => { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    photoBox.addEventListener("touchend", e => {
      const dx = e.changedTouches[0].clientX - sx;
      const dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.5) show(gi + (dx < 0 ? 1 : -1));
    }, { passive: true });
  }

  // "Hear it played" — performance strip from the model data (demoModel
  // resolved above, shared with the gallery's video slide)
  if (demoModel) {
    const strip = document.getElementById("demoStrip");
    strip.innerHTML = demoModel.videos.map((v, i) => {
      const base = v.artist.split(" · ")[0];
      const a = (typeof ARTISTS !== "undefined" && ARTISTS[base]) || {};
      return `
      <article class="demo-card" data-i="${i}" tabindex="0" role="button" aria-label="${AYASA_t("js.core.play_performance_by", { artist: v.artist })}">
        <img ${posterAttrs(v.file)} alt="" loading="lazy">
        <span class="demo-card-play" aria-hidden="true">▶</span>
        <div class="demo-card-info">
          <strong>${base}</strong>
          ${a.credential ? `<span>${a.credential}</span>` : ""}
        </div>
      </article>`;
    }).join("");
    // the compact strip in the gallery column carries only the "The sound"
    // kicker; the summary line survives for any layout that still shows one
    const sub = document.getElementById("productDemosSub");
    if (sub) {
      const artistCount = new Set(demoModel.videos.map(v => v.artist.split(" · ")[0])).size;
      sub.textContent = AYASA_t("js.core.performances_summary", { n: demoModel.videos.length, artists: artistCount });
    }
    document.getElementById("productDemos").hidden = false;
    const open = card => openDemoLightbox(demoModel, +card.dataset.i, buildBuyCtx());
    strip.addEventListener("click", e => {
      const card = e.target.closest(".demo-card");
      if (card) open(card);
    });
    strip.addEventListener("keydown", e => {
      const card = e.target.closest(".demo-card");
      if (card && (e.key === "Enter" || e.key === " ")) { e.preventDefault(); open(card); }
    });

    const demosMore = document.getElementById("demosMore");
    if (demosMore) {
      demosMore.addEventListener("click", () => {
        strip.dataset.open = "1";
        fitDemoRows();
      });
      addEventListener("resize", fitDemoRows, { passive: true });
    }
  }

  // How many rows of clips a page shows before the rest go behind the button.
  // The studio decides the COUNT (1–6, per screen); how many cards fit in one
  // row depends on the window, so the rows themselves are measured — cards
  // sharing an offsetTop are a row — rather than assumed.
  //
  // A phone either scrolls the clips sideways, where there are no rows to
  // count and the cut-off card is its own cue, or shows the same grid with its
  // own row count. Which one is the studio's answer too.
  function fitDemoRows() {
    const strip = document.getElementById("demoStrip");
    const demosMore = document.getElementById("demosMore");
    if (!strip || !demosMore) return;
    const cards = [...strip.querySelectorAll(".demo-card")];
    if (!cards.length) return;

    const cfg = (typeof AYASA_CFG !== "undefined" && AYASA_CFG.demos) || {};
    const wide = matchMedia("(min-width: 901px)").matches;
    const phoneGrid = cfg.mobile === "grid";
    strip.dataset.mobile = phoneGrid ? "grid" : "scroll";
    // How WIDE the phone grid is, which the desktop never needs to be told:
    // there the window decides how many cards fit, here every phone is about
    // the same width, so the count is a choice the studio makes. The CSS holds
    // the fallback for a data file written before this existed.
    if (phoneGrid) {
      strip.style.setProperty("--demo-cols", Math.max(1, Math.min(6, Math.round(
        Number(cfg.mobileCols) || 2))));
    } else {
      strip.style.removeProperty("--demo-cols");
    }

    cards.forEach(c => { c.hidden = false; }); // measure with everything shown

    // a phone left scrolling has no rows, and nothing to reveal
    if (!wide && !phoneGrid) { demosMore.hidden = true; return; }
    if (strip.dataset.open) { demosMore.hidden = true; return; }

    const want = Math.max(1, Math.min(6, Math.round(
      Number(wide ? cfg.desktopRows : cfg.mobileRows) || 1)));
    // the first `want` distinct row positions survive; everything below goes
    const tops = [...new Set(cards.map(c => c.offsetTop))].sort((a, b) => a - b);
    const keep = new Set(tops.slice(0, want));
    let shown = 0;
    cards.forEach(c => {
      const stays = keep.has(c.offsetTop);
      c.hidden = !stays;
      if (stays) shown++;
    });
    const rest = cards.length - shown;
    demosMore.textContent = AYASA_t(rest === 1 ? "js.core.more_videos_one" : "js.core.more_videos_other", { n: rest });
    demosMore.hidden = rest <= 0;
  }

  // buy form: instrument + required case go into the cart together
  const form = document.getElementById("buyForm");
  const caseSelect = document.getElementById("caseSelect");
  const error = document.getElementById("buyError");

  const { openPicker, caseTrigger } = initPlayerPurchaseOptions(document, error);

  // live total: handpan + chosen case, shown just above the buy button.
  // Desktop: appears once a case is picked. Mobile: also during the
  // Order-now step, as "€… + case", so the number is honest before choosing.
  const totalEl = document.getElementById("buyTotal");
  const baseCents = +section.dataset.cents || 0;
  const fmtEur = c => ayasaMoney(c, true);
  let optionsRevealed = false;
  const updateTotal = () => {
    if (!totalEl || !caseSelect) return;
    const opt = caseSelect.selectedOptions[0];
    if (opt && opt.value) {
      totalEl.textContent = AYASA_t("js.core.total", { amount: fmtEur(baseCents + (+opt.dataset.price || 0)) });
      totalEl.hidden = false;
    } else if (optionsRevealed) {
      totalEl.textContent = AYASA_t("js.core.total_plus_case", { amount: fmtEur(baseCents) });
      totalEl.hidden = false;
    } else {
      totalEl.hidden = true;
    }
  };
  if (caseSelect) caseSelect.addEventListener("change", updateTotal);
  updateTotal();

  // Two-step buy: the choices stay folded and the button reads "Order now";
  // the first tap unfolds them in place and the button becomes the real Add to
  // cart, which then validates and submits as always. Everywhere now — this was
  // layout B's behaviour and it won the A/B (2026-08-13).
  const buyOptions = document.getElementById("buyOptions");
  const buyBtn = form?.querySelector(".product-buy");
  const twoStepPossible = buyOptions && buyOptions.querySelector(".product-option") &&
    buyBtn && buyBtn.type === "submit";
  const finalLabel = twoStepPossible ? buyBtn.textContent.trim() : "";
  let twoStepWired = false;
  function applyTwoStep(enable) {
    if (!twoStepPossible || optionsRevealed) return; // already opened: leave it alone
    buyOptions.classList.toggle("collapsible", !!enable);
    if (!enable) buyOptions.classList.remove("open");
    buyBtn.textContent = enable ? AYASA_t("js.core.order_now") : finalLabel;
    updateTotal();
    if (twoStepWired) return;
    twoStepWired = true;
    buyBtn.addEventListener("click", e => {
      // only intercept while the folded step is actually showing
      if (optionsRevealed || !buyOptions.classList.contains("collapsible")) return;
      e.preventDefault();
      optionsRevealed = true;
      buyOptions.classList.add("open");
      buyBtn.textContent = finalLabel;
      updateTotal();
      // once unfolded, park Add to cart at the bottom edge — the case and
      // t-shirt choices frame themselves in the view above it
      let scrolled = false;
      const frame = () => {
        if (scrolled) return;
        scrolled = true;
        buyBtn.closest(".buy-row").scrollIntoView({ block: "end", behavior: "smooth" });
      };
      buyOptions.addEventListener("transitionend", frame, { once: true });
      setTimeout(frame, 450); // fallback if the transition event never lands
    });
  }
  applyTwoStep(true);
  // the lightbox borrows this block; when it hands it back, put the fold back
  // (it strips it while it has it)
  document.addEventListener("ayasa:options-returned", () => applyTwoStep(true));

  // the fold changes the info column's height, and the description is fitted
  // against it — measure once it has settled. Both are idempotent, so the extra
  // passes cost nothing and catch anything still reflowing.
  requestAnimationFrame(fitDemoRows);
  requestAnimationFrame(() => requestAnimationFrame(fitDescription));
  setTimeout(fitDescription, 200);
  setTimeout(fitDescription, 600);

  // product context for the lightbox buy bar (built lazily at click time)
  function buildBuyCtx() {
    return {
      variantId: +form.elements.id.value,
      handle: section.dataset.handle,
      price: section.dataset.price,
      compareAt: section.dataset.compare || "",
      available: section.dataset.available === "true",
      caseSelect,
      // "Free t-shirt size"/"Free t-shirt color" are a contract with Flow: its
      // order intake matches these exact strings to print the packer's slip, so
      // renaming either makes Flow print "No t-shirt" on every order and say
      // nothing. Declining attaches no properties at all — that absence is how
      // Flow reads "declined". Message the orders chat before changing either.
      getProperties: () => {
        const properties = {};
        const size = document.getElementById("shirtSize");
        const color = document.getElementById("shirtColor");
        if (size && size.value && size.value !== "No free t-shirt") {
          properties["Free t-shirt size"] = size.value;
          properties["Free t-shirt color"] = color.value;
        }
        return properties;
      }
    };
  }
  section.__playerBuyContext = buildBuyCtx;
  form.addEventListener("submit", async e => {
    e.preventDefault();
    error.hidden = true;
    const size = document.getElementById("shirtSize");
    const needCase = caseSelect && !caseSelect.value;
    const needShirt = size && !size.value;
    if (needCase || needShirt) {
      showChoicePopup(choiceMessage(needCase, needShirt));
      if (needCase) {
        openPicker(true);
        caseTrigger?.scrollIntoView({ block: "center", behavior: "smooth" });
      } else {
        size.scrollIntoView({ block: "center", behavior: "smooth" });
      }
      return;
    }
    const properties = {};
    const color = document.getElementById("shirtColor");
    if (size && size.value && size.value !== "No free t-shirt") {
      properties["Free t-shirt size"] = size.value;
      properties["Free t-shirt color"] = color.value;
    }
    // the product LAST: the last item of one add lands on top of the basket
    const items = [{ id: +form.elements.id.value, quantity: 1, properties }];
    if (caseSelect) items.unshift({ id: +caseSelect.value, quantity: 1 });
    const btn = form.querySelector(".product-buy");
    btn.disabled = true;
    try {
      // the basket rules (ayasa-cart-rules-2.js): at most 3 of a model, and
      // Shopify's own stock message (which names the stock) never shows
      await window.AyasaCart.add(items, { instruments: [{ handle: section.dataset.handle, quantity: 1 }], pan: true });
      // a case bought on its own, or an instrument joining one already in the
      // basket, still needs settling; the order must never cost the sale
      try { await instrumentsFirst(); } catch (e) { console.error("basket order:", e); }
      window.location.href = "/cart";
    } catch (err) {
      error.textContent = err.message;
      error.hidden = false;
      btn.disabled = false;
    }
  });
}

// ---------- basket order: instruments first (Roy, 24-09) ----------
// Checkout, the order status page and the order itself list lines in the
// basket's own order, and Shopify puts the NEWEST line on top — also within
// one /cart/add.js call, where the last item of the list lands on top. So a
// case added with or after its instrument ended up above it (OW1022). The
// cart page already sorts its display by tag; the real order is what checkout
// uses, so that is what has to change. An instrument is product type
// "Handpan", the same test Flow and the order email use.
//
// Shopify has no reorder call: a line reaches the top only by being added
// again. Taking the instrument out first would risk losing it if the re-add
// failed, so instead the old line is marked (a hidden "_reorder" property, so
// the re-add cannot merge back into it), the instrument is added again with
// its original properties and lands on top, and only then is the marked line
// removed. If the re-add fails the marker comes off and nothing is lost.
// Properties are copied verbatim: they carry the free-t-shirt choice that
// Flow reads by exact name.
const REORDER_MARK = "_reorder";
const isInstrumentLine = i => i.product_type === "Handpan";
const isMarked = i => !!(i.properties && REORDER_MARK in i.properties);
async function cartCall(url, body) {
  const r = await fetch(url, body ? {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body)
  } : undefined);
  if (!r.ok) throw new Error(`${url} ${r.status}`);
  return r.json();
}
// keeps the customer's own order of properties (size before colour) — the
// re-added line shows them exactly as before, at checkout and on the order
function unmarkedProps(props) {
  const out = {};
  Object.keys(props || {}).forEach(k => { if (k !== REORDER_MARK) out[k] = props[k]; });
  return out;
}
const propsKey = props => JSON.stringify(Object.entries(unmarkedProps(props)).sort());
const sameLine = (a, b) => a.variant_id === b.variant_id && propsKey(a.properties) === propsKey(b.properties);

// Puts every instrument line above everything else. Returns true when it
// changed the basket. One GET and nothing more when the order is already right.
async function instrumentsFirst() {
  let cart = await cartCall("/cart.js");
  let changed = false;
  // leftovers from a move that was interrupted (tab closed mid-way): drop a
  // marked line whose clean copy made it in, otherwise just take the mark off
  for (const item of cart.items.filter(isMarked)) {
    const copy = cart.items.find(o => o !== item && !isMarked(o) && sameLine(o, item));
    cart = await cartCall("/cart/change.js", copy
      ? { id: item.key, quantity: 0 }
      : { id: item.key, quantity: item.quantity, properties: unmarkedProps(item.properties) });
    changed = true;
  }
  const firstOther = cart.items.findIndex(i => !isInstrumentLine(i));
  if (firstOther === -1 || !cart.items.slice(firstOther).some(isInstrumentLine)) return changed;

  // move every instrument, the bottom one first, so they keep their order
  for (const item of cart.items.filter(isInstrumentLine).reverse()) {
    const props = unmarkedProps(item.properties);
    const line = { id: item.variant_id, quantity: item.quantity, properties: props };
    if (item.selling_plan_allocation) line.selling_plan = item.selling_plan_allocation.selling_plan.id;
    await cartCall("/cart/change.js", {
      id: item.key, quantity: item.quantity, properties: { ...props, [REORDER_MARK]: "1" }
    });
    const findMarked = async () => (await cartCall("/cart.js")).items.find(i => isMarked(i) && sameLine(i, item));
    try {
      await cartCall("/cart/add.js", { items: [line] });
    } catch (e) {
      const old = await findMarked();
      if (old) await cartCall("/cart/change.js", { id: old.key, quantity: old.quantity, properties: props });
      throw e;
    }
    const old = await findMarked();
    if (old) await cartCall("/cart/change.js", { id: old.key, quantity: 0 });
  }
  return true;
}

// The cart page: a case added from its "needs a case" buttons (a plain form
// post) lands on top, so settle the order here too. The page already shows
// instruments first and a moved instrument keeps its line key, so nothing
// needs re-rendering — but hold the form while it runs, because between the
// re-add and the removal the instrument is briefly in the basket twice.
// ---------- a case only with its handpan (Roy, 29-09) ----------
// One case per pan, and never a case on its own. As the basket page loads,
// cases that lost their pan come out: a removed pan takes its cases with it,
// a lowered pan keeps as many as it still has pans (the newest case goes
// first), and with no pan left no case stays. A case knows its pan line by
// the hidden "_pan_id" (ayasa-cart-rules-2.js); an older unlinked case may
// stay only for a pan that has no case linked. Reads the line data the cart
// section renders (#cartShipData). Returns how many cases it took out.
const CASES_NOTE_KEY = "ayasaCasesSettled";
async function settleCases() {
  const el = document.getElementById("cartShipData");
  if (!el) return false;
  const lines = JSON.parse(el.textContent).lines;
  const cases = lines.filter(l => l.isCase);
  if (!cases.length) return false;
  const room = {};          // pan line id -> its pans still without a case
  let loosePans = 0;        // pans on lines without an id (older baskets)
  for (const p of lines.filter(l => l.instrument)) {
    if (p.panId) room[p.panId] = (room[p.panId] || 0) + p.qty;
    else loosePans += p.qty;
  }
  const keep = {};
  const loose = [];
  // the basket lists the newest line first: walk oldest first, so the case
  // chosen first keeps its place
  for (const c of [...cases].reverse()) {
    if (!c.panId) { loose.push(c); continue; }
    const k = Math.min(c.qty, room[c.panId] || 0);   // 0 when its pan is gone
    if (room[c.panId]) room[c.panId] -= k;
    keep[c.key] = k;
  }
  let spare = loosePans + Object.values(room).reduce((n, r) => n + r, 0);
  for (const c of loose) { const k = Math.min(c.qty, spare); spare -= k; keep[c.key] = k; }
  const updates = {};
  for (const c of cases) if (keep[c.key] !== c.qty) updates[c.key] = keep[c.key];
  if (!Object.keys(updates).length) return false;
  await cartCall("/cart/update.js", { updates });
  return cases.reduce((n, c) => n + c.qty - keep[c.key], 0);   // cases taken out
}

function initCartOrder() {
  const form = document.querySelector(".cart-form");
  // the note after settleCases' reload, so the customer knows why a case went
  // (read before the empty-basket return, so it never shows up on a later visit)
  try {
    const n = +sessionStorage.getItem(CASES_NOTE_KEY);
    if (n) {
      sessionStorage.removeItem(CASES_NOTE_KEY);
      const text = n === 1
        ? AYASA_t("js.core.cases_removed_one")
        : AYASA_t("js.core.cases_removed_other", { n });
      const msg = document.getElementById("cartRuleMsg");
      const empty = document.querySelector(".cart-section .section-sub");   // the empty basket's line
      if (msg) { msg.textContent = text; msg.hidden = false; }
      else if (empty) { const p = document.createElement("p"); p.className = "section-sub"; p.textContent = text; empty.before(p); }
    }
  } catch (e) {}
  if (!form) return;
  let settling = true;
  let held = null;   // { submitter } once a submit arrived while settling
  form.addEventListener("submit", e => {
    if (!settling) return;
    e.preventDefault();
    held = { submitter: e.submitter || null };
  });
  settleCases()
    .catch(err => { console.error("basket cases:", err); return false; })
    .then(changed => {
      if (!changed) return instrumentsFirst();
      try { sessionStorage.setItem(CASES_NOTE_KEY, String(changed)); } catch (e) {}
      location.reload();
      return new Promise(() => {});   // keep the form held until the reload
    })
    .catch(err => console.error("basket order:", err))
    .finally(() => {
      settling = false;
      if (held) held.submitter ? form.requestSubmit(held.submitter) : form.requestSubmit();
    });
}

renderRange();
initRangeFilters(); // straight after: it tags the cards renderRange just drew
renderPlayers();
initArtistPage(); // before initReveal so the injected cards get observed
initScaleNav();   // same — its range cards carry reveal classes too
initStickyRails(); // after every pill row exists — three of the four are injected
initDemoButtons();
initReveal();
// wrapped, unlike its neighbours: every homepage block carries .reveal, which
// is opacity:0 until initReveal runs, so a throw anywhere in this flat list
// blanks the page. The bands are decoration - they must never do that.
try { initHomeBands(); } catch (e) { console.error("home bands:", e); }
initNav();
initHeroMotion();
initProductPage();
initCartOrder();
initHoverPreviews();
refreshWatchedDots();
restoreMiniPlayer();
initShortlist();  // after every render pass — hearts sync to localStorage state
initScrollSpotlight(); // after every render pass — all cards exist by now

// cache-bump 2026-08-27

// ---------- condition dropdown (product page) ----------
// The menu rows are plain links to the sibling products, so "swapping" the
// condition is a normal navigation; this only opens and closes the menu.
(function () {
  const trigger = document.getElementById("condTrigger");
  const menu = document.getElementById("condMenu");
  if (!trigger || !menu) return;
  const close = () => { menu.hidden = true; trigger.setAttribute("aria-expanded", "false"); };
  trigger.addEventListener("click", (e) => {
    e.stopPropagation();
    const open = menu.hidden;
    menu.hidden = !open;
    trigger.setAttribute("aria-expanded", String(open));
  });
  document.addEventListener("click", (e) => { if (!menu.hidden && !menu.contains(e.target)) close(); });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") close(); });
})();

// ---------- sold-out condition: bounce to one that can be bought ----------
// The Liquid renders #condRedirect only when THIS product is unavailable and a
// sibling condition is live and buyable; random when there are several.
(function () {
  const el = document.getElementById("condRedirect");
  if (!el) return;
  const urls = (el.dataset.urls || "").split(",").filter(Boolean);
  if (!urls.length) return;
  location.replace(urls[Math.floor(Math.random() * urls.length)]);
})();

// ---------- fullscreen photo viewer (mockup approved 28-08) ----------
// Opens from the product gallery: whole photo + magnifier button. Photos at
// 2048px for deep zoom, angle tags from the image alt text (top / bottom /
// side-left ...) with a theme-side fallback per handle until the alt texts are
// filled in the admin. The 3D chip hands the current angle to the full player.
(function () {
  const section = document.querySelector(".product-section[data-handle]");
  const photoBox = document.getElementById("productPhoto");
  if (!section || !photoBox) return;
  const handle = section.dataset.handle;
  const condBase = handle.replace(/-(scratched|spotted)$/, "");

  // positional fallback until the admin's alt texts carry the angle words
  const ANGLE_FALLBACK = {
    "e-amara-20-ember-steel": ["top", "bottom", "side", "side"]
  };
  const ANGLE_LABEL = { top: AYASA_t("js.core.angle_top"), bottom: AYASA_t("js.core.angle_bottom"), side: AYASA_t("js.core.angle_side"), "side-left": AYASA_t("js.core.angle_side_left"), "side-right": AYASA_t("js.core.angle_side_right") };
  const angleOf = (alt, i) => {
    const m = /\b(top|bottom|side(?:[- ](?:left|right))?)\b/i.exec(alt || "");
    if (m) return m[1].toLowerCase().replace(" ", "-");
    const fb = ANGLE_FALLBACK[handle] || ANGLE_FALLBACK[condBase];
    return (fb && fb[i]) || null;
  };

  const slides = () => [...document.querySelectorAll("#productThumbs .product-thumb")].map((t, i) => ({
    src: t.dataset.full || t.dataset.src,
    thumb: t.querySelector("img")?.src || t.dataset.src,
    angle: angleOf(t.dataset.alt, i)
  }));

  let box = null, idx = 0, zoomed = false;

  const pageHeart = document.querySelector(".shortlist-btn[data-handle], .shortlist-heart[data-handle]");

  function build() {
    box = document.createElement("div");
    box.className = "pviewer";
    box.innerHTML = `
      <div class="pv-top">
        <span class="pv-angle" id="pvAngle"></span>
        <span class="pv-actions">
          ${pageHeart ? `<button type="button" class="shortlist-heart pv-heart" data-handle="${pageHeart.dataset.handle}" data-name="${pageHeart.dataset.name || ""}" aria-pressed="${pageHeart.getAttribute("aria-pressed") || "false"}" aria-label="${AYASA_t("js.core.add_to_wishlist")}">${HEART_SVG}</button>` : ""}
          <button type="button" class="pv-x" aria-label="${AYASA_t("js.core.close")}">✕</button>
        </span>
      </div>
      <div class="pv-stage">
        <button type="button" class="pv-nav pv-prev" aria-label="${AYASA_t("js.core.previous_photo")}">‹</button>
        <div class="pv-imgwrap"><img class="pv-img" alt=""></div>
        <button type="button" class="pv-nav pv-next" aria-label="${AYASA_t("js.core.next_photo")}">›</button>
      </div>
      <p class="pv-hint"></p>
      <div class="pv-thumbs"></div>`;
    document.body.appendChild(box);

    box.querySelector(".pv-x").addEventListener("click", close);
    box.addEventListener("click", e => {
      // the dark ground closes; anything interactive doesn't bubble this far
      if (e.target === box || e.target.classList.contains("pv-stage") || e.target.classList.contains("pv-imgwrap")) close();
    });
    box.querySelector(".pv-prev").addEventListener("click", () => show(idx - 1));
    box.querySelector(".pv-next").addEventListener("click", () => show(idx + 1));

    // click to zoom into the clicked spot; click again to zoom out
    const img = box.querySelector(".pv-img");
    img.addEventListener("click", e => {
      zoomed = !zoomed;
      if (zoomed) {
        const r = img.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width) * 100 + "% " + ((e.clientY - r.top) / r.height) * 100 + "%";
      }
      img.classList.toggle("zoomed", zoomed);
      hint();
    });
    // while zoomed, moving the pointer pans - the origin follows the cursor
    img.addEventListener("pointermove", e => {
      if (!zoomed) return;
      const r = box.querySelector(".pv-imgwrap").getBoundingClientRect();
      img.style.transformOrigin = ((e.clientX - r.left) / r.width) * 100 + "% " + ((e.clientY - r.top) / r.height) * 100 + "%";
    });

    // touch: horizontal swipe navigates, a downward swipe lets go of the viewer
    let tx = 0, ty = 0;
    box.addEventListener("touchstart", e => { tx = e.touches[0].clientX; ty = e.touches[0].clientY; }, { passive: true });
    box.addEventListener("touchend", e => {
      if (zoomed) return;
      const dx = e.changedTouches[0].clientX - tx, dy = e.changedTouches[0].clientY - ty;
      if (dy > 80 && Math.abs(dx) < 60) return close();
      if (Math.abs(dx) > 50 && Math.abs(dy) < 50) show(idx + (dx < 0 ? 1 : -1));
    }, { passive: true });
  }

  function thumbsRow(list) {
    const row = box.querySelector(".pv-thumbs");
    row.innerHTML = list.map((s, i) => `
      <button type="button" class="pv-thumb${i === idx ? " on" : ""}" data-i="${i}" aria-label="${AYASA_t("js.core.photo_n", { n: i + 1 })}">
        <img src="${s.thumb}" alt="" loading="lazy">
        ${s.angle ? `<span class="pv-ttag">${(ANGLE_LABEL[s.angle] || s.angle).split(" · ")[0]}</span>` : ""}
      </button>`).join("")
      + (window.AYASA_OPEN_FULL_PLAYER ? `
      <button type="button" class="pv-thumb pv-3d" aria-label="${AYASA_t("js.core.open_3d_player")}"><span>3D</span></button>` : "");
    row.querySelectorAll(".pv-thumb[data-i]").forEach(t => t.addEventListener("click", () => show(+t.dataset.i)));
    const chip = row.querySelector(".pv-3d");
    if (chip) chip.addEventListener("click", () => {
      // the full player opens on top; closing it lands back on the photos
      window.AYASA_OPEN_FULL_PLAYER(slides()[idx] && slides()[idx].angle || null);
    });
  }

  function hint() {
    box.querySelector(".pv-hint").textContent = zoomed
      ? AYASA_t("js.core.zoom_hint_zoomed")
      : AYASA_t("js.core.zoom_hint");
  }

  function show(i) {
    const list = slides();
    if (!list.length) return;
    idx = (i + list.length) % list.length;
    zoomed = false;
    const img = box.querySelector(".pv-img");
    img.classList.remove("zoomed");
    img.src = list[idx].src;
    const tag = box.querySelector("#pvAngle");
    tag.textContent = list[idx].angle ? ANGLE_LABEL[list[idx].angle] || list[idx].angle : "";
    tag.hidden = !list[idx].angle;
    thumbsRow(list);
    hint();
  }

  const onKey = e => {
    if (e.key === "Escape") close();
    else if (e.key === "ArrowRight") show(idx + 1);
    else if (e.key === "ArrowLeft") show(idx - 1);
  };

  function open(startAt) {
    if (!box) build();
    // mirror the page heart's current state each time the viewer opens
    const h = box.querySelector(".pv-heart");
    if (h && pageHeart) {
      h.setAttribute("aria-pressed", pageHeart.getAttribute("aria-pressed") || "false");
      h.classList.toggle("on", pageHeart.classList.contains("on"));
    }
    box.classList.add("open");
    document.body.style.overflow = "hidden";
    addEventListener("keydown", onKey);
    show(startAt);
  }
  function close() {
    box.classList.remove("open");
    document.body.style.overflow = "";
    removeEventListener("keydown", onKey);
  }

  // ways in: the magnifier, and the photo itself (arrows keep their own clicks)
  const currentIndex = () => {
    const act = document.querySelector("#productThumbs .product-thumb.active");
    const all = [...document.querySelectorAll("#productThumbs .product-thumb")];
    return Math.max(0, all.indexOf(act));
  };
  const zoomBtn = document.getElementById("galZoom");
  if (zoomBtn) zoomBtn.addEventListener("click", () => open(currentIndex()));
  const mainImg = photoBox.querySelector("img");
  if (mainImg) {
    mainImg.addEventListener("click", () => open(currentIndex()));
    mainImg.style.cursor = "zoom-in";
  }
})();

// ---------- the artist count states itself (Roy 16-09) ----------
// The stats bar and the artists intro used to carry a typed number that
// drifted from the data (45 vs 48). PLAYERS is the source of truth — the
// same list the "+N more" card already counts from.
(function () {
  if (typeof PLAYERS === "undefined" || !PLAYERS.length) return;
  var n = String(PLAYERS.length);
  // The stats bar reads "48+" — the count is a floor, not a ceiling (Roy, 23-09).
  // Match on "artists" alone rather than the old "named artists": the label was
  // reworded to "Professional Artists play Ayasa", and the tighter regex would have
  // stopped counting silently, leaving whatever number happens to be typed in the
  // theme editor. No other stats label contains the word.
  document.querySelectorAll("#stats .stat").forEach(function (s) {
    var label = s.querySelector("span"), value = s.querySelector("strong");
    if (label && value && /artists/i.test(label.textContent)) value.textContent = n + "+";
  });
  document.querySelectorAll(".carousel-head strong").forEach(function (el) {
    if (/named artists/i.test(el.textContent)) el.textContent = el.textContent.replace(/\d+/, n);
  });
})();
